(function () {
"use strict";
var FIGURES = window.PmoMatchFigures || {};
var rootEl = document.querySelector("[data-sy]");
if (!rootEl) return;
var CFG = {};
try { CFG = JSON.parse(rootEl.querySelector("[data-sy-cfg]").textContent); } catch (e) {}
var ORDERS = [];
try { var oe = rootEl.querySelector("[data-sy-orders]"); if (oe) ORDERS = JSON.parse(oe.textContent) || []; } catch (e) {}
var SITE = String(CFG.site || "").replace(/\/+$/, "");
var CONSULT_URL = abs(CFG.consultUrl || "/pages/fit-consultation");
var GUIDE_URL = abs(CFG.guideUrl || "/pages/how-to-take-measurements-for-motorcycle-gear");
function abs(u) { return /^https?:/i.test(u) ? u : SITE + (u.charAt(0) === "/" ? u : "/" + u); }
function $(sel) { return rootEl.querySelector(sel); }
function $$(sel) { return Array.prototype.slice.call(rootEl.querySelectorAll(sel)); }
function esc(s) {
return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
});
}
function uniq(a) { var seen = {}; return a.filter(function (x) { if (seen[x]) return false; seen[x] = 1; return true; }); }
function listJoin(a) { return a.length > 1 ? a.slice(0, -1).join(", ") + " and " + a[a.length - 1] : a[0] || ""; }
var NF = null;
function money(cents) {
var d = cents / 100;
if (!NF) NF = [new Intl.NumberFormat("en-AU", { minimumFractionDigits: 0, maximumFractionDigits: 2 }), new Intl.NumberFormat("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })];
return "$" + NF[d % 1 ? 1 : 0].format(d);
}
function norm(s) { return String(s == null ? "" : s).trim().toLowerCase(); }
var CATS = [
{ k: "helmets", n: "Helmets", need: ["head"] },
{ k: "jackets", n: "Jackets", need: ["chest"], opt: ["waist"] },
{ k: "base", n: "Base layers", need: ["chest"], opt: ["waist"] },
{ k: "pants", n: "Pants", need: ["waist"], opt: ["hips", "inseam"] },
{ k: "boots", n: "Boots", need: ["foot"] },
{ k: "gloves", n: "Gloves", need: ["palm", "hand length"], any: true },
{ k: "acc", n: "Accessories", need: [], acc: true },
{ k: "extras", n: "Extras", need: [], acc: true }
];
var OWN_WORD = { jackets: "a jacket", base: "a base layer", pants: "pants", gloves: "gloves", boots: "boots", helmets: "a helmet", acc: "gear", extras: "gear" };
var MEAS = { chest: "Chest", waist: "Waist", hips: "Hips", inseam: "Inseam", palm: "Palm circumference", "hand length": "Hand length", foot: "Foot length", head: "Head" };
var SHORT = { chest: "chest", waist: "waist", hips: "hips", inseam: "inseam", palm: "palm", "hand length": "hand length", foot: "foot", head: "head" };
var FIG_FOR = { jackets: "body", base: "body", pants: "body", gloves: "hand", boots: "foot", helmets: "head", acc: "body", extras: "body" };
var TIPS = {
chest: ["chest", "Measure around the widest part of your chest, keeping the tape level around your back. Some brands ask for your arms down by your side."],
waist: ["waist", "Measure around your waist at the point where you bend side to side."],
hips: ["hips", "Stand with your feet together and measure around the widest part of your bum."],
inseam: ["inseam", "Measure from your groin down to your ankle bone, following along the inside of your leg."],
head: ["head", "Measure around your forehead and behind the bony bump at the back of your head (the occipital bone)."],
palm: ["palm", "With your hand softly closed, measure around your knuckles and across your palm."],
"hand length": ["hand length", "Measure from where the palm joins the forearm to the tip of the middle finger."],
foot: ["foot length", "Stand with your heel against a wall and measure from the wall to the tip of your longest toe. Use your longer foot."]
};
var TIP_GENERAL = "Measure over light clothing, roughly what you'd wear under your gear. Stand relaxed, breathe out normally and keep the tape snug but not tight.";
function catDef(k) { return CATS.filter(function (c) { return c.k === k; })[0]; }
function axesFor(c) { return (c.need || []).concat(c.opt || []); }
function catOf(type, title) {
var t = (type || "") + " " + (title || "");
if (/visor|cleaning|care\b/i.test(type)) return "other";
if (/helmet/i.test(t)) return "helmets";
if (/sock/i.test(type)) return "other";
if (/boot|shoe/i.test(t)) return "boots";
if (/under-?gloves?|glove liners?|inner gloves?|liner gloves?/i.test(t)) return "other";
if (/glove/i.test(t)) return "gloves";
if (/suit/i.test(type)) return "suits";
if (/pants|jean|trouser|legging|chaps/i.test(t)) return "pants";
if (/thermal|base ?layer/i.test(t)) return "base";
if (/jacket|shirt|hoodie|windbreaker|vest|rain|jersey|heated/i.test(t)) return "jackets";
return "other";
}
var ARMOURED_CATS = { jackets: 1, base: 1, pants: 1 };
function hasArmour(ip) {
return (ip || []).some(function (s) { return /CE Level \d\s+(Shoulder|Elbow|Hip|Knee)/i.test(s); });
}
function protectionOf(list) {
var out = null;
(list || []).forEach(function (s) {
var m;
if (out) return;
if ((m = String(s).match(/CE (AAA|AA|A) Rated/i))) out = "CE " + m[1].toUpperCase();
else if (/\bB Rated/i.test(s)) out = "CE B";
else if (/\bC Rated/i.test(s)) out = "CE C";
else if ((m = String(s).match(/Gloves CE Certified.*Level (\d)( KP)?/i))) out = "CE Level " + m[1] + (m[2] ? " KP" : "");
else if (/Footwear CE Certified/i.test(s)) out = "CE certified";
else if (/ECE R?\s?22\.06/i.test(s)) out = "ECE 22.06" + (/\bFIM\b/i.test(s) ? " + FIM" : "");
else if (/ECE R?\s?22\.05/i.test(s)) out = "ECE 22.05";
else if (/AS\/NZS\s?1698/i.test(s)) out = "AS/NZS 1698";
});
if (!out) (list || []).forEach(function (s) {
var m = String(s).match(/CE Level (\d) (Back|Shoulder|Elbow|Chest|Hip|Knee)/i);
if (m && (!out || m[1] > out.slice(-1))) out = "CE Level " + m[1];
});
return out;
}
function hasOwnRating(list) {
return (list || []).some(function (s) { return /CE (AAA|AA|A|B|C) Rated|\b[BC] Rated|Gloves CE Certified|Footwear CE Certified/i.test(String(s)); });
}
var NOCE_CATS = { jackets: 1, pants: 1, suits: 1, base: 1, gloves: 1 };
var ARMOUR_ORDER = ["Shoulder", "Elbow", "Back", "Chest", "Hip", "Knee"];
var ARMOUR_MARK = {
Shoulder: '<circle cx="6.6" cy="9.6" r="2.1"/><circle cx="13.4" cy="9.6" r="2.1"/>',
Elbow: '<circle cx="4.4" cy="14.6" r="2"/><circle cx="15.6" cy="14.6" r="2"/>',
Chest: '<rect x="7.2" y="9.4" width="5.6" height="3.8" rx="1.4"/>',
Back: '<rect x="8.6" y="8.6" width="2.8" height="9.6" rx="1.2"/>',
Hip: '<circle cx="6.9" cy="18.6" r="2"/><circle cx="13.1" cy="18.6" r="2"/>',
Knee: '<circle cx="7.6" cy="24.6" r="2"/><circle cx="12.4" cy="24.6" r="2"/>'
};
function armourIcon(k) {
return '<svg class="sy-aico" viewBox="0 0 20 32" aria-hidden="true"><g fill="none" stroke="#8795a6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">' +
'<circle cx="10" cy="4" r="2.6"/><path d="M6.6 8.2h6.8a1.6 1.6 0 0 1 1.6 1.6v7.4a1.6 1.6 0 0 1-1.6 1.6H6.6A1.6 1.6 0 0 1 5 17.2V9.8a1.6 1.6 0 0 1 1.6-1.6z"/>' +
'<path d="M5.4 9.4 3.4 17.6M14.6 9.4l2 8.2M8.2 18.8l-.7 11M11.8 18.8l.7 11"/></g><g fill="#d2815f">' + ARMOUR_MARK[k] + "</g></svg>";
}
var ARMOUR_SPOTS = { jackets: ["Shoulder", "Elbow", "Back", "Chest"], pants: ["Hip", "Knee"], suits: ["Shoulder", "Elbow", "Back", "Chest", "Hip", "Knee"] };
function armourList(ip, cat, bp, cp) {
var found = {}, pocket = {};
if (bp) pocket.Back = 1;
if (cp) pocket.Chest = 1;
(ip || []).forEach(function (x) {
var m = /CE Level (\d) (Back|Shoulder|Elbow|Chest|Hip|Knee)/i.exec(x);
if (m) { var k = m[2].charAt(0).toUpperCase() + m[2].slice(1).toLowerCase(); found[k] = m[1]; }
var p = /(Back|Shoulder|Elbow|Chest|Hip|Knee)\b.*\bpocket/i.exec(x);
if (p) pocket[p[1].charAt(0).toUpperCase() + p[1].slice(1).toLowerCase()] = 1;
});
var spots = ARMOUR_SPOTS[cat] || ARMOUR_ORDER.filter(function (k) { return found[k] || pocket[k]; });
if (cat === "base") {
var lower = (ip || []).some(function (x) { return /Hip|Knee/i.test(x); }), upper = (ip || []).some(function (x) { return /Back|Shoulder|Elbow|Chest/i.test(x); });
spots = (upper || !lower ? ARMOUR_SPOTS.jackets : []).concat(lower ? ARMOUR_SPOTS.pants : []);
}
var keys = ARMOUR_ORDER.filter(function (k) { return found[k] || spots.indexOf(k) > -1; });
if (!keys.length) return '<span class="sy-none">None listed</span>';
return '<ul class="sy-armour">' + keys.map(function (k) {
if (found[k]) return "<li>" + armourIcon(k) + '<span class="sy-an">' + k + '</span><span class="sy-alv">Level ' + found[k] + "</span></li>";
return '<li class="is-off">' + armourIcon(k) + '<span class="sy-an">' + k + (pocket[k] ? '<small>Can take ' + (k === "Back" || k === "Chest" ? "a " + k.toLowerCase() + " protector" : "armour here") + ", sold separately</small>" : "") + '</span><span class="sy-alv" title="Not included">Not incl.</span></li>';
}).join("") + "</ul>";
}
var GLOVE_SPOTS = ["Knuckles", "Fingers", "Palm", "Scaphoid", "Wrist"];
var GLOVE_NOTE = { Knuckles: "Hard or padded knuckle armour", Fingers: "Armour over the fingers", Palm: "Palm slider or padding",
Scaphoid: "Protects the wrist bone that breaks most in a fall", Wrist: "Armour or padding at the wrist" };
var GLOVE_RX = { Knuckles: /knuckle|\bKP\b/i, Fingers: /finger/i, Palm: /palm/i, Scaphoid: /scaphoid/i, Wrist: /wrist/i };
function gloveSpots(it) {
var src = [].concat(it.ga || []).concat(it.ip || []).concat(it.prot ? [it.prot] : []);
return GLOVE_SPOTS.filter(function (k) { return src.some(function (x) { return GLOVE_RX[k].test(String(x)); }); });
}
function gloveArmour(it) {
if (it.ga == null) {
return hasKnuckles(it) ? '<ul class="sy-armour sy-garm"><li><span class="sy-an">Knuckles</span><span class="sy-alv">Included</span></li></ul><small class="sy-none">Other spots not recorded yet</small>' :
'<span class="sy-none">Not recorded</span>';
}
var on = gloveSpots(it);
return '<ul class="sy-armour sy-garm">' + GLOVE_SPOTS.map(function (k) {
var has = on.indexOf(k) > -1;
return "<li" + (has ? "" : ' class="is-off"') + ' title="' + esc(GLOVE_NOTE[k]) + '"><span class="sy-an">' + k + '</span><span class="sy-alv">' + (has ? "Included" : "Not incl.") + "</span></li>";
}).join("") + "</ul>";
}
function armourText(ip) {
var out = [];
(ip || []).forEach(function (x) { var m = /CE Level (\d) (Back|Shoulder|Elbow|Chest|Hip|Knee)/i.exec(x); if (m) out.push(m[2] + " (Level " + m[1] + ")"); });
return out.length ? out.join(", ") : "None listed";
}
var F = null;
var profile = null;
var BANDS = ["Cold", "Cool", "Mild", "Warm", "Hot"];
var EDGE = [8, 15, 22, 30];
function bandOf(d) { for (var i = 0; i < EDGE.length; i++) if (d < EDGE[i]) return i; return 4; }
var BIKES = [["adv", "Adventure"], ["tour", "Tourer"], ["naked", "Naked"], ["sport", "Sport"], ["cruiser", "Cruiser"], ["retro", "Retro"], ["scooter", "Scooter"], ["dirt", "Dirt"]];
var BIKE_STYLE = {
adv: ["Adventure & Off-Road", "Touring"], tour: ["Touring", "Urban & Commuting"], naked: ["Urban & Commuting", "Sport & Track"],
sport: ["Sport & Track"], cruiser: ["Cruiser", "Heritage"], retro: ["Heritage", "Urban & Commuting"],
scooter: ["Urban & Commuting"], dirt: ["Adventure & Off-Road"]
};
function bikeNames() { return BIKES.filter(function (b) { return S.bikes.indexOf(b[0]) > -1; }).map(function (b) { return b[1]; }); }
function bikeOk(it) {
if (!S.bikes.length || !it.rs) return true;
return S.bikes.some(function (k) { return (BIKE_STYLE[k] || []).some(function (r) { return it.rs.indexOf(r) > -1; }); });
}
var HEIGHTS = ["Ankle", "Shin", "Calf"];
function heightOk(it) { return it.cat !== "boots" || !S.heights.length || !it.bh || S.heights.indexOf(it.bh) > -1; }
function orJoin(a) { return a.length > 1 ? a.slice(0, -1).join(", ") + " or " + a[a.length - 1] : a[0] || ""; }
var S = {
cat: "jackets", unit: "cm", gender: "", bikes: [], heights: [], kitColour: "", budget: null, prefill: "", colPick: {}, cwOpen: {}, fitIdx: {}, colSel: {}, sizeSel: {}, swOpen: {}, accSub: {}, gSpots: [], wet: false, showSold: false, fitOnly: true,
tempOn: false, tlo: 10, thi: 28, minProt: {}, auProt: {}, kit: [], cartMsg: null, cmp: {}, hideSame: false,
refFrom: {}, ref: null, email: "", emailDraft: "", mkt: false,
ownMode: "orders", ownQ: "", ownPick: null, welcome: false, wait: {},
step: 1, sel: [], acc: {}, ownOpen: false, q: ""
};
function body() { return profile.meas; }
function saveRider() {
profile.temp = { on: S.tempOn, lo: S.tlo, hi: S.thi };
profile.gen = S.gender ? [S.gender] : [];
F.saveProfile(profile);
}
function haveFor(c) {
return axesFor(c).every(function (a) { return F.measValue(body()[a]) != null; });
}
function bodyFor(c) {
var b = {};
if (c && c.acc) { Object.keys(MEAS).forEach(function (a) { var v = F.measValue(body()[a]); if (v != null) b[a] = v; }); return b; }
axesFor(c).forEach(function (a) { var v = F.measValue(body()[a]); if (v != null) b[a] = v; });
return b;
}
function toCm(v) { return S.unit === "in" ? v * 2.54 : v; }
function fromCm(v) { return S.unit === "in" ? v / 2.54 : v; }
function show(cm) { return S.unit === "in" ? Math.round(cm / 2.54 * 10) / 10 + "in" : Math.round(cm * 10) / 10 + "cm"; }
function showRange(lo, hi) {
if (lo <= 0) return "up to " + show(hi);
if (lo === hi) return show(hi);
return S.unit === "in"
? Math.round(lo / 2.54 * 10) / 10 + "–" + Math.round(hi / 2.54 * 10) / 10 + "in"
: Math.round(lo * 10) / 10 + "–" + Math.round(hi * 10) / 10 + "cm";
}
var ITEMS = null;      // what can be recommended
var ALL = null;        // everything with a size chart, for "gear you own"
var FIT = {};
var EXTRA = {};        // per-handle extras from the gear-studio view
var PAGES_KEY = "pmo.sys.pages";
function getPages(view, extra) {
var base = String(CFG.source || "/collections/all").replace(/\?.*$/, "");
var pre = window.__gsPre || {};
var get = function (n) {
var u = base + "?view=" + view + (extra || "") + "&page=" + n;
if (pre[u]) { var p = pre[u]; delete pre[u]; return p.catch(function () { return fetch(u, { credentials: "same-origin" }).then(function (r) { return r.json(); }); }); }
return fetch(u, { credentials: "same-origin" }).then(function (r) { return r.json(); });
};
var guess = 3; try { guess = +localStorage.getItem(PAGES_KEY) || 3; } catch (x) {}
guess = Math.max(1, Math.min(guess, 20));
var first = [];
for (var i = 1; i <= guess; i++) first.push(get(i));
return Promise.all(first).then(function (got) {
var total = Math.min(got[0].pages || 1, 20), more = [];
if (view === "pmo-data") { try { localStorage.setItem(PAGES_KEY, String(total)); } catch (x) {} }
for (var j = guess + 1; j <= total; j++) more.push(get(j));
return Promise.all(more).then(function (m) { return got.slice(0, total).concat(m); });
});
}
function prep(raw) {
var o = (raw.o || []).map(String);
var cat = catOf(raw.ty, raw.t);
var suit = cat === "suits" || /one[- ]?piece/i.test(raw.t || "");
if (cat === "suits") cat = "jackets";
var ag = accGroup(raw.ty, raw.t);
if (ag && (cat === "other" || (ARMOURED_CATS[cat] && !hasArmour(raw.ip)))) cat = "acc";
var eg = cat === "other" ? extrasGroup(raw.ty, raw.t) : null;
if (eg) cat = "extras";
var sizeIdx = -1, lenIdx = -1, colIdx = -1;
o.forEach(function (n, i) {
if (/colou?r/i.test(n)) colIdx = i;
else if (/length|leg|inseam/i.test(n)) lenIdx = i;
else if (/size/i.test(n) && sizeIdx < 0) sizeIdx = i;
});
if (sizeIdx < 0 && o.length === 1 && colIdx < 0 && lenIdx < 0 && !/^title$/i.test(o[0])) sizeIdx = 0;
var ctx = cat;
if (sizeIdx > -1 && /shoe|boot/i.test(o[sizeIdx])) ctx = "boots";
if (sizeIdx > -1 && /pant|waist/i.test(o[sizeIdx])) ctx = "pants";
var vars = (raw.vs || []).map(function (v) { return { o: [v[0], v[1], v[2]], a: !!v[3], id: String(v[4]) }; });
return {
id: raw.id, h: raw.h, t: String(raw.t || "").replace(/\s*[-\u2013\u2014|]\s*final sale\b/ig, "").trim(), fsale: /final sale/i.test(raw.t || ""), u: raw.u, v: raw.v || "", ty: raw.ty, img: raw.img, p: raw.p, pm: raw.pm, cp: raw.cp, av: raw.av,
cat: cat, ctx: ctx, suit: suit, sizeIdx: sizeIdx, lenIdx: lenIdx, colIdx: colIdx, vars: vars,
gen: (raw.g || []).filter(function (g) { return g === "Women" || g === "Men" || g === "Unisex"; }),
tp: raw.tp && raw.tp.length ? raw.tp : null, rs: raw.rs && raw.rs.length ? raw.rs : null,
wp: raw.wp === true ? true : raw.wp === false ? false : null,
ip: raw.ip || [], prot: protectionOf(raw.ip),
noCE: !!raw.au && !!NOCE_CATS[cat] && !hasOwnRating(raw.ip) && (raw.ip || []).some(function (s) { return /CE Level|Australian brand|Armou?r/i.test(String(s)); }),
rv: +raw.rv || 0, rc: +raw.rc || 0, est: !!raw.est,
bh: (EXTRA[raw.h] && EXTRA[raw.h].bh) || null,
ga: (EXTRA[raw.h] && EXTRA[raw.h].ga) || null,
vi: (EXTRA[raw.h] && EXTRA[raw.h].vi) || null,
gl: (EXTRA[raw.h] && EXTRA[raw.h].gl) || null,
su: (EXTRA[raw.h] && EXTRA[raw.h].su) || null,
bp: !!(EXTRA[raw.h] && EXTRA[raw.h].bp),
cp: !!(EXTRA[raw.h] && EXTRA[raw.h].cp),
bs: (EXTRA[raw.h] && +EXTRA[raw.h].bs) || 0,
charts: FIT[raw.h] || null, ag: cat === "acc" ? ag : cat === "extras" ? eg : null
};
}
var ACC_GROUPS = [["rain", "Rain gear"], ["mid", "Midlayers"], ["thermal", "Thermals"], ["neck", "Neck gaiters"], ["casual", "Casual gear"]];
function groupList(k) {
var g = (k === "acc" ? ACC_GROUPS : EXTRA_GROUPS).map(function (x) { return x[1]; });
return g.map(function (n, i) { return i ? n.charAt(0).toLowerCase() + n.slice(1) : n; }).join(", ").replace(/, ([^,]*)$/, " and $1") + ".";
}
var EXTRA_GROUPS = [["armour", "Armour inserts"], ["luggage", "Bags & luggage"], ["security", "Locks & covers"], ["phone", "Phone mounts"], ["care", "Care & cleaning"], ["visors", "Visors"]];
var SUB_GROUPS = { acc: ACC_GROUPS, extras: EXTRA_GROUPS };
function extrasGroup(ty, t) {
var x = ty || "";
if (/bags? & luggage|luggage|straps?$/i.test(x)) return "luggage";
if (/alarm|lock|motorcycle cover/i.test(x)) return "security";
if (/phone mount/i.test(x)) return "phone";
if (/cleaning|care|chain maintenance|bike maintenance|battery charger/i.test(x)) return "care";
if (/visor/i.test(x)) return "visors";
if (/back protector|chest protector/i.test(x)) return "armour";
return null;
}
function accGroup(ty, t) {
var x = (ty || "") + " " + (t || "");
if (/rainwear|high visibility|\brain\b|hi-?vis/i.test(x)) return "rain";
if (/neckwear|neck ?(tube|warmer|gaiter)|gaiter|windcollar|\bbuff\b|snood/i.test(x)) return "neck";
if (/thermal|base ?layer|balaclava|sock|under-?glove|glove liner|heated/i.test(x)) return "thermal";
if (/windbreaker|mid ?layer|fleece|softshell|gilet|\bvests?\b|insulat/i.test(x)) return "mid";
if (/t-?shirt|\btee\b|hoodie|sweat|hat\b|cap\b|beanie|jersey|shirt/i.test(ty || "") || /t-?shirt|\btee\b|beanie|\bcap\b/i.test(t || "")) return "casual";
return null;
}
function loadData() {
var extra = getPages("gear-studio", "&sort_by=best-selling").catch(function () { return []; });
var sw = CFG.swatches ? fetch(CFG.swatches).then(function (r) { return r.json(); }).then(function (d) {
(d.colors || []).forEach(function (o) { Object.keys(o).forEach(function (k) { SWATCH[normC(k)] = o[k]; }); });
}).catch(function () {}) : null;
return Promise.all([getPages("pmo-data"), getPages("pmo-fit"), extra, sw]).then(function (res) {
res[2].forEach(function (pg) { Object.keys(pg.items || {}).forEach(function (h) { EXTRA[h] = pg.items[h]; }); });
res[1].forEach(function (pg) { Object.keys(pg.items || {}).forEach(function (h) { FIT[h] = pg.items[h]; }); });
var all = [];
res[0].forEach(function (pg) { (pg.items || []).forEach(function (raw) { all.push(prep(raw)); }); });
ALL = all.filter(function (it) { var c = catDef(it.cat); return c && (it.charts || c.acc); }); IDX = null;
ITEMS = ALL.filter(function (it) { return !ARMOURED_CATS[it.cat] || hasArmour(it.ip); });
CATS = CATS.filter(function (c) { return ITEMS.some(function (it) { return it.cat === c.k; }); });
if (!catDef(S.cat) && CATS.length) S.cat = CATS[0].k;
});
}
var IDX = null;
function findItem(h) {
if (!ALL) return undefined;
if (!IDX) { IDX = {}; ALL.forEach(function (x) { IDX[x.h] = x; }); }
return IDX[h];
}
function hasAttrs(c) { return (ITEMS || []).some(function (it) { return it.cat === c.k && (it.tp || it.rs || it.wp != null); }); }
var TO_CM = { cm: 1, "cm-ft": 1, "ft-cm": 1, mm: 0.1, in: 2.54 };
function rowsOf(t) {
if (!t || !t.rows) return [];
if (t.direction !== "row") return t.rows;
var out = [];
t.rows.forEach(function (row, r) { row.forEach(function (c, i) { (out[i] = out[i] || [])[r] = c; }); });
return out;
}
function cellText(c) { return c ? String(c.v != null ? c.v : c.value != null ? c.value : "").trim() : ""; }
function cellBand(c) {
var t = cellText(c), f = TO_CM[c && (c.u || c.unit)] || 1;
var nums = (t.replace(/,/g, ".").match(/\d+(\.\d+)?/g) || []).map(function (n) { return parseFloat(n) * f; });
if (!nums.length) return null;
if (nums.length === 1) return /up to|under|less|</i.test(t) ? [0, nums[0]] : [nums[0], nums[0]];
return [Math.min(nums[0], nums[1]), Math.max(nums[0], nums[1])];
}
function isGarment(label) {
if (/palm|hand|head|foot/i.test(label || "")) return false;
return /\bflat\b|width|armpit|\bof (a )?(jacket|garment|hoodie|tee|shirt|pants|jeans)\b/i.test(label || "");
}
function usedFields(chart, meas) {
var out = [];
((chart.calc && chart.calc.fields) || []).forEach(function (f) {
if (isGarment(f.label)) return;
var k = F.areaKey(f.label);
if (!k || (meas && F.measValue(meas[k]) == null)) return;
out.push({ area: k, col: f.col });
});
return out;
}
function rowIndex(chart, label) {
var rows = rowsOf(chart.table), col = (chart.calc && chart.calc.size) || 0;
var want = String(label).trim();
for (var r = 1; r < rows.length; r++) if (String(cellText(rows[r][col])).trim() === want) return r;
return -1;
}
function bandAt(chart, r, col) {
var rows = rowsOf(chart.table);
var b = cellBand(rows[r] && rows[r][col]);
if (!b) return null;
var prev = r > 1 ? cellBand(rows[r - 1][col]) : null, next = r < rows.length - 1 ? cellBand(rows[r + 1][col]) : null;
if (b[0] === b[1]) {
var lo = prev ? (prev[1] + b[0]) / 2 : null, hi = next ? (b[1] + next[0]) / 2 : null;
var step = hi != null ? hi - b[1] : lo != null ? b[0] - lo : 2;
return { lo: lo != null ? lo : b[0] - step, hi: hi != null ? hi : b[1] + step, point: true, raw: b };
}
if (b[0] <= 0) {
if (next && next[1] > next[0]) return { lo: b[1] - (next[1] - next[0]), hi: b[1], openLow: true, raw: b };
return { lo: 0, hi: b[1], openLow: true, raw: b };
}
return { lo: b[0], hi: b[1], raw: b };
}
var BF = {}, BF_N = 0;
function bestFit(it, meas) {
var key = it.h + "|" + Object.keys(meas).sort().map(function (a) { return a + meas[a]; }).join(",");
if (key in BF) return BF[key];
if (++BF_N > 6000) { BF = {}; BF_N = 1; }
return (BF[key] = bestFitCalc(it, meas));
}
function bestFitCalc(it, meas) {
var best = null;
(it.charts || []).forEach(function (c) {
var f = F.fitProduct([c], meas);
if (!f) return;
if (!best || f.used > best.f.used || (f.used === best.f.used && (F.LEVEL_RANK[f.level] < F.LEVEL_RANK[best.f.level] || (f.level === best.f.level && f.score > best.f.score)))) best = { f: f, chart: c };
});
return best;
}
function sizeTextOf(it, v) {
var s = String(v.o[it.sizeIdx] || "");
if (it.lenIdx > -1 && v.o[it.lenIdx]) s += " · " + (String(v.o[it.lenIdx]).replace(/\s*\(?\s*\d+(?:\.\d+)?\s*(?:"|”|''|in\b|inch(?:es)?)\s*\)?\s*$/i, "").trim() || v.o[it.lenIdx]);
return s;
}
var FAMILY = [
["Pattern", /camo|pattern|print|leopard|tiger|check|plaid|holo|multi/i, "repeating-linear-gradient(45deg,#6b6a52 0 3px,#b9b48e 3px 6px)"],
["Black", /black|stealth|jet|onyx|ebony|anthracite black/i, "#1d1f22"],
["White", /white|ivory|cream|off-white|pearl/i, "#f3f3f1"],
["Grey", /gr[ae]y|silver|charcoal|anthracite|graphite|slate|ash|titanium|gunmetal|smoke/i, "#8e959d"],
["Sand", /sand|beige|khaki|stone|camel|tan\b|taupe|desert|bone/i, "#c9b38b"],
["Brown", /brown|cognac|chocolate|coffee|mocha|tobacco|whisky|rust|chestnut|bronze/i, "#7a4b2b"],
["Blue", /blue|navy|denim|indigo|teal|petrol|cobalt|sky|aqua|cyan/i, "#2f5180"],
["Green", /green|olive|army|forest|lime|mint|sage/i, "#536b3c"],
["Red", /red|burgundy|wine|maroon|oxblood|cherry|bordeaux/i, "#a3302f"],
["Orange", /orange|amber/i, "#dd7a2c"],
["Yellow", /yellow|neon|fluo|hi[- ]?vi|gold|mustard/i, "#e0b42a"],
["Pink", /pink|rose|blush|magenta|fuchsia/i, "#e08fb2"],
["Purple", /purple|violet|lilac|lavender|plum/i, "#5d3c7d"]
];
function famOf(name) {
var first = String(name || "").split(/\s*[\/&+,-]\s*|\s+and\s+/i)[0];
for (var i = 0; i < FAMILY.length; i++) if (FAMILY[i][1].test(first)) return FAMILY[i][0];
for (var j = 0; j < FAMILY.length; j++) if (FAMILY[j][1].test(name)) return FAMILY[j][0];
return null;
}
function famsOf(name) {
var out = [], lead = famOf(name);
if (lead) out.push(lead);
colourParts(name).concat(String(name || "").split(/\s+/)).forEach(function (part) {
for (var i = 0; i < FAMILY.length; i++) if (FAMILY[i][1].test(part) && out.indexOf(FAMILY[i][0]) < 0) { out.push(FAMILY[i][0]); break; }
});
return out;
}
function titleColour(it) { var p = String(it.t).split(/\s+[-–—]\s+/); return p.length > 1 ? p.slice(1).join(" - ") : ""; }
function varFam(it, v) { return it.colIdx > -1 ? famOf(v.o[it.colIdx]) : famOf(titleColour(it)); }
function varHas(it, v, fam) { return famsOf(it.colIdx > -1 ? v.o[it.colIdx] : titleColour(it)).indexOf(fam) > -1; }
function itemFams(it) {
if (!it._fams) {
var f = {};
if (it.colIdx > -1) it.vars.forEach(function (v) { famsOf(v.o[it.colIdx]).forEach(function (x) { f[x] = 1; }); });
else famsOf(titleColour(it)).forEach(function (x) { f[x] = 1; });
it._fams = Object.keys(f);
}
return it._fams;
}
var SWATCH = {};
function normC(x) { return String(x == null ? "" : x).trim().toLowerCase(); }
function colourParts(name) { return String(name || "").split(/\s*(?:\/|\+|&|,|\band\b| - )\s*/i).filter(Boolean); }
function hexOf(part) {
if (SWATCH[normC(part)]) return SWATCH[normC(part)];
for (var i = 0; i < FAMILY.length; i++) if (FAMILY[i][1].test(part)) return FAMILY[i][2];
return "#d9dee5";
}
function swatchCss(v) { return /\.(png|jpe?g|gif|webp|svg)$/i.test(v) ? "url('" + (CFG.assetBase || "") + encodeURIComponent(v) + "') center/cover" : v; }
function swatchBg(name) {
if (SWATCH[normC(name)]) return swatchCss(SWATCH[normC(name)]);
var hx = colourParts(name).map(hexOf);
if (hx.length > 1 && hx[0].charAt(0) === "#" && hx[1].charAt(0) === "#") return "linear-gradient(135deg," + hx[0] + " 50%," + hx[1] + " 50%)";
return swatchCss(hx[0] || "#d9dee5");
}
function colourOf(it, v) { return v && it.colIdx > -1 ? v.o[it.colIdx] : S.colSel[it.h] || null; }
function imgFor(it, v) { var c = colourOf(it, v); return (c && it.vi && it.vi[c]) || it.img; }
function swatchesHtml(it, v) {
if (it.colIdx < 0) return "";
var cols = [], cur = colourOf(it, v);
it.vars.forEach(function (x) { var n = x.o[it.colIdx]; if (n && cols.indexOf(n) < 0) cols.push(n); });
if (!cols.length) return "";
if (S.kitColour) cols.sort(function (a, b) { return (famsOf(b).indexOf(S.kitColour) > -1 ? 1 : 0) - (famsOf(a).indexOf(S.kitColour) > -1 ? 1 : 0); });
var open = S.swOpen[it.h] || cols.length <= 5, show = open ? cols : cols.slice(0, 4);
if (!open && cur && show.indexOf(cur) < 0) show[3] = cur;
return '<span class="sy-sws" role="group" aria-label="' + esc(cols.length + (cols.length === 1 ? " colour" : " colours")) + '">' +
show.map(function (n) {
var on = n === cur;
return '<button type="button" class="sy-sw' + (on ? " is-on" : "") + '" style="background:' + swatchBg(n) + '" title="' + esc(n) + '" aria-label="' + esc(n) + '" aria-pressed="' + on + '" data-swc="' + esc(it.h) + '" data-col="' + esc(n) + '"></button>';
}).join("") +
(open ? "" : '<button type="button" class="sy-swm" data-swmore="' + esc(it.h) + '" aria-label="Show all ' + cols.length + ' colours">+' + (cols.length - 4) + "</button>") + "</span>";
}
function colourMatch(it) { return !S.kitColour || itemFams(it).indexOf(S.kitColour) > -1; }
function noFit(it) {
var col = it.colIdx > -1 ? S.colSel[it.h] : null;
var inCol = function (v) { return !col || v.o[it.colIdx] === col; };
var vars = it.vars.filter(inCol); if (!vars.length) vars = it.vars;
var pick = S.sizeSel[it.h], v = null;
if (it.sizeIdx < 0) v = vars.filter(function (x) { return x.a; })[0] || vars[0] || null;
else if (pick) { var m = vars.filter(function (x) { return sizeTextOf(it, x) === pick; }); v = m.filter(function (x) { return x.a; })[0] || m[0] || null; }
return { nofit: true, f: { label: "", level: "none" }, chart: null, vars: vars, v: v, a: it.vars.some(function (x) { return x.a; }),
missing: false, label: v ? (it.sizeIdx < 0 ? "One size" : sizeTextOf(it, v)) : "", sugLabel: "", picked: false, exact: false };
}
function leanLabel(it, f, chart, meas) {
if (!f.span || it.cat === "pants") return f.label;
var x = F.splitLength(f.label), len = x ? " " + x.length : "";
var score = function (lab) {
var r = rowIndex(chart, lab); if (r < 0) return Infinity;
return usedFields(chart, meas).reduce(function (t, fl) {
var b = bandAt(chart, r, fl.col), v = F.measValue(meas[fl.area]);
if (!b || v == null) return t;
var w = Math.max(b.hi - b.lo, 0.5);
return t + Math.abs(v - (b.lo + b.hi) / 2) / w;
}, 0);
};
var a = f.span.from, z = f.span.to;
return (score(z) < score(a) ? z : a) + len;
}
function fitItem(it, meas) {
var b = bestFit(it, meas);
if (!b) return catDef(it.cat) && catDef(it.cat).acc ? noFit(it) : null;
var f = b.f;
var vars = F.variantsFor(it, leanLabel(it, f, b.chart, meas));
var col = it.colIdx > -1 ? S.colSel[it.h] : null;
var inCol = function (v) { return !col || v.o[it.colIdx] === col; };
var pref = !col && S.kitColour ? vars.filter(function (v) { return v.a && varHas(it, v, S.kitColour); })[0] || vars.filter(function (v) { return varHas(it, v, S.kitColour); })[0] : null;
var v0 = pref || vars.filter(function (v) { return v.a && inCol(v); })[0] || vars.filter(inCol)[0] || vars.filter(function (v) { return v.a; })[0] || vars[0] || null;
var sug = v0 ? sizeTextOf(it, v0) : f.label;
var pick = S.sizeSel[it.h], pv = null;
if (pick && pick !== sug) {
var c0 = colourOf(it, v0);
var m = it.vars.filter(function (v) { return sizeTextOf(it, v) === pick && (c0 == null || v.o[it.colIdx] === c0); });
pv = m.filter(function (v) { return v.a; })[0] || m[0] || null;
}
var vv = pv || v0;
return { f: f, chart: b.chart, vars: vars, v: vv, a: vars.some(function (v) { return v.a; }),
missing: it.sizeIdx > -1 && !vars.length, label: vv ? sizeTextOf(it, vv) : f.label, sugLabel: sug, picked: !!pv,
exact: f.level === "great" || f.level === "good" };
}
function axesOf(fit, meas) {
var r = rowIndex(fit.chart, fit.f.label);
if (r < 0) return [];
return usedFields(fit.chart, meas).map(function (fl) {
var band = bandAt(fit.chart, r, fl.col);
if (!band) return null;
var v = F.measValue(meas[fl.area]), raw = band.raw;
var isIn = raw[0] === raw[1] ? Math.abs(v - raw[0]) <= Math.max(1, (band.hi - band.lo) / 2) : v >= raw[0] && v <= raw[1];
var span = band.hi - band.lo;
return { ax: fl.area, v: v, lo: raw[0], hi: raw[1], blo: band.lo, bhi: band.hi, isIn: isIn,
pos: span > 0 ? (v - band.lo) / span : 0.5, low: v < raw[0], gap: v < raw[0] ? raw[0] - v : v > raw[1] ? v - raw[1] : 0,
openLow: !!band.openLow, col: fl.col, row: r };
}).filter(Boolean);
}
var LEVEL = { great: ["Suggested size", 3], good: ["Suggested size", 2], close: ["Closest size", 1], out: ["Outside the size range", 0] };
function spanParts(it, f) {
var x = F.splitLength(f.label);
var len = x ? " " + x.length : "";
function text(label) {
var vs = F.variantsFor(it, label + len);
var v0 = vs.filter(function (v) { return v.a; })[0] || vs[0];
return v0 ? sizeTextOf(it, v0).replace(" · ", " ") : label + len;
}
return { a: text(f.span.from), b: text(f.span.to), join: f.span.wide ? "to" : "or" };
}
function spanSizes(it, f) {
var p = spanParts(it, f);
if (p.a.length <= 4 && p.b.length <= 4) return '<span class="sy-sz sy-sz--row">' + esc(p.a) + '<span class="sy-or"> ' + p.join + " </span>" + esc(p.b) + "</span>";
return '<span class="sy-sz">' + esc(p.a) + '</span><span class="sy-sz"><span class="sy-or">' + p.join + "</span> " + esc(p.b) + "</span>";
}
function spanSentence(sp) {
var why = sp.fits.slice();
if (sp.legFits) why.push("leg length");
var after = [];
var notHand = function (a) { return a !== "hand length"; };
var roomy = sp.roomy.filter(notHand), snug = sp.snug.filter(notHand);
if (roomy.length) after.push("roomy in the " + listJoin(roomy));
if (snug.length) after.push("snug in the " + listJoin(snug));
if (sp.roomy.length > roomy.length) after.push("long in the fingers");
if (sp.snug.length > snug.length) after.push("short in the fingers");
if (sp.long) after.push("long in the leg");
if (sp.short) after.push("short in the leg");
var out = why.length ? "Sized for your " + listJoin(why) + "." : "";
if (after.length) out += (out ? " " : "") + "May be " + listJoin(after) + ".";
return out;
}
function uniqA(a) { var seen = {}; return a.filter(function (x) { if (seen[x]) return false; seen[x] = 1; return true; }); }
function fitSentence(f) {
if (f.span && (f.level === "great" || f.level === "good")) return spanSentence(f.span);
var worst = -1, wd = 0;
(f.positions || []).forEach(function (p, i) { var d = Math.abs(p - 50); if (d > wd) { wd = d; worst = i; } });
var areas = uniqA(f.areas || []);
if (f.level === "great" || worst < 0 || wd <= 33) return "Fits your " + listJoin(areas) + " well.";
var p = f.positions[worst], a = f.areas[worst];
if (a === "inseam" || a === "height") {
var w = a === "inseam" ? "at the inseam" : "in the leg";
if (p <= 10) return "Short " + w + ". Worth trying on.";
if (p < 50) return "A little short " + w + "." + (f.level === "good" ? "" : " Worth trying on.");
if (p >= 92) return "Long " + w + ". Worth trying on.";
return "A little long " + w + "." + (f.level === "good" ? "" : " Worth trying on.");
}
if (a === "hand length") {
var gl = p < 50 ? "Glove length may be too short." : "Glove length may be too long.";
return gl + (p <= 10 || p >= 92 || f.level !== "good" ? " Worth trying on." : "");
}
if (p <= 10) return "Tight at the " + a + ". Worth trying on.";
if (p < 50) return "A little snug at the " + a + "." + (f.level === "good" ? "" : " Worth trying on.");
if (p >= 92) return "Loose at the " + a + ". Worth trying on.";
return "A little roomy at the " + a + "." + (f.level === "good" ? "" : " Worth trying on.");
}
var THIN_WORD = { hips: "hip", waist: "waist", inseam: "inseam", chest: "chest", thigh: "thigh", height: "height" };
var AREA_SEQ = ["chest", "waist", "hips", "thigh", "inseam", "height"];
function thinChartNote(it) {
if (it.cat !== "pants" && it.cat !== "jackets") return "";
var charts = it.charts;
if (!charts || !charts.length) return "";
var seen = {}, unknown = false;
charts.forEach(function (c) {
((c.calc && c.calc.fields) || []).forEach(function (fl) {
var k = F.areaKey(fl.label);
if (k && THIN_WORD[k]) seen[k] = 1; else unknown = true;
});
});
var areas = AREA_SEQ.filter(function (k) { return seen[k]; });
if (!areas.length) return "";
var thin = it.cat === "pants" ? !(seen.waist && seen.hips) : !unknown && areas.filter(function (k) { return k !== "height" && k !== "inseam"; }).length === 1;
if (!thin) return "";
return '<span class="sy-est">Sized by ' + listJoin(areas.map(function (k) { return THIN_WORD[k]; })) + ' only. <a href="' + CONSULT_URL + '">Book a fit consult</a> to double check sizing.</span>';
}
var EST_NOTE = "Estimate from the brand's garment measurements. Treat it as a guide.";
function detail(it, fit, meas) {
if (fit.nofit) return { level: 0, key: "none", word: "", size: "", sizeText: "", text: "", note: "", axes: [] };
var f = fit.f;
if (fit.missing) {
var c = F.chipsOf((F.splitLength(f.label) || { size: f.label }).size, it.ctx)[0];
var gone = c ? c.v : f.label;
return { level: 0, key: "out", word: "None left in your size", size: "", sizeText: gone, text: esc("Your size here is " + gone + ", which is no longer available in this style."), note: "", axes: [] };
}
var lv = LEVEL[f.level] || LEVEL.out;
var between = f.span && (f.level === "great" || f.level === "good") && it.cat !== "pants";
var axes = axesOf(fit, meas);
var outside = axes.filter(function (a) { return a.gap > Math.max(0.3, a.v * 0.015); });
if (!between && (f.level === "great" || f.level === "good") && outside.length) {
var lows = outside.filter(function (a) { return a.low; }), highs = outside.filter(function (a) { return !a.low; });
var nm = function (l) { return listJoin(l.map(function (a) { return SHORT[a.ax]; })); };
var t = "The closest size we have. Your " + [lows.length ? nm(lows) + (lows.length > 1 ? " are" : " is") + " smaller" : "", highs.length ? nm(highs) + (highs.length > 1 ? " are" : " is") + " bigger" : ""].filter(Boolean).join(" and your ") +
" than its range, so it may feel " + (highs.length && !lows.length ? "snug" : lows.length && !highs.length ? "roomy" : "different") + ".";
return { level: 1, key: "close", word: "Closest size", size: esc(fit.sugLabel || fit.label), sizeText: fit.sugLabel || fit.label,
text: esc(t), note: thinChartNote(it) + (it.est ? '<span class="sy-est">' + esc(EST_NOTE) + "</span>" : ""), axes: axes, chart: fit.chart, sug: sugRows(fit, false) };
}
var sp = between ? spanParts(it, f) : null;
return {
level: lv[1], key: f.level, word: between ? "Suggested sizes" : lv[0],
size: between ? spanSizes(it, f) : esc((f.level === "out" ? "closest " : "") + (fit.sugLabel || fit.label)),
sizeText: between ? sp.a + " " + sp.join + " " + sp.b : fit.sugLabel || fit.label,
text: esc(fitSentence(f)), note: thinChartNote(it) + (it.est ? '<span class="sy-est">' + esc(EST_NOTE) + "</span>" : ""),
axes: axes, chart: fit.chart, sug: sugRows(fit, between)
};
}
function fitBox(d, label, withAxes) {
return '<div class="sy-fitbox"><span class="sy-lvl sy-lv-' + d.key + '"><span class="sy-lvl-k"><i></i>' + esc(d.word) + "</span>" +
(d.size ? '<span class="sy-lvl-v">' + d.size + "</span>" : "") + "</span>" +
'<span class="sy-fsent">' + d.text + "</span>" + d.note + (withAxes ? axesHtml(d, label) : "") + "</div>";
}
function sugRows(fit, between) {
var rs = [];
if (between && fit.f.span) [fit.f.span.from, fit.f.span.to].forEach(function (l) { var r = rowIndex(fit.chart, l); if (r > -1) rs.push(r); });
if (!rs.length) { var r0 = rowIndex(fit.chart, fit.f.label); if (r0 > -1) rs.push(r0); }
return rs;
}
function fitStrips() {
var bs = document.querySelectorAll(".sy-sstep b[data-full]");
for (var i = 0; i < bs.length; i++) {
var b = bs[i], room = b.parentNode.clientWidth - 2;
if (!room) continue;
b.textContent = b.getAttribute("data-full");
if (b.offsetWidth > room) b.textContent = b.getAttribute("data-s1");
if (b.offsetWidth > room) b.textContent = b.getAttribute("data-s2");
}
}
var fitQueued = false;
function queueFit() { if (fitQueued) return; fitQueued = true; requestAnimationFrame(function () { fitQueued = false; fitStrips(); placeTopBtn(); }); }
if (window.MutationObserver) new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { queueFit(); return; } }).observe(document.querySelector(".gear-studio-section") || document.body, { childList: true, subtree: true });
window.addEventListener("resize", queueFit);
var topBtn = null;
function placeTopBtn() {
var kit = $("[data-sy-kit]");
if (!topBtn) {
if (!kit) return;
topBtn = document.createElement("button");
topBtn.type = "button"; topBtn.className = "sy-totop"; topBtn.hidden = true;
topBtn.innerHTML = '<span aria-hidden="true">&uarr;</span> Back to top';
topBtn.addEventListener("click", function () {
var k = $("[data-sy-kit]"), y = k ? k.getBoundingClientRect().top + window.pageYOffset - 90 : 0;
window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
});
(kit.parentNode || document.body).appendChild(topBtn);
}
var show = S.step === 4 && kit && kit.getBoundingClientRect().bottom < 0;
topBtn.hidden = !show;
if (!show) return;
var off = 16;
["[data-sy-cmpbar]", "[data-sy-kitbar]"].forEach(function (q) { var b = $(q); if (b && !b.hidden && b.offsetHeight) off += b.offsetHeight; });
topBtn.style.bottom = off + "px";
}
window.addEventListener("scroll", function () { if (!fitQueued) requestAnimationFrame(placeTopBtn); }, { passive: true });
function axesHtml(d, label) {
if (!d.axes.length) return "";
var chart = d.chart, rows = chart ? rowsOf(chart.table) : [], scol = (chart && chart.calc && chart.calc.size) || 0;
return '<div class="sy-axesbox"><span class="sy-ahead">Where you sit</span><ul class="sy-axes">' + d.axes.map(function (a) {
var segs = [];
var lens = a.ax === "inseam" ? rows.slice(1).map(function (rw) { return F.splitLength(cellText(rw[scol])); }) : [];
if (lens.some(function (x) { return x && x.length; })) {
var sugSz = (d.sug || []).length ? (lens[d.sug[0] - 1] || {}).size : null, byLen = {}, order = [];
for (var rl = 1; rl < rows.length; rl++) {
var sl = lens[rl - 1], bl = bandAt(chart, rl, a.col); if (!sl || !sl.length || !bl) continue;
var mine = !!sugSz && sl.size === sugSz, isSug = (d.sug || []).indexOf(rl) > -1, cur = byLen[sl.length];
if (!cur) { order.push(sl.length); byLen[sl.length] = { lo: bl.lo, hi: bl.hi, raw: bl.raw, lab: String(sl.length).trim(), sug: isSug, mine: mine }; }
else { if (mine && !cur.mine) { cur.lo = bl.lo; cur.hi = bl.hi; cur.raw = bl.raw; cur.mine = true; } if (isSug) cur.sug = true; }
}
segs = order.map(function (k) { return byLen[k]; }).sort(function (x, y) { return x.lo - y.lo; });
}
var lenDone = segs.length > 0;
for (var r = 1; r < rows.length && !lenDone; r++) {
var b = bandAt(chart, r, a.col); if (!b) continue;
var lab = cellText(rows[r][scol]), sz = (F.splitLength(lab) || { size: lab }).size || lab;
var last = segs[segs.length - 1];
if (last && last.lo === b.lo && last.hi === b.hi) { if ((d.sug || []).indexOf(r) > -1) last.sug = true; continue; }
segs.push({ lo: b.lo, hi: b.hi, raw: b.raw, lab: String(sz).trim(), sug: (d.sug || []).indexOf(r) > -1 });
}
if (!segs.length) return "";
for (var q = 1; q < segs.length; q++) {
var pq = segs[q - 1], cq = segs[q];
if (cq.lo !== pq.hi && cq.lo > pq.lo && cq.hi > pq.hi) { var mid = (pq.hi + cq.lo) / 2; pq.hi = mid; cq.lo = mid; }
}
var si = segs.map(function (x, k) { return x.sug ? k : -1; }).filter(function (k) { return k > -1; });
var vi = 0, best = Infinity;
segs.forEach(function (x, k) { var dd = a.v < x.lo ? x.lo - a.v : a.v > x.hi ? a.v - x.hi : 0; if (dd < best) { best = dd; vi = k; } });
var from = Math.max(0, Math.min.apply(null, si.concat([vi])) - 1), to = Math.min(segs.length - 1, Math.max.apply(null, si.concat([vi])) + 1);
var win = segs.slice(from, to + 1);
var lo0 = Math.min(win[0].lo, a.v), hi0 = Math.max(win[win.length - 1].hi, a.v), pad = (hi0 - lo0) * 0.06 + 0.5, l = lo0 - pad, w = hi0 + pad - l;
var inSug = win.some(function (x) { return x.sug && a.v >= x.lo && a.v <= x.hi; });
var sugs = win.filter(function (x) { return x.sug; });
var full = sugs.map(function (x) { return x.lab + " " + showRange(x.raw[0], x.raw[1]); }).join(" · "), right = full;
if (sugs.length > 1) {
var f = sugs[0], z = sugs[sugs.length - 1], fl = f.lab.split(" / ")[0], zl = z.lab.split(" / ")[0], pre = (fl.match(/^[^\d]*\s/) || [""])[0];
if (pre && zl.indexOf(pre) === 0) zl = zl.slice(pre.length);
var next = win.indexOf(z) - win.indexOf(f) === sugs.length - 1;
right = next ? fl + "–" + zl + " " + showRange(f.raw[0], z.raw[1]) : sugs.map(function (x, k) { var t = x.lab.split(" / ")[0]; return k && pre && t.indexOf(pre) === 0 ? t.slice(pre.length) : t; }).join(" & ");
}
return '<li><span class="sy-nm">' + esc(MEAS[a.ax].replace(" circumference", "")) + " " + esc(show(a.v)) + '</span><span class="sy-vv" title="' + esc(full) + '">' + esc(right) + "</span>" +
'<span class="sy-strip">' + win.map(function (x) {
var left = (x.lo - l) / w * 100, width = (x.hi - x.lo) / w * 100;
var s1 = x.lab.split(" / ")[0], s2 = s1.replace(/^[A-Za-z]+\s+(?=\d)/, "");
return '<i class="sy-sstep' + (x.sug ? " is-sug" : "") + '" style="left:' + left.toFixed(2) + "%;width:" + width.toFixed(2) + '%" title="' + esc(x.lab + " " + showRange(x.raw[0], x.raw[1])) + '"><b data-full="' + esc(x.lab) + '" data-s1="' + esc(s1) + '" data-s2="' + esc(s2) + '">' + esc(x.lab) + "</b></i>";
}).join("") +
'<i class="sy-pin' + (inSug ? "" : " is-out") + '" style="left:' + ((a.v - l) / w * 100).toFixed(1) + '%"></i></span></li>';
}).join("") + "</ul></div>";
}
function bandSpan(it) {
var t = (it.tp || []).map(function (x) { return BANDS.indexOf(String(x).split(" ")[0]); }).filter(function (x) { return x >= 0; }).sort(function (a, b) { return a - b; });
return t.length ? [t[0], t[t.length - 1]] : null;
}
function overlapsTemp(it) {
var sp = bandSpan(it);
if (!sp) return true;
return sp[0] <= bandOf(S.thi) && sp[1] >= bandOf(S.tlo);
}
function itemBandText(it) {
var sp = bandSpan(it); if (!sp) return "";
if (sp[0] === 0 && sp[1] === 4) return "All temperatures";
if (sp[0] === 0) return "Under " + EDGE[sp[1]] + "°C";
if (sp[1] === 4) return EDGE[sp[0] - 1] + "°C and up";
return EDGE[sp[0] - 1] + "–" + EDGE[sp[1]] + "°C";
}
var THERMO = '<svg class="sy-thermo" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M14 14.76V4a2 2 0 0 0-4 0v10.76a4 4 0 1 0 4 0z"/></svg>';
function tempHtml(it) {
return '<span class="sy-temp" title="Suggested riding temperature">' + THERMO + "<span>" + esc(itemBandText(it)) + "</span></span>";
}
function degText(lo, hi) { return lo + "–" + hi + "°C"; }
var PROT_FAMILY = { jackets: "garment", base: "garment", pants: "garment", gloves: "gloves" };
var PROT_RANK = { garment: { "CE C": 1, "CE B": 1, "CE A": 2, "CE AA": 3, "CE AAA": 4 } };
var PROT_OPT = {
garment: { 2: "A or higher", 3: "AA or higher", 4: "AAA" },
gloves: { 1: "Knuckle protection" }
};
var PROT_GROUP = { garment: "Jackets & pants", gloves: "Gloves" };
function hasKnuckles(it) { return /KP\b/.test(it.prot || "") || (it.ga || []).some(function (s) { return /knuckle/i.test(s); }) || (it.ip || []).some(function (s) { return /knuckle/i.test(s); }); }
function famName(f) { var n = selCats().filter(function (c) { return PROT_FAMILY[c.k] === f; }).map(function (c) { return c.n; }); return n.length ? n.join(" & ") : PROT_GROUP[f]; }
function protRank(it) {
var f = PROT_FAMILY[it.cat];
if (f === "gloves") return hasKnuckles(it) ? 1 : 0;
return f && it.prot && !it.noCE ? PROT_RANK[f][it.prot] || 0 : 0;
}
function auKept(it, pf) { return it.noCE && S.auProt[pf] !== false; }
function protOut(it) {
var pf = PROT_FAMILY[it.cat];
if (pf === "gloves") { var gs = gloveSpots(it); return S.gSpots.some(function (k) { return gs.indexOf(k) < 0; }); }
return !!(pf && S.minProt[pf] && protRank(it) < S.minProt[pf] && !auKept(it, pf));
}
function protFamilies(cats) {
var out = [];
cats.forEach(function (c) {
var f = PROT_FAMILY[c.k]; if (!f || out.some(function (x) { return x.f === f; })) return;
var ranks = {};
(ITEMS || []).forEach(function (it) { if (PROT_FAMILY[it.cat] === f && S.sel.indexOf(it.cat) > -1) { var r = protRank(it); if (PROT_OPT[f][r]) ranks[r] = 1; } });
var opts = Object.keys(ranks).map(Number).sort();
var au = (ITEMS || []).some(function (it) { return PROT_FAMILY[it.cat] === f && S.sel.indexOf(it.cat) > -1 && it.noCE; });
if (opts.length) out.push({ f: f, opts: opts, au: au && f === "garment" });
});
return out;
}
function protText() {
var g = S.gSpots.length ? ["Gloves with " + listJoin(S.gSpots.map(function (k) { return k.toLowerCase(); })) + " protection"] : [];
return Object.keys(S.minProt).filter(function (f) { return f !== "gloves" && S.minProt[f]; }).map(function (f) {
return (Object.keys(S.minProt).filter(function (k) { return S.minProt[k]; }).length > 1 ? famName(f) + " " : "") + PROT_OPT[f][S.minProt[f]];
}).concat(g).join(" · ");
}
function renderProt() {
var box = $("[data-sy-prot]"); if (!box) return;
box.innerHTML = protFamilies(selCats()).map(function (g) {
if (g.f === "gloves") {
var have = {};
(ITEMS || []).forEach(function (it) { if (it.cat === "gloves") gloveSpots(it).forEach(function (k) { have[k] = 1; }); });
var spots = GLOVE_SPOTS.filter(function (k) { return have[k]; });
return '<div class="sy-protg"><span class="sy-protn">' + esc(famName(g.f)) + ' <span class="sy-labelhint">Pick as many as you like</span></span><div class="sy-pills">' +
'<button type="button" class="sy-pill" data-gspot="" aria-pressed="' + !S.gSpots.length + '">Any</button>' +
spots.map(function (k) { return '<button type="button" class="sy-pill" data-gspot="' + k + '" aria-pressed="' + (S.gSpots.indexOf(k) > -1) + '">' + esc(k) + "</button>"; }).join("") + "</div></div>";
}
var cur = S.minProt[g.f] || 0;
return '<div class="sy-protg"><span class="sy-protn">' + esc(famName(g.f)) + '</span><div class="sy-pills">' +
'<button type="button" class="sy-pill" data-prot="' + g.f + ':0" aria-pressed="' + !cur + '">Any</button>' +
g.opts.map(function (r) { return '<button type="button" class="sy-pill" data-prot="' + g.f + ":" + r + '" aria-pressed="' + (cur === r) + '">' + esc(PROT_OPT[g.f][r]) + "</button>"; }).join("") + "</div>" +
(g.f === "garment" && cur === 4 ? '<div class="sy-infobox" role="note"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3a506b" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M12 11v6"/><circle cx="12" cy="7.5" r=".6" fill="#3a506b"/></svg><p>Only a small share of jackets and pants are rated AAA, so this may limit your results. AA is generally considered reasonable for most road and adventure riding.</p></div>' : "") +
(g.au && cur ? '<label class="sy-mkt sy-auprot"><input type="checkbox" data-sy-auprot="' + g.f + '"' + (S.auProt[g.f] !== false ? " checked" : "") + "> Also show Australian brands that aren't CE rated</label>" : "") + "</div>";
}).join("");
}
function attrOk(it, anyColour) {
if (!anyColour && S.kitColour && !colourMatch(it)) return false;
var pf = PROT_FAMILY[it.cat];
if (protOut(it)) return false;
if (S.wet && it.wp != null && it.wp !== true) return false;
if (S.wet && it.wp == null && hasAttrs(catDef(it.cat))) return false;
if (!bikeOk(it)) return false;
if (!heightOk(it)) return false;
if (S.tempOn && !overlapsTemp(it)) return false;
return true;
}
function isOwn(it) { return !S.gender || !it.gen.length || it.gen.indexOf(S.gender) > -1 || it.gen.indexOf("Unisex") > -1; }
function isCross(it) { return !!S.gender && it.gen.length && !isOwn(it); }
var STOCK = {}, QUEUE = [], ACTIVE = 0;
var CONFIRM_LINE = "We will confirm your dispatch date within one business day.";
var BACKORDER_LINE = "Order now and we will confirm your delivery date within one business day.";
var MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
var WKD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
function ord(n) { var v = n % 100; return n + (v >= 11 && v <= 13 ? "th" : ["th", "st", "nd", "rd"][n % 10] || "th"); }
function isoParts(d) { return String(d).slice(0, 10).split("-").map(Number); }
function fmtDay(d) {
var a = isoParts(d), w = new Date(Date.UTC(a[0], a[1] - 1, a[2])).getUTCDay();
return WKD[w] + " " + ord(a[2]) + " " + MON[a[1] - 1];
}
function fmtDate(d) {
var a = isoParts(d);
try { return new Date(a[0], a[1] - 1, a[2]).toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" }); }
catch (e) { return a[2] + "/" + a[1]; }
}
function fmtEtaBoard(d) {
var a = isoParts(d); if (!a[2]) return "";
return (a[2] <= 10 ? "Early" : a[2] <= 20 ? "Mid" : "Late") + " " + MON[a[1] - 1] + " '" + String(a[0]).slice(-2);
}
function fmtCountdown(sec) {
var h = Math.floor(sec / 3600), m = Math.floor(sec % 3600 / 60);
return h > 0 ? h + "h " + m + "m" : m > 0 ? m + " min" : "moments";
}
function workday(d) {
var a = isoParts(d);
var dt = new Date(Date.UTC(a[0], a[1] - 1, a[2])), w = dt.getUTCDay();
if (w === 6) dt.setUTCDate(dt.getUTCDate() + 2); else if (w === 0) dt.setUTCDate(dt.getUTCDate() + 1);
return dt.toISOString().slice(0, 10);
}
var MELB = { at: 0, day: "", fmt: null };
function melbToday() {
var now = Date.now();
if (MELB.day && now - MELB.at < 60000) return MELB.day;
var p = {};
MELB.fmt = MELB.fmt || new Intl.DateTimeFormat("en-AU", { timeZone: "Australia/Melbourne", year: "numeric", month: "2-digit", day: "2-digit" });
MELB.fmt.formatToParts(new Date(now)).forEach(function (x) { p[x.type] = x.value; });
MELB.at = now; MELB.day = p.year + "-" + p.month + "-" + p.day;
return MELB.day;
}
function shopName(n) { return /melb/i.test(n) ? "Port Melbourne" : n; }
function dispatchLine(d) {
if (d.secondsToCutoff > 0) return "Order within " + fmtCountdown(d.secondsToCutoff) + " and it is dispatched today.";
if (d.date) return (d.estimated ? "Estimated dispatch " : "Dispatched ") + fmtDay(d.date);
return "";
}
function promiseFrom(j) {
var d = j.dispatch ? Object.assign({}, j.dispatch) : {};
if (d.date) {
var wd = workday(d.date);
if (wd !== String(d.date).slice(0, 10)) d.secondsToCutoff = 0;
d.date = wd;
}
var by = j.order && j.order.by;
var deadline = by ? (by <= melbToday() ? "Order today to make our next supplier order." : "Order by " + fmtDate(by) + " to make our next supplier order.") : "";
var when = [deadline, dispatchLine(d) || (j.localPromise || "")].filter(Boolean).join(" ");
if (j.state === "in_shop" || j.state === "available") {
var at = (j.shops || []).filter(function (s) { return s.available; })[0];
return { cls: "in", label: at ? "In stock at " + shopName(at.name) : "Available online", when: when || CONFIRM_LINE, date: d.secondsToCutoff > 0 ? melbToday() : d.date || null,
src: "stock" };
}
if (j.state === "supplier") return { cls: "in", label: "Available online", when: when || CONFIRM_LINE, date: d.date || null, by: by || null, src: "supplier" };
if (j.state === "incoming" || j.state === "backorder") {
var eta = (j.incoming && j.incoming.eta) || (j.supply && j.supply.eta), board = eta ? fmtEtaBoard(eta) : "";
return { cls: "later", label: board ? "Backordered - estimated arrival " + board : "On backorder", when: when || BACKORDER_LINE, date: d.date || null,
src: j.state === "incoming" ? "incoming" : "backorder", eta: board || "" };
}
return { cls: "out", label: "Sold out in this size", when: "" };
}
function stockFor(v) {
if (!v) return { cls: "out", label: "Sold out in this size", when: "" };
if (STOCK[v.id]) return STOCK[v.id];
return v.a ? { cls: "wait", label: "Checking stock…", when: "", pending: true } : { cls: "out", label: "Sold out in this size", when: "" };
}
function askStock(vid) {
if (!vid || STOCK[vid] || QUEUE.indexOf(vid) > -1) return;
QUEUE.push(vid); pump();
}
function pump() {
while (ACTIVE < 4 && QUEUE.length) {
var vid = QUEUE.shift();
ACTIVE++;
fetch("/apps/peakmoto/availability?variant=" + encodeURIComponent(vid), { credentials: "same-origin" })
.then(function (r) { return r.ok ? r.json() : null; })
.then((function (id) { return function (j) { STOCK[id] = j ? promiseFrom(j) : { cls: "in", label: "In stock", when: "" }; paintStock(id); }; })(vid))
.catch((function (id) { return function () { STOCK[id] = { cls: "in", label: "In stock", when: "" }; paintStock(id); }; })(vid))
.then(function () { ACTIVE--; pump(); });
}
}
function stockHtml(st) { return '<span class="sy-stock is-' + st.cls + '"><i class="sy-dot"></i>' + esc(st.label) + "</span>"; }
function paintStock(vid) {
var st = STOCK[vid];
$$('[data-sy-stock="' + vid + '"]').forEach(function (el) { el.innerHTML = stockHtml(st); });
$$('[data-sy-when="' + vid + '"]').forEach(function (el) { el.textContent = st.when; });
if (S.kit.length) renderKitSum();
}
var seen = "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting) { askStock(e.target.getAttribute("data-sy-card")); seen.unobserve(e.target); } });
}, { rootMargin: "200px" }) : null;
function watchCards() {
$$("[data-sy-card]").forEach(function (el) {
var vid = el.getAttribute("data-sy-card");
if (!vid || STOCK[vid]) return;
if (seen) seen.observe(el); else askStock(vid);
});
}
function reviewHtml(it, long) {
if (!it.rc || !it.rv) return long ? '<span class="sy-rev is-none">No reviews yet</span>' : "";
return '<button type="button" class="sy-rev" data-reviews="' + esc(it.h) + '" aria-label="Rated ' + it.rv.toFixed(1) + " out of 5 from " + it.rc + ' reviews. Read the reviews">' + starsHtml(it.rv) +
'<span class="sy-rn">(' + it.rc + ")</span></button>";
}
var STAR = "M7 1l1.8 3.9 4.2.5-3.1 2.9.8 4.2L7 10.4 3.3 12.5l.8-4.2L1 5.4l4.2-.5z";
function starsHtml(rating) {
var pct = Math.max(0, Math.min(100, rating / 5 * 100));
var paths = [0, 16, 32, 48, 64].map(function (x) { return '<path transform="translate(' + x + ' 0)" d="' + STAR + '"/>'; }).join("");
return '<span class="sy-stars" aria-hidden="true"><svg class="sy-stars-bg" viewBox="0 0 80 14">' + paths + '</svg><span class="sy-stars-fg" style="width:' + pct.toFixed(0) + '%"><svg viewBox="0 0 80 14">' + paths + "</svg></span></span>";
}
var REV = {};
function loadReviews(h) {
if (!REV[h]) {
REV[h] = fetch("/products/" + encodeURIComponent(h) + "?view=gear-studio-reviews", { credentials: "same-origin" }).then(function (r) { return r.json(); });
REV[h].catch(function () { delete REV[h]; });
}
return REV[h];
}
function revDate(d) { var p = String(d || "").split("-"); return p.length === 3 ? +p[2] + " " + MON[+p[1] - 1] + " " + p[0] : ""; }
function plain(html) { var t = document.createElement("div"); t.innerHTML = String(html || "").replace(/<br\s*\/?>|<\/p>/gi, "\n"); return (t.textContent || "").trim(); }
function paras(text) { return String(text || "").split(/\n\s*\n|\n/).filter(function (x) { return x.trim(); }).map(function (x) { return "<p>" + esc(x.trim()) + "</p>"; }).join(""); }
function reviewsHtml(it, d) {
var avg = parseFloat(d.avg) || it.rv, n = +d.n || it.rc, hist = d.hist || [], tot = hist.reduce(function (a, b) { return a + b; }, 0) || 1;
var list = d.r || [];
var head = '<div class="sy-rvhead"><div class="sy-rvprod">' + thumb(it) + '<div><span class="sy-vend">' + esc(it.v) + '</span><span class="sy-cname">' + esc(it.t) + "</span></div></div>" +
'<div class="sy-rvsum"><div class="sy-rvavg"><b>' + avg.toFixed(1) + "</b>" + starsHtml(avg) + "<span>Based on " + n + " review" + (n === 1 ? "" : "s") + "</span></div>" +
'<ul class="sy-hist">' + hist.map(function (f, i) {
return '<li><span class="sy-hs">' + (5 - i) + ' ★</span><span class="sy-hb"><i style="width:' + Math.round(f / tot * 100) + '%"></i></span><span class="sy-hn">' + f + "</span></li>";
}).join("") + "</ul></div></div>";
var rows = list.map(function (r) {
var meta = [esc(r.a || "Anonymous")];
if (r.v) meta.push('<span class="sy-verified">Verified buyer</span>');
if (r.l) meta.push(esc(r.l));
return '<li class="sy-rv"><div class="sy-rvtop">' + starsHtml(r.s) + '<span class="sy-rvd">' + esc(revDate(r.d)) + "</span></div>" +
(r.t ? '<b class="sy-rvt">' + esc(r.t) + "</b>" : "") + '<div class="sy-rvb">' + paras(r.b) + "</div>" +
(r.x ? '<p class="sy-rvx">' + esc(r.x) + "</p>" : "") +
(r.p && r.p.length ? '<div class="sy-rvpics">' + r.p.map(function (p) { return '<a href="' + esc(p.o || p.s) + '" target="_blank" rel="noopener"><img loading="lazy" alt="" src="' + esc(p.s || p.o) + '"></a>'; }).join("") + "</div>" : "") +
'<p class="sy-rvm">' + meta.join(" · ") + "</p>" +
(r.re ? '<div class="sy-rvre"><b>Peak Moto replied</b>' + paras(plain(r.re)) + "</div>" : "") + "</li>";
}).join("");
return head + (rows ? '<ul class="sy-rvlist">' + rows + "</ul>" : '<p class="sy-hint">No written reviews yet.</p>') +
(n > list.length ? '<a class="sy-howto sy-rvall" href="' + url(it) + '#judgeme_product_reviews">See all ' + n + " reviews</a>" : "");
}
function openReviews(h) {
var it = findItem(h); if (!it) return;
var m = $("[data-sy-revmodal]"), body = m.querySelector(".sy-mbody");
body.innerHTML = '<p class="sy-loading">Loading reviews&hellip;</p>';
m.hidden = false; m.querySelector(".sy-mclose").focus();
loadReviews(h).then(function (d) { if (!m.hidden) body.innerHTML = reviewsHtml(it, d || {}); }).catch(function () {
body.innerHTML = '<p class="sy-hint">We couldn\'t load the reviews just now. <a href="' + url(it) + '#judgeme_product_reviews">Read them on the product page</a>.</p>';
});
}
function closeReviews() { $("[data-sy-revmodal]").hidden = true; }
function backIncluded(it) { return (it.ip || []).some(function (x) { return /CE Level \d Back/i.test(x); }); }
function isRevit(it) { return /^rev.?it/i.test(String(it.v || "")); }
function backReady(it) { return (!!it.bp || (isRevit(it) && it.cat === "jackets" && !it.suit)) && !backIncluded(it) && !!ARMOURED_CATS[it.cat]; }
var RV_HANDLE = "revit-see-soft-air-back-protector-type-rv";
function rvSize(jk) {
var f = kitFit(jk), lab = f && f.label ? String(f.label) : ""; if (!lab) return null;
var ladies = jk.gen.indexOf("Women") > -1 && jk.gen.indexOf("Men") < 0, leather = /leather/i.test(jk.ty + " " + jk.t);
var m = /EU\s*(\d{2})/i.exec(lab) || /^(\d{2})\b/.exec(lab.trim()), n = m ? +m[1] : null;
var L = sizeRank(lab.split(/[\s/·]/)[0]);
if (!ladies && !leather) return L < 0 ? null : L <= sizeRank("M") ? "4" : L <= sizeRank("XXL") ? "5" : "6";
if (n == null) return null;
if (ladies && !leather) return n <= 36 ? "3" : n <= 44 ? "4" : "5";
if (!ladies && leather) return n <= 48 ? "3" : n <= 54 ? "4" : n <= 58 ? "5" : "6";
return n <= 44 ? "3" : "4";
}
function visorFits(vis, helmet) {
var brand = String(vis.v || "").trim().toLowerCase();
if (brand && String(helmet.v || "").trim().toLowerCase() !== brand) return false;
var names = String(vis.t).replace(/\([^)]*\)/g, " ").replace(/\bvisors?\b/ig, " ").split("/").map(function (n) {
n = n.trim(); if (brand && n.toLowerCase().indexOf(brand + " ") === 0) n = n.slice(brand.length + 1);
return n.replace(/[^a-z0-9]+/gi, " ").trim().toLowerCase();
}).filter(Boolean);
var ht = " " + modelName(helmet).replace(/[^a-z0-9]+/gi, " ").toLowerCase() + " ";
return names.some(function (n) { return ht.indexOf(" " + n + " helmet ") > -1 || ht.slice(-(n.length + 2)) === " " + n + " "; });
}
function kitHelmetFor(vis) { return kitItems().filter(function (h) { return h.cat === "helmets" && visorFits(vis, h); })[0] || null; }
function kitBackFor(ins) {
if (!/back/i.test(ins.ty + " " + ins.t)) return null;
var g = kitItems().filter(backReady);
if (ins.h === RV_HANDLE) return g.filter(isRevit)[0] || null;
return g.filter(function (x) { return x.v && x.v === ins.v; })[0] || g[0] || null;
}
function kitMatch(it) { return it.ag === "visors" ? kitHelmetFor(it) : it.ag === "armour" ? kitBackFor(it) : null; }
var SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];
function sizeRank(t) {
var u = String(t).toUpperCase().replace(/\s/g, "").replace(/^2XL$/, "XXL").replace(/^3XL$/, "XXXL");
return SIZE_ORDER.indexOf(u);
}
function autoVisorSize(h, forHelmet) {
if (h === RV_HANDLE && !S.sizeSel[h]) {
var rj = kitItems().filter(function (x) { return backReady(x) && isRevit(x); })[0], rs = rj && rvSize(rj);
if (rs) S.sizeSel[h] = rs;
return;
}
var vis = findItem(h); if (!vis || vis.ag !== "visors" || S.sizeSel[h]) return;
var hel = forHelmet || kitHelmetFor(vis), f = hel && kitFit(hel); if (!f || !f.label) return;
var hi = sizeRank(String(f.label).split(/[\s/·]/)[0]); if (hi < 0) return;
var opts = uniq(vis.vars.map(function (v) { return sizeTextOf(vis, v); }));
var pick = opts.filter(function (o) {
var m = String(o).toUpperCase().replace(/\s/g, "").split("-");
if (m.length === 2) { var a = sizeRank(m[0]), b = sizeRank(m[1]); return a > -1 && b > -1 && hi >= a && hi <= b; }
return sizeRank(o) === hi;
})[0];
if (pick) S.sizeSel[h] = pick;
}
function rowsFor(c, which) {
var meas = bodyFor(c), rows = [];
(ITEMS || []).forEach(function (it) {
if (it.cat !== c.k) return;
if (which === "own" ? !isOwn(it) : !isCross(it)) return;
if (!attrOk(it)) return;
var fit = fitItem(it, meas);
if (!fit) return;
if (S.fitOnly && !fit.nofit && (!fit.exact || fit.missing)) return;
if (c.acc && S.accSub[c.k] && it.ag !== S.accSub[c.k]) return;
rows.push({ it: it, fit: fit, d: detail(it, fit, meas) });
});
var scores = rows.map(function (r) { return r.fit.f.score || 0; }).sort(function (a, b) { return a - b; });
var maxBs = ITEMS.reduce(function (m, it) { return Math.max(m, it.bs || 0); }, 0) || 1;
rows.forEach(function (r) {
var sc = r.fit.f.score || 0, fitPct = scores.length > 1 ? scores.indexOf(sc) / (scores.length - 1) : 1;
var sold = r.it.bs ? 1 - (r.it.bs - 1) / maxBs : 0, rev = Math.min(r.it.rc || 0, 40) / 40;
r.rank = fitPct * 0.5 + (sold * 0.7 + rev * 0.3) * 0.5;
});
rows.sort(function (a, b) {
if (c.k === "extras") { var ma = !!kitMatch(a.it), mb = !!kitMatch(b.it); if (ma !== mb) return ma ? -1 : 1; }
if (a.fit.a !== b.fit.a) return a.fit.a ? -1 : 1;
var ea = a.fit.exact && !a.fit.missing, eb = b.fit.exact && !b.fit.missing;
if (ea !== eb) return ea ? -1 : 1;
if (S.kitColour) { var ca = colourMatch(a.it), cb = colourMatch(b.it); if (ca !== cb) return ca ? -1 : 1; }
if (a.d.level !== b.d.level) return b.d.level - a.d.level;
return b.rank - a.rank;
});
return rows;
}
function url(it, v) { return it.u + (v ? "?variant=" + v.id : ""); }
function thumb(it) {
if (!it || !it.img) return '<span class="sy-noimg"></span>';
var f = catDef(it.cat) ? kitFit(it) : null;
return '<img alt="" loading="lazy" src="' + esc(imgFor(it, f && f.v)) + '">';
}
function flagsHtml(it) {
var h = "", tb = "";
if (it.av && it.cp > it.p) {
var off = Math.round((it.cp - it.p) / it.cp * 100);
h += '<span class="sy-flag sy-flag--sale">' + (off >= 1 ? (it.pm > it.p ? "Up to " : "") + off + "% off" : "Sale") + "</span>";
}
var r = (it.fsale || /final sale/i.test(it.t) ? '<span class="sy-flag sy-flag--final">Final sale</span>' : "") +
(it.gen.indexOf("Unisex") > -1 ? '<span class="sy-flag sy-flag--uni">Unisex</span>' : "");
return (h || tb ? '<span class="sy-flagl">' + h + tb + "</span>" : "") + (r ? '<span class="sy-flagr">' + r + "</span>" : "");
}
function brandRow(it) {
var pill = it.cat === "boots" ? (it.wp === true ? "Waterproof" : null) : it.noCE ? null : it.prot;
return '<div class="sy-vendrow"><span class="sy-vend">' + esc(it.v) + "</span>" + (pill ? '<span class="sy-cepill">' + esc(pill) + "</span>" : "") + "</div>" +
(it.noCE ? '<span class="sy-cenote">Australian brand, CE not required</span>' : "");
}
function attrRow(it) {
var chips = [];
if (bandSpan(it)) chips.push('<span class="sy-chip is-temp' + (S.tempOn ? " is-match" : "") + '">' + tempHtml(it) + "</span>");
if (it.wp === true && it.cat !== "boots") chips.push('<span class="sy-chip">Waterproof</span>');
if (it.cat === "boots" && it.bh) chips.push('<span class="sy-chip">' + esc(it.bh) + " height</span>");
if (backReady(it)) chips.push('<span class="sy-chip" title="Has a pocket for a back protector, sold separately">Back armour ready</span>');
var pt = popTag(it); if (pt) chips.push('<span class="sy-chip is-pop">' + esc(pt) + "</span>");
return chips.length ? '<div class="sy-chips">' + chips.join("") + "</div>" : "";
}
function sizePick(it, fit) {
if (it.sizeIdx < 0 || (!fit.v && !fit.nofit)) return "";
var c0 = fit.v ? colourOf(it, fit.v) : (it.colIdx > -1 ? S.colSel[it.h] || null : null), seen = {}, opts = [];
it.vars.forEach(function (v) {
if (c0 != null && v.o[it.colIdx] !== c0) return;
var l = sizeTextOf(it, v);
if (seen[l] == null) { seen[l] = opts.length; opts.push({ l: l, a: v.a }); } else if (v.a) opts[seen[l]].a = true;
});
if (opts.length < 2 && !fit.nofit) return "";
return '<label class="sy-sizepick"><span>Choose size</span><select data-sizesel="' + esc(it.h) + '">' + (fit.nofit && !fit.v ? '<option value="" selected>Choose a size</option>' : "") + opts.map(function (o) {
return '<option value="' + esc(o.l) + '"' + (o.l === fit.label ? " selected" : "") + ">" + esc(o.l) + (o.l === fit.sugLabel ? " (our pick)" : !o.a ? " (sold out)" : "") + "</option>";
}).join("") + "</select></label>" +
(fit.picked ? '<span class="sy-picknote">Note: we suggested ' + esc(fit.sugLabel) + " based on your measurements.</span>" : "");
}
function budgetNote(it, inKit) {
if (!S.budget || inKit) return "";
var cur = kitItems().filter(function (x) { return x.cat === it.cat; });
if (cur.length > 1) cur = [];   // two or more already: this one is an extra
var same = cur.reduce(function (t, x) { return t + x.p; }, 0);
var diff = kitTotal() - same + it.p - S.budget * 100;
if (diff <= 0) {
if (cur.length && it.p < same && overBy() > 0) return '<span class="sy-inb">Brings your kit within budget · saves ' + money(same - it.p) + "</span>";
var up = cur.length && it.p > same ? upgradeWhy(cur[0], it) : [];
return up.length ? '<span class="sy-inb">Still within budget, with ' + whyText(up) + "</span>" : "";
}
if (cur.length && it.p < same) return '<span class="sy-inb is-part">Saves ' + money(same - it.p) + " · your kit is still " + money(diff) + " over budget</span>";
var why = cur.length && sameKind(cur[0], it) ? upgradeWhy(cur[0], it) : [];
if (why.length && diff <= bumpCap()) return '<span class="sy-stretch"><b>Worth the stretch:</b> ' + money(diff) + " over your budget for " + whyText(why) + ".</span>";
return '<span class="sy-overb">Adds ' + money(it.p - same) + ", taking your kit " + money(diff) + " over budget</span>";
}
function modelName(it) { return String(it.t).split(/\s+[-–—]\s+/)[0]; }
function modelKey(it) { return (it.v + "|" + modelName(it)).toLowerCase(); }
function groupModels(rows) {
var by = {}, order = [];
rows.forEach(function (r) { var k = modelKey(r.it); if (!by[k]) { by[k] = []; order.push(k); } by[k].push(r); });
return order.map(function (k) {
var g = by[k], pick = (S.colPick[k] && g.filter(function (r) { return r.it.h === S.colPick[k]; })[0]) || g[0];
return g.length > 1 ? Object.assign({}, pick, { group: g, gkey: k }) : pick;
});
}
function colourways(r) {
var g = r.group, open = S.cwOpen[r.gkey] || g.length <= 12, show = open ? g : g.slice(0, 11);
return '<div class="sy-cways"><span class="sy-cwl">' + esc(titleColour(r.it) || "Colour") + '<span class="sy-cwn"> · ' + g.length + " colourways</span></span>" +
'<div class="sy-cwlist">' + show.map(function (x) {
var on = x.it.h === r.it.h, nm = (titleColour(x.it) || x.it.t) + (x.fit.a ? "" : " · sold out in your size");
return '<button type="button" class="sy-cw' + (on ? " is-on" : "") + (x.fit.a ? "" : " is-out") + '" data-cw="' + esc(r.gkey) + "|" + esc(x.it.h) + '" aria-pressed="' + on + '" title="' + esc(nm) + '" aria-label="' + esc(nm) + '">' +
(x.it.img ? '<img alt="" loading="lazy" src="' + esc(x.it.img) + '">' : "") + "</button>";
}).join("") + (open ? "" : '<button type="button" class="sy-cwmore" data-cwmore="' + esc(r.gkey) + '" aria-label="Show all ' + g.length + ' colourways">+' + (g.length - 11) + "</button>") + "</div></div>";
}
function card(r) {
var it = r.it, fit = r.fit, d = r.d, v = fit.v, vid = v ? v.id : "";
var st = !v && fit.nofit ? { cls: "wait", label: "Choose a size to see stock", when: "" } : stockFor(v);
var tags = [];
var myRef = refOf(it.h); if (myRef) tags.push(["You have this in " + myRef.label, "own"]);
var km = kitMatch(it);
if (km) tags.push([it.h === RV_HANDLE && rvSize(km) ? "Type RV " + rvSize(km) + " fits your " + modelName(km) : (it.ag === "visors" ? "Fits your " : "For the back pocket in your ") + modelName(km), "own"]);
var inKit = S.kit.indexOf(it.h) > -1;
var cl = cmpList(), inCmp = cl.indexOf(it.h) > -1, cmpFull = !inCmp && cl.length >= 3;
return '<article class="sy-card"' + (vid && st.pending ? ' data-sy-card="' + vid + '"' : "") + ">" +
'<a class="sy-ph" href="' + url(it, v) + '" tabindex="-1" aria-hidden="true">' + (it.img ? '<img loading="lazy" alt="" src="' + esc(imgFor(it, v)) + '">' : "") + flagsHtml(it) + "</a>" +
'<div class="sy-body"><div class="sy-cs sy-cs-head">' + brandRow(it) +
'<h3 class="sy-name"><a href="' + url(it, v) + '">' + esc(r.group ? modelName(it) : it.t) + "</a></h3>" + reviewHtml(it) +
(r.group ? colourways(r) : "") +
attrRow(it) +
'<div class="sy-pricerow"><span class="sy-price">' + (it.pm > it.p ? "From " : "") + money(it.p) + (it.cp > it.p ? " <s>" + money(it.cp) + "</s>" : "") + "</span>" + swatchesHtml(it, v) + "</div></div>" +
'<div class="sy-cs sy-cs-stock"><span class="sy-stockline" data-sy-stock="' + vid + '">' + stockHtml(st) + "</span>" +
'<span class="sy-when" data-sy-when="' + vid + '">' + esc(st.when) + "</span></div>" +
'<div class="sy-cs sy-cs-fit">' + (fit.nofit ? "" : fitBox(d, fit.sugLabel || fit.label, true)) + sizePick(it, fit) + budgetNote(it, inKit) +
(tags.length ? '<div class="sy-tags">' + tags.map(function (t) { return '<span class="sy-tag' + (t[1] ? " is-" + t[1] : "") + '">' + esc(t[0]) + "</span>"; }).join("") + "</div>" : "") +
waitHtml(it, v, st) + "</div>" +
'<span class="sy-cta"><a class="sy-cardbtn is-viewp" href="' + url(it, v) + '">View product</a>' +
'<button type="button" class="sy-cardbtn" data-cmp="' + esc(it.h) + '" aria-pressed="' + inCmp + '"' + (cmpFull ? " disabled" : "") + ">" + (inCmp ? "✓ Comparing" : cmpFull ? "Compare (3 max)" : "Compare") + "</button>" +
(inKit || slotCount(it.cat) !== 1 ? '<button type="button" class="sy-cardbtn is-primary" data-kit="' + esc(it.h) + '" aria-pressed="' + !!inKit + '">' + (inKit ? "✓ In your kit" : "Add to kit") + "</button>" :
'<span class="sy-kitpair" role="group" aria-label="Add to kit">' +
'<button type="button" class="sy-cardbtn is-lite" data-swap="' + esc(it.h) + '" title="Replace your ' + esc(kitItems().filter(function (x) { return x.cat === it.cat; })[0].t) + '">Swap</button>' +
'<button type="button" class="sy-cardbtn is-primary" data-kit="' + esc(it.h) + '" title="Keep both, e.g. for summer and winter">Add</button></span>') +
"</span></div></article>";
}
function waitHtml(it, v, st) {
if (!v || v.a) return "";
var k = v.id;
if (S.wait[k]) return '<div class="sy-waitl"><span class="sy-done">✓ We\'ll email you when it\'s back.</span></div>';
return '<div class="sy-waitl"><span class="sy-wtitle">Tell me when it\'s back</span><form data-wait="' + k + '">' +
(S.email ? '<input type="hidden" value="' + esc(S.email) + '"><button type="submit" style="flex:1">Email ' + esc(S.email) + "</button>"
: '<input type="email" required placeholder="you@email.com" aria-label="Email for a restock alert"><button type="submit">Notify me</button>') + "</form></div>";
}
function cmpList() { return S.cmp[S.cat] || (S.cmp[S.cat] = []); }
function renderCmpBar() {
var bar = $("[data-sy-cmpbar]"), l = cmpList(), undo = cmpUndoHtml();
if (!l.length && !undo) { bar.hidden = true; return; }
bar.hidden = false;
if (!l.length) { bar.innerHTML = '<div class="sy-wrap sy-cmpin">' + undo + "</div>"; return; }
bar.innerHTML = '<div class="sy-wrap sy-cmpin">' + undo + l.map(function (h) {
var it = findItem(h); return '<span class="sy-cmpthumb">' + thumb(it) + '<button type="button" class="sy-x" data-uncmp="' + esc(h) + '" aria-label="Remove ' + esc(it ? it.t : "") + '">&times;</button></span>';
}).join("") + "<span>" + (l.length < 2 ? "Pick one more to compare" : l.length + " " + esc(catDef(S.cat).n.toLowerCase()) + " to compare") + "</span>" +
'<button type="button" class="sy-cmpgo" data-cmpgo' + (l.length < 2 ? " disabled" : "") + ">Compare</button>" +
'<button type="button" class="sy-linkbtn" data-cmpclear>Clear</button></div>';
}
var INFO = {};
function loadInfo(h) {
if (INFO[h]) return INFO[h].p;
var rec = INFO[h] = { d: null };
rec.p = fetch("/products/" + encodeURIComponent(h) + "?view=gear-studio-info", { credentials: "same-origin" })
.then(function (r) { return r.ok ? r.json() : null; })
.catch(function () { return null; })
.then(function (d) { rec.d = d || {}; return rec.d; });
return rec.p;
}
function infoOf(it) { return INFO[it.h] && INFO[it.h].d; }
function infoCell(it, fn) {
var d = infoOf(it);
if (!d) return '<span class="sy-none">Loading&hellip;</span>';
var v = fn(d);
return v ? v : '<span class="sy-none">Not recorded</span>';
}
function textCell(t) { t = String(t || "").trim(); return t && t !== "-" && !/^none$/i.test(t) ? esc(t).replace(/\n+/g, "<br>") : ""; }
function listCell(v) { var l = Array.isArray(v) ? v : v ? [v] : []; return l.length ? esc(l.join(", ")) : ""; }
function claspOf(ds) {
var t = String(ds || "");
if (/micro-?metric|ratchet/i.test(t)) return "Micrometric buckle";
if (/double[- ]?d|d[- ]?ring/i.test(t)) return "Double D-ring";
if (/fidlock|magnetic (buckle|closure|strap)/i.test(t)) return "Magnetic buckle";
if (/quick[- ]release/i.test(t)) return "Quick-release buckle";
return "";
}
var NUMW = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10 };
function ventsOf(ds) {
var t = String(ds || "").replace(/&amp;/g, "&").replace(/([a-z])([A-Z0-9])/g, "$1 $2").replace(/(\d)([A-Za-z])/g, "$1 $2");
var out = [], seen = {}, m;
var re = /\b(\d{1,2}|one|two|three|four|five|six|seven|eight|nine|ten)\s+((?:(?:large|front|rear|top|chin|brow|closable|adjustable|air|upper|lower|side|cheek)\s+){0,2})(vents?|inlets?|intakes?|extractors?|exhausts?|outlets?)\b/gi;
while ((m = re.exec(t)) && out.length < 4) {
var n = NUMW[m[1].toLowerCase()] || +m[1], noun = m[3].toLowerCase().replace(/s$/, ""), q = m[2].toLowerCase().replace(/\b(large|closable|adjustable)\s+/g, "").trim();
if (!n || n > 20 || seen[q + noun]) continue;
seen[q + noun] = 1; out.push(n + " " + (q ? q + " " : "") + noun + (n === 1 ? "" : "s"));
}
return out.join(", ");
}
function stretchOf(d) {
var s0 = textCell(d.st);
if (s0) return s0;
var m = /([^.]{0,60}\bstretch(?:y|able)?\b(?:\s+(?:panels?|inserts?|zones?|fabric|material))?[^.]{0,40})/i.exec(String(d.ds || ""));
return m ? "Yes: " + esc(m[1].trim()) : "";
}
var VJS = {};
function visorJs(h) {
if (VJS[h]) return VJS[h].d;
var rec = VJS[h] = { d: null };
fetch("/products/" + encodeURIComponent(h) + ".js", { credentials: "same-origin" })
.then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
.then(function (d) { rec.d = d || { variants: [] }; refreshCmp(); });
return null;
}
function refreshCmp() {
var m = $("[data-sy-cmpmodal]"); if (!m || m.hidden) return;
var b = m.querySelector(".sy-mbody"), top = b.scrollTop, lefts = [];
[].forEach.call(b.querySelectorAll("*"), function (el, i) { if (el.scrollLeft) lefts.push([i, el.scrollLeft]); });
b.innerHTML = cmpHtml(); b.scrollTop = top;
var all = b.querySelectorAll("*"); lefts.forEach(function (x) { if (all[x[0]]) all[x[0]].scrollLeft = x[1]; });
}
function visorColours(e) {
var js = visorJs(e.h);
return uniq(e.vars.map(function (v) { return e.colIdx > -1 ? v.o[e.colIdx] : ""; }).filter(Boolean)).map(function (col) {
var jv = js ? (js.variants || []).filter(function (v) { return (v.options || [])[e.colIdx] === col; }) : [];
var price = jv.length ? Math.min.apply(null, jv.map(function (v) { return v.price; })) : null;
var fi = jv.filter(function (v) { return v.featured_image && v.featured_image.src; })[0];
var img = (e.vi && e.vi[col]) || (fi && fi.featured_image.src) || e.img;
return { col: col, price: price, img: img, a: e.vars.some(function (v) { return v.o[e.colIdx] === col && v.a; }) };
});
}
function visorOptions(helmet) {
var vs = (ALL || []).filter(function (e) { return e.ag === "visors" && visorFits(e, helmet); });
if (!vs.length) return '<span class="sy-none">None listed</span>';
S.vpick = S.vpick || {};
return vs.map(function (e) {
var key = helmet.h + "|" + e.h, sel = S.vpick[key], cols = visorColours(e);
var cur = cols.filter(function (c) { return c.col === sel; })[0];
var inKit = S.kit.indexOf(e.h) > -1, sameCol = inKit && S.colSel[e.h] === sel;
var cta = !cur ? "" : sameCol ? '<span class="sy-vin">&#10003; In your kit</span>' :
'<button type="button" class="sy-btn sy-vadd" data-vadd="' + esc(key) + '"' + (cur.a ? "" : " disabled") + ">" +
(cur.a ? (inKit ? "Switch to this colour" : "Add to kit") + (cur.price != null ? " &middot; " + money(cur.price) : "") : "Sold out") + "</button>";
return '<div class="sy-vopt"><a href="' + url(e) + '" target="_blank" rel="noopener">' + esc(e.t) + "</a>" +
'<div class="sy-vsws" role="group" aria-label="Colours">' + cols.map(function (c) {
return '<button type="button" class="sy-vsw' + (c.a ? "" : " is-out") + '" data-vpick="' + esc(key + "|" + c.col) + '" aria-pressed="' + (c.col === sel) + '" title="' + esc(c.col) + '" aria-label="' + esc(c.col) + '">' +
(c.img ? '<img alt="" loading="lazy" src="' + esc(c.img) + '">' : "") + "</button>";
}).join("") + "</div>" +
(cur ? '<p class="sy-vsel">' + esc(cur.col) + "</p>" + cta : "") + "</div>";
}).join("");
}
function cmpHtml() {
var c = catDef(S.cat), meas = bodyFor(c), have = haveFor(c);
var cols = cmpList().map(function (h) {
var it = findItem(h), fit = have ? fitItem(it, meas) : null;
return { it: it, fit: fit, d: fit ? detail(it, fit, meas) : null };
}).filter(function (x) { return x.it; });
var R = [
["Your size", function (x) { return x.fit ? '<span class="sy-lvl sy-lv-' + x.d.key + '"><span class="sy-lvl-k"><i></i>' + esc(x.d.word) + "</span>" + (x.d.size ? '<span class="sy-lvl-v">' + x.d.size + "</span>" : "") + "</span>" : "Add your measurements"; }],
["How it fits", function (x) { return x.d ? '<span class="sy-fsent">' + x.d.text + "</span>" + x.d.note : "—"; }, true],
["Where you sit", function (x) { return x.d && x.d.axes.length ? axesHtml(x.d, x.fit.sugLabel || x.fit.label) : "—"; }, true],
["Availability", function (x) { var st = x.fit ? stockFor(x.fit.v) : null; return st ? stockHtml(st) + (st.when ? '<br><span class="sy-cwhen">' + esc(st.when) + "</span>" : "") : "—"; }],
["Price", function (x) { return money(x.it.p); }],
["Reviews", function (x) { return reviewHtml(x.it, true); }],
c.k === "extras" ? null : ["Protection", function (x) { return x.it.cat === "helmets" && x.it.prot ? esc(x.it.prot) : x.it.noCE ? "Australian brand, CE not required" : esc(x.it.prot || "Not rated"); }],
c.k === "boots" ? ["Boot height", function (x) { return x.it.bh ? esc(x.it.bh) : "Not recorded"; }] :
c.k === "gloves" ? ["Protection built in", function (x) { return gloveArmour(x.it); }] :
c.k === "helmets" || c.acc ? null : ["Armour included", function (x) { return armourList(x.it.ip, x.it.cat, backReady(x.it) || x.it.bp, x.it.cp); }],
c.k === "gloves" ? ["Cuff length", function (x) { return x.it.gl ? esc(x.it.gl) : "Not recorded"; }] : null,
c.k === "helmets" || c.k === "extras" ? null : ["Temperatures", function (x) { return bandSpan(x.it) ? tempHtml(x.it) : "Not recorded"; }],
c.k === "helmets" || c.k === "extras" ? null : ["Waterproof", function (x) { return x.it.wp === true ? "Yes" : x.it.wp === false ? "No" : "Not recorded"; }],
c.k === "extras" ? null : ["Riding style", function (x) { return x.it.rs ? esc(x.it.rs.join(", ")) : "Not recorded"; }],
c.k === "helmets" ? ["Visor options", function (x) { return visorOptions(x.it); }] : null,
c.k === "extras" || c.acc ? null : [c.k === "helmets" ? "Shell and materials" : "Materials", function (x) { return infoCell(x.it, function (d) { return textCell(d.ma) || textCell(d.jm); }); }],
c.k === "helmets" ? ["Fastening", function (x) { return infoCell(x.it, function (d) { return claspOf(d.ds); }); }] : null,
c.k === "helmets" ? ["Vents", function (x) { return infoCell(x.it, function (d) { return d.vn ? esc(d.vn) : ventsOf(d.ds); }); }] : null,
ARMOURED_CATS[c.k] ? ["Stretch panels", function (x) { return infoCell(x.it, stretchOf); }] : null,
c.k === "extras" || c.acc ? null : ["Fit", function (x) { return infoCell(x.it, function (d) { return textCell(d.fi); }); }],
c.k === "extras" || c.acc ? null : ["Feel", function (x) { return infoCell(x.it, function (d) { return textCell(d.fe); }); }],
c.k === "extras" ? null : ["Season", function (x) { return infoCell(x.it, function (d) { return listCell(d.se); }); }]
].filter(Boolean);
var head = '<tr class="is-hd"><th></th>' + cols.map(function (x) {
var v = x.fit && x.fit.v;
return '<th><div class="sy-cph">' + thumb(x.it) + '</div><span class="sy-vend">' + esc(x.it.v) + '</span><span class="sy-cname">' + esc(x.it.t) + "</span>" +
'<div class="sy-cacts"><a class="sy-cview" href="' + url(x.it, v) + '">View' + (x.fit && x.fit.label ? " · size " + esc(x.fit.label) : "") + "</a>" +
'<button type="button" class="sy-linkbtn" data-uncmp="' + esc(x.it.h) + '">Remove</button></div>' + cmpKitBtn(x) + "</th>";
}).join("") + "</tr>";
var rows = R.map(function (r) {
var cells = cols.map(function (x) { return r[1](x); });
var plain = cells.map(function (h) { return h.replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim(); });
var same = plain.every(function (p) { return p === plain[0]; });
return '<tr class="' + (r[2] ? "is-info" : same ? "is-same" : "is-diff") + '"><th>' + esc(r[0]) + "</th>" + cells.map(function (h) { return "<td>" + h + "</td>"; }).join("") + "</tr>";
}).join("");
return '<div class="sy-cmptop"><b>Comparing ' + cols.length + " " + esc(c.n.toLowerCase()) + "</b>" + cmpUndoHtml() + '<label class="sy-mkt"><input type="checkbox" data-sy-hidesame' + (S.hideSame ? " checked" : "") + "> Hide attributes that overlap</label></div>" +
'<div class="sy-cmpwrap' + (S.hideSame ? " is-hidesame" : "") + '"><table class="sy-cmpt" style="--n:' + cols.length + '"><colgroup><col class="sy-colh">' + cols.map(function () { return "<col>"; }).join("") + "</colgroup>" + head + rows + "</table></div>";
}
function cmpKitBtn(x) {
if (!x.fit || x.fit.nofit && !noFit(x.it)) return "";
var it = x.it, inKit = S.kit.indexOf(it.h) > -1;
if (inKit || slotCount(it.cat) !== 1) return '<div class="sy-ckit"><button type="button" class="sy-cardbtn is-primary" data-kit="' + esc(it.h) + '" aria-pressed="' + inKit + '">' + (inKit ? "✓ In your kit" : "Add to kit") + "</button></div>";
var cur = kitItems().filter(function (k) { return k.cat === it.cat; })[0];
return '<div class="sy-ckit sy-kitpair" role="group" aria-label="Add to kit">' +
'<button type="button" class="sy-cardbtn is-lite" data-swap="' + esc(it.h) + '" title="Replace your ' + esc(cur ? cur.t : "") + '">Swap</button>' +
'<button type="button" class="sy-cardbtn is-primary" data-kit="' + esc(it.h) + '" title="Keep both">Add</button></div>';
}
function cmpUndoHtml() {
var u = S.cmpUndo;
if (!u || u.cat !== S.cat) return "";
return '<span class="sy-cundo">' + esc(u.msg) + ' <button type="button" class="sy-linkbtn" data-cmpundo>Undo</button></span>';
}
function cmpSnap(msg) { S.cmpUndo = { cat: S.cat, list: cmpList().slice(), msg: msg, open: !$("[data-sy-cmpmodal]").hidden }; }
function openCmp() {
var m = $("[data-sy-cmpmodal]");
var want = cmpList().filter(function (h) { return !INFO[h]; });
if (want.length) Promise.all(want.map(loadInfo)).then(function () { if (!m.hidden) m.querySelector(".sy-mbody").innerHTML = cmpHtml(); });
m.querySelector(".sy-mbody").innerHTML = cmpHtml();
m.hidden = false;
m.querySelector(".sy-mclose").focus();
cmpList().forEach(function (h) { var it = findItem(h), fit = it && haveFor(catDef(S.cat)) ? fitItem(it, bodyFor(catDef(S.cat))) : null; if (fit && fit.v) askStock(fit.v.id); });
}
function closeCmp() { $("[data-sy-cmpmodal]").hidden = true; }
function kitItems() { return S.kit.map(findItem).filter(Boolean); }
function kitFit(it) { var c = catDef(it.cat); return c && haveFor(c) ? fitItem(it, bodyFor(c)) : null; }
var KIT_CORE = ["jackets", "pants", "gloves", "boots", "helmets"];
var KIT_ORDER = ["helmets", "jackets", "base", "pants", "boots", "gloves", "acc", "extras"];
var KIT_SHARE = { helmets: 30, jackets: 25, base: 8, pants: 20, boots: 15, gloves: 10, acc: 5, extras: 3 };
function kitRank(k) { var i = KIT_ORDER.indexOf(k); return i < 0 ? 99 : i; }
function byKit(a, b) { return kitRank(a.k || a.cat) - kitRank(b.k || b.cat); }
function overBy() { return S.budget ? kitTotal() - S.budget * 100 : 0; }
function bumpCap() { return Math.max(15000, (S.budget || 0) * 10); }
function budgetMin() { return (+CFG.kitBudgetMin || 1500) * 100; }
function armourMap(it) {
var m = {};
(it.ip || []).forEach(function (x) {
var r = /CE Level (\d) (Back|Shoulder|Elbow|Chest|Hip|Knee)/i.exec(x);
if (r) { var k = r[2].charAt(0).toUpperCase() + r[2].slice(1).toLowerCase(); m[k] = Math.max(m[k] || 0, +r[1]); }
});
return m;
}
function kpLevel(it) { var m = /Level (\d) KP/.exec(it.prot || ""); return m ? +m[1] : 0; }
function upgradeWhy(a, b) {
var out = [];
if (PROT_FAMILY[b.cat] === "garment" && protRank(b) < protRank(a)) return out;
if (PROT_FAMILY[b.cat] === "garment") {
var ra = protRank(a), rb = protRank(b);
if (rb > ra && rb >= 2) out.push(esc(String(b.prot).replace(/^CE /, "")) + " protection" + (ra ? " instead of " + esc(String(a.prot).replace(/^CE /, "")) : ""));
}
if (b.cat === "gloves") {
if (kpLevel(b) > kpLevel(a)) out.push("Level " + kpLevel(b) + " knuckle protection");
if (a.ga != null && b.ga != null) {
var ga = gloveSpots(a), add = gloveSpots(b).filter(function (x) { return ga.indexOf(x) < 0; });
if (add.length) out.push(listJoin(add.map(function (x) { return x.toLowerCase(); })) + " protection");
}
}
var ma = armourMap(a), mb = armourMap(b), added = [], up = [];
ARMOUR_ORDER.forEach(function (k) { if (mb[k] && !ma[k]) added.push(k.toLowerCase()); else if (mb[k] > (ma[k] || 0)) up.push(k.toLowerCase()); });
if (added.length) out.push(listJoin(added) + " armour");
if (up.length) out.push("Level 2 " + listJoin(up) + " armour");
return out;
}
function sameKind(a, b) {
var ga = (a.gen || []).filter(function (g) { return g !== "Unisex"; }), gb = (b.gen || []).filter(function (g) { return g !== "Unisex"; });
if (ga.length && gb.length && !ga.some(function (g) { return gb.indexOf(g) > -1; })) return false;
if (a.rs && b.rs && !a.rs.some(function (r) { return b.rs.indexOf(r) > -1; })) return false;
return true;
}
function whyText(why) { return why[0] + (why.length > 1 ? ", plus " + listJoin(why.slice(1)) : ""); }
function kitStretch() {
var best = null;
kitItems().forEach(function (cur) {
var c = catDef(cur.cat); if (!c) return;
candidates(c).forEach(function (r) {
var extra = r.it.p - cur.p;
if (extra <= 0 || extra > bumpCap() || r.it.h === cur.h) return;
if (!sameKind(cur, r.it)) return;
var why = upgradeWhy(cur, r.it); if (!why.length) return;
var tier = PROT_FAMILY[cur.cat] === "garment" && protRank(r.it) > protRank(cur) ? 0 : 1;
if (!best || tier < best.tier || (tier === best.tier && extra < best.extra)) best = { cur: cur, it: r.it, extra: extra, why: why, tier: tier };
});
});
return best;
}
var KIT_WORD = { jackets: "a jacket", base: "a base layer", pants: "pants", gloves: "gloves", boots: "boots", helmets: "a helmet", acc: "an accessory", extras: "an extra" };
function kitTotal() { return kitItems().reduce(function (a, it) { return a + it.p; }, 0); }
function kitHas(k) { return kitItems().some(function (it) { return it.cat === k; }); }
function discountOn() { return !!(CFG.kitOn && CFG.kitCode && CFG.kitText); }
function kitMin() { return Math.max(0, +CFG.kitMin || 0) * 100; }
function kitShort() { var t = kitReady().reduce(function (a, it) { return a + it.p; }, 0); return Math.max(0, kitMin() - t); }
function kitReady() { return kitItems().filter(function (it) { var f = kitFit(it); return f && f.v && f.v.a; }); }
function kitMissingCore() { var r = kitReady(); return KIT_CORE.filter(function (k) { return !r.some(function (it) { return it.cat === k; }); }); }
function kitDiscountEarned() { return discountOn() && !kitMissingCore().length && !kitShort(); }
function candidates(c) {
if (!haveFor(c)) return [];
var rows = rowsFor(c, "own").filter(function (r) { return r.fit.a; });
var good = rows.filter(function (r) { return r.fit.exact && !r.fit.missing; });
return good.length ? good : rows;
}
function popOf(it) {
var maxBs = ITEMS.reduce(function (m, x) { return Math.max(m, x.bs || 0); }, 0) || 1;
var sold = it.bs ? 1 - (it.bs - 1) / maxBs : 0, rev = Math.min(it.rc || 0, 40) / 40;
return sold * 0.7 + rev * 0.3;
}
function fillKit() {
var empty = selCats().filter(function (c) { return !c.acc && !kitHas(c.k); }).sort(byKit);
var slots = empty.map(function (c) { return { c: c, all: candidates(c).filter(function (r) { return !r.it.suit; }) }; }).filter(function (x) { return x.all.length; });
var pools = slots.map(function (x) { return x.all.slice(0, 15); });
var done = function () { S.prefill = "yes"; S.cartMsg = null; };
if (!pools.length) return done();
if (!S.budget) { pools.forEach(function (p) { S.kit.push(p[0].it.h); }); return done(); }
var L = Math.floor((S.budget * 100 - kitTotal()) / 100);
var shareSum = slots.reduce(function (t, x) { return t + (KIT_SHARE[x.c.k] || 10); }, 0);
var target = slots.map(function (x) { return Math.max(1, L * (KIT_SHARE[x.c.k] || 10) / shareSum); });
pools = slots.map(function (x, i) {
var near = x.all.slice().sort(function (a, b) { return Math.abs(a.it.p / 100 - target[i]) - Math.abs(b.it.p / 100 - target[i]); }).slice(0, 8);
return x.all.slice(0, 12).concat(near.filter(function (r) { return x.all.slice(0, 12).indexOf(r) < 0; }));
});
var dollars = function (r) { return Math.ceil(r.it.p / 100); };
var layers = [], cur = { 0: { pop: 0 } };
pools.forEach(function (pool, si) {
var next = {};
Object.keys(cur).forEach(function (k) {
var t = +k, base = cur[k];
pool.forEach(function (r, j) {
var nt = t + dollars(r); if (nt > L) return;
var fair = 1 - Math.min(1, Math.abs(r.it.p / 100 - target[si]) / target[si]);
var pop = base.pop + popOf(r.it) + (r.rank || 0) * 0.25 + fair * 1.2;
if (!next[nt] || next[nt].pop < pop) next[nt] = { pop: pop, from: t, pick: j };
});
});
layers.push(next); cur = next;
});
var totals = Object.keys(cur).map(Number);
if (!totals.length) {
pools.forEach(function (p) { S.kit.push(p.slice().sort(function (a, b) { return a.it.p - b.it.p; })[0].it.h); });
return done();
}
var top = Math.max.apply(null, totals), tol = Math.max(30, L * 0.05), best = top;
totals.forEach(function (t) { if (t >= top - tol && cur[t].pop > cur[best].pop) best = t; });
var picks = [];
for (var i = layers.length - 1, t = best; i >= 0; i--) { var st = layers[i][t]; picks.unshift(pools[i][st.pick].it.h); t = st.from; }
picks.forEach(function (h) { S.kit.push(h); });
done();
}
function slotCount(k) { return kitItems().filter(function (x) { return x.cat === k; }).length; }
function swapIn(h) {
var it = findItem(h); if (!it) return;
S.kit = S.kit.filter(function (k) { var x = findItem(k); return !x || x.cat !== it.cat; });
S.kit.push(h); S.cartMsg = null;
}
function lowestAlready(c, mine) {
if (!mine.length || !haveFor(c)) return false;
var have = Math.min.apply(null, mine.map(function (it) { return it.p; }));
var rows = rowsFor(c, "own").filter(function (r) { return r.fit.a && r.it.p < have && mine.indexOf(r.it) < 0; });
return !rows.length;
}
function slotHtml(c) {
var mine = kitItems().filter(function (it) { return it.cat === c.k; }), cur = S.cat === c.k;
var head = '<button type="button" class="sy-kslot' + (cur ? " is-cur" : "") + (mine.length ? " is-filled" : "") + '" data-slot="' + c.k + '" aria-pressed="' + cur + '">' +
'<span class="sy-kcat">' + esc(c.n) + (mine.length > 1 ? " · " + mine.length : "") + "</span>";
if (!mine.length) {
return head + '<span class="sy-kempty"><i aria-hidden="true">+</i>' + (haveFor(c) ? "Pick " + esc(KIT_WORD[c.k] || c.n.toLowerCase()) : "Needs a measurement") + "</span></button>";
}
var low = overBy() > 0 && lowestAlready(c, mine);
return head + (overBy() > 0 ? (low ? '<span class="sy-kcheap is-low">Already the lowest price</span>' : '<span class="sy-kcheap">Shop other ' + esc(c.n.toLowerCase()) + "</span>") : "") + "</button>" + mine.map(function (it) {
var fit = kitFit(it), v = fit && fit.v, st = v ? stockFor(v) : null;
if (v && v.a) askStock(v.id);
return '<div class="sy-kitem">' + thumb(it) + '<span class="sy-kil"><span class="sy-kin">' + esc(it.t) + "</span>" +
'<span class="sy-kis">' + (fit ? "Size " + esc(fit.label) : "Add your measurements") + " · " + money(it.p) + "</span>" +
(st ? '<span class="sy-kist"><span data-sy-stock="' + v.id + '">' + stockHtml(st) + "</span></span>" : "") + "</span>" +
'<button type="button" class="sy-x" data-unkit="' + esc(it.h) + '" aria-label="Remove ' + esc(it.t) + ' from your kit">&times;</button></div>';
}).join("");
}
function renderKit() {
var box = $("[data-sy-kit]");
var cats = selCats(), items = kitItems();
var groups = cats.concat(CATS.filter(function (c) { return cats.indexOf(c) < 0 && items.some(function (it) { return it.cat === c.k; }); })).sort(byKit);
if (groups.length < 2 && !items.length) { box.innerHTML = ""; renderKitSum(); return; }
var picked = groups.filter(function (c) { return kitHas(c.k); }).length;
var canFill = groups.some(function (c) { return !c.acc && !kitHas(c.k) && candidates(c).length; });
var ask = !S.prefill && !items.length && canFill;
box.innerHTML = '<div class="sy-board"><div class="sy-bhead"><h3>Your kit</h3>' +
'<span class="sy-bacts">' + (!ask && canFill ? '<button type="button" class="sy-linkbtn" data-sy-fill>Fill the empty slots for me</button>' : "") +
(items.length ? '<button type="button" class="sy-linkbtn sy-kclear" data-sy-kclear>Clear kit</button><button type="button" class="sy-btn sy-fitbtn" data-sy-fitcheck>Fit check</button>' : "") + "</span></div>" +
(ask ? '<div class="sy-prefill"><p><b>Want a head start?</b> We can fill each slot with our top pick in your size' + (S.budget ? ", within your budget" : "") + ". Swap anything out after.</p>" +
'<div class="sy-prefillbtns"><button type="button" class="sy-btn" data-sy-fill>Fill my kit</button><button type="button" class="sy-linkbtn" data-sy-nofill>I\'ll pick myself</button></div></div>' : "") +
(canFill ? presetsHtml() : "") +
(function () {
var n = groups.length, first = n <= 4 ? n : Math.ceil(n / 2);
return '<div class="sy-slots is-rows">' + groups.map(function (c, i) {
var per = i < first ? first : n - first;
return '<div class="sy-kcol" style="grid-column:span ' + (12 / Math.max(1, Math.min(per, 4))) + '">' + slotHtml(c) + "</div>";
}).join("") + "</div></div>";
})();
renderKitSum();
}
function kitDispatch(ready) {
var rows = [], i;
for (i = 0; i < ready.length; i++) {
var f = kitFit(ready[i]), st = f && f.v ? STOCK[f.v.id] : null;
if (!st) return { pending: true };
rows.push({ it: ready[i], f: f, st: st });
}
if (!rows.length) return null;
var name = function (r) { return "<b>" + esc(r.it.t) + "</b> (size " + esc(r.f.label) + ")"; };
var the = function (list) { return "the " + list.map(name).join(" and the "); };
var isAre = function (list) { return list.length > 1 ? " are" : " is"; };
var because = function (list) {
var by = {}; list.forEach(function (r) { (by[r.st.src] = by[r.st.src] || []).push(r); });
var out = [];
if (by.supplier) out.push("we'll order in " + the(by.supplier));
if (by.incoming) out.push(the(by.incoming) + isAre(by.incoming) + " on an incoming order");
if (by.backorder) out.push(the(by.backorder) + isAre(by.backorder) + " on backorder" + (by.backorder[0].st.eta ? " (estimated arrival " + esc(by.backorder[0].st.eta) + ")" : ""));
return out.join(", and ");
};
var together = " Everything is dispatched together.";
var cap = function (t) { return t.charAt(0).toUpperCase() + t.slice(1); };
var undated = rows.filter(function (r) { return !r.st.date; });
if (undated.length) {
return { day: "To be confirmed",
text: cap(because(undated)) + ". We'll confirm the date within one business day of your order." + together };
}
var last = rows.reduce(function (a, r) { return r.st.date > a ? r.st.date : a; }, rows[0].st.date);
var today = melbToday();
if (last <= today) return { day: "Today", text: "" };
var slow = rows.filter(function (r) { return r.st.date === last; });
var late = slow.filter(function (r) { return r.st.src !== "stock"; });
var text = !late.length || slow.length === rows.length ? "" : cap(because(late)) + "." + together;
var ord = slow.map(function (r) { return r.st.by; }).filter(Boolean)[0];
if (ord) text += (text ? " " : "") + (ord <= today ? "Order today to make our next supplier order." : "Order by " + fmtDate(ord) + " to make our next supplier order.");
return { day: fmtDay(last), text: text };
}
var FIT_SLOTS = [
{ k: "helmets", cls: "is-head", word: "a helmet" },
{ k: "gloves", cls: "is-handl", word: "gloves" },
{ k: "jackets", alt: "base", cls: "is-torso", word: "a jacket" },
{ k: "gloves", cls: "is-handr", mirror: true, word: "gloves" },
{ k: "pants", cls: "is-legs", word: "pants" },
{ k: "boots", cls: "is-feet", word: "boots" }
];
function fitPieces(k, alt) {
var l = kitItems().filter(function (x) { return x.cat === k; });
return l.length || !alt ? l : kitItems().filter(function (x) { return x.cat === alt; });
}
function fitCheckHtml() {
var cycles = {};
var cells = FIT_SLOTS.map(function (sl) {
var l = fitPieces(sl.k, sl.alt), key = sl.k;
if (!l.length) return '<div class="sy-fc ' + sl.cls + ' is-empty"><span>' + (sl.cls === "is-handr" ? "" : "No " + esc(sl.word.replace(/^an? /, "")) + " yet") + "</span></div>";
var i = (S.fitIdx[key] || 0) % l.length, it = l[i], f = kitFit(it);
if (l.length > 1 && !sl.mirror) cycles[key] = l.length;
var many = l.length > 1 && !sl.mirror, word = esc(catDef(it.cat).n.toLowerCase());
var img = it.img ? '<img alt="' + esc(it.t) + '" src="' + esc(imgFor(it, f && f.v)) + '"' + (sl.mirror ? ' class="is-mirror"' : "") + ">" : "";
return '<div class="sy-fc ' + sl.cls + '">' +
img +
'<span class="sy-fcl' + (sl.mirror ? " is-ghost" : "") + '"' + (sl.mirror ? ' aria-hidden="true"' : "") + ">" + esc(it.t) + (f ? " · " + esc(f.label) : "") + "</span>" +
(many ? '<span class="sy-fcc"><button type="button" class="sy-fcarr" data-fitprev="' + key + '" aria-label="Previous ' + word + '">&lsaquo;</button>' +
"<span>" + (i + 1) + " of " + l.length + "</span>" +
'<button type="button" class="sy-fcarr" data-fitnext="' + key + '" aria-label="Next ' + word + '">&rsaquo;</button></span>' : "") + "</div>";
}).join("");
var items = kitItems(), acc = items.filter(function (x) { return x.cat === "acc" || x.cat === "extras"; });
return '<div class="sy-fctop"><span class="sy-fctl">Product names</span><div class="sy-seg" role="group" aria-label="Product names">' +
'<button type="button" class="sy-segbtn" data-fcnames="1" aria-pressed="' + !S.fcHide + '">Show</button><button type="button" class="sy-segbtn" data-fcnames="0" aria-pressed="' + !!S.fcHide + '">Hide</button></div></div>' +
'<div class="sy-fcwrap' + (acc.length ? " has-acc" : "") + (S.fcHide ? " no-names" : "") + '"><div class="sy-fcgrid">' + cells + "</div>" +
(acc.length ? '<div class="sy-fcacc">' + acc.map(function (x) { var f = kitFit(x); return '<div class="sy-fc"><img alt="' + esc(x.t) + '" src="' + esc(imgFor(x, f && f.v)) + '"><span class="sy-fcl">' + esc(x.t) + "</span></div>"; }).join("") + "</div>" : "") + "</div>" +
'<p class="sy-fcfoot"><b>' + items.length + " piece" + (items.length === 1 ? "" : "s") + " · " + money(kitTotal()) + "</b>" +
(Object.keys(cycles).length ? " Got more than one in a slot? Use the arrows to try each look." : "") + "</p>";
}
function fitCount(key) { var sl = FIT_SLOTS.filter(function (x) { return x.k === key && !x.mirror; })[0]; return sl ? Math.max(1, fitPieces(sl.k, sl.alt).length) : 1; }
function openFitCheck() {
var m = $("[data-sy-fitmodal]"); if (!m) return;
m.querySelector(".sy-mbody").innerHTML = fitCheckHtml();
m.hidden = false; m.querySelector(".sy-mclose").focus();
}
var clearModal = null;
function openClearKit() {
var n = S.kit.length; if (!n) return;
if (!clearModal) {
clearModal = document.createElement("div");
clearModal.className = "sy-modal is-top"; clearModal.hidden = true;
clearModal.setAttribute("role", "alertdialog"); clearModal.setAttribute("aria-modal", "true"); clearModal.setAttribute("aria-label", "Clear your kit");
var host = $("[data-sy-fitmodal]"); (host ? host.parentNode : document.body).appendChild(clearModal);
clearModal.addEventListener("click", function (e) {
var t = e.target.closest ? e.target.closest("button") : null;
if (e.target === clearModal || (t && t.hasAttribute("data-kc-no"))) { closeClearKit(); return; }
if (t && t.hasAttribute("data-kc-yes")) {
S.kit = []; S.pin = []; S.prefill = ""; S.cartMsg = null; S.fitIdx = {};
closeClearKit(); render();
var k = $("[data-sy-kit]"); if (k) window.scrollTo({ top: Math.max(0, k.getBoundingClientRect().top + window.pageYOffset - 90), behavior: "smooth" });
}
});
clearModal.addEventListener("keydown", function (e) { if (e.key === "Escape") { e.stopPropagation(); closeClearKit(); } });
}
clearModal.innerHTML = '<div class="sy-mpanel is-small"><div class="sy-mtop"><b>Clear your kit?</b><button type="button" class="sy-mclose" data-kc-no aria-label="Close">&times;</button></div>' +
'<div class="sy-mbody"><p class="sy-kcp">This takes all ' + n + " piece" + (n === 1 ? "" : "s") + " out of your kit so you can start it again. Your measurements and preferences stay as they are.</p>" +
'<div class="sy-kcbtns"><button type="button" class="sy-btn" data-kc-yes>Yes, clear my kit</button><button type="button" class="sy-linkbtn" data-kc-no>Keep my kit</button></div></div></div>';
clearModal.hidden = false;
clearModal.querySelector("[data-kc-no].sy-linkbtn").focus();
}
function closeClearKit() { if (clearModal) clearModal.hidden = true; var b = $("[data-sy-kclear]"); if (b) b.focus(); }
function closeFitCheck() { var m = $("[data-sy-fitmodal]"); if (m) m.hidden = true; }
function cheapestKit() {
var parts = [], total = 0;
selCats().filter(function (c) { return !c.acc && haveFor(c); }).sort(byKit).forEach(function (c) {
var rows = candidates(c); if (!rows.length) return;
var lo = rows.reduce(function (m, r) { return Math.min(m, r.it.p); }, Infinity);
parts.push({ c: c, p: lo }); total += lo;
});
return { parts: parts, total: total };
}
function budgetHintHtml() {
if (S.budget && ITEMS) {
var ck = cheapestKit();
if (ck.parts.length > 1 && S.budget * 100 < ck.total) {
var one = { helmets: "helmet", jackets: "jacket", base: "base layer", pants: "pants", boots: "boots", gloves: "gloves" };
return '<p class="sy-bhint is-low">The lowest-priced kit in your size right now comes to ' + money(ck.total) + " (" +
ck.parts.map(function (x) { return (one[x.c.k] || x.c.n.toLowerCase()) + " from " + money(x.p); }).join(", ") + "), so " + money(S.budget * 100) + " won't cover every piece.</p>" +
'<button type="button" class="sy-btn is-ghost sy-bset" data-setbudget="' + Math.ceil(ck.total / 100) + '">Make ' + money(Math.ceil(ck.total / 100) * 100) + " your budget</button>";
}
}
var full = KIT_CORE.every(function (k) { return S.sel.indexOf(k) > -1; });
if (!full) return "";
var min = budgetMin();
if (S.budget && S.budget * 100 < min) return '<p class="sy-bhint is-low">For a full kit we suggest a budget of at least ' + money(min) + ". Below that there's less to choose from in each slot.</p>";
if (!S.budget) return '<p class="sy-bhint">We suggest at least ' + money(min) + " for a full kit: helmet, jacket, pants, boots and gloves.</p>";
return "";
}
function extrasFor() {
var kit = kitItems();
if (!kit.some(function (x) { return !catDef(x.cat).acc; })) return [];
var pool = ITEMS.filter(function (it) { return it.cat === "extras" && S.kit.indexOf(it.h) < 0 && it.vars.some(function (v) { return v.a; }); });
var pick = [], add = function (it, why) { if (it && !pick.some(function (p) { return p.it === it; }) && pick.length < 2) pick.push({ it: it, why: why || "" }); };
var byPop = function (a, b) { return (a.bs || 1e9) - (b.bs || 1e9); };
kit.filter(function (x) { return x.cat === "helmets"; }).forEach(function (h) {
add(pool.filter(function (e) { return e.ag === "visors" && visorFits(e, h); }).sort(byPop)[0], "Fits your " + modelName(h));
});
var rj = kit.filter(function (x) { return backReady(x) && isRevit(x); })[0], rv = findItem(RV_HANDLE);
if (rj && rv && S.kit.indexOf(rv.h) < 0) add(rv, (rvSize(rj) ? "Type RV " + rvSize(rj) + " fits your " : "Fits your ") + modelName(rj));
var jk = kit.filter(backReady)[0];
if (jk && !rj) {
var bps = pool.filter(function (e) { return e.ag === "armour" && /back/i.test(e.ty + " " + e.t); }).sort(byPop);
add(bps.filter(function (e) { return e.v && e.v === jk.v; })[0] || bps[0], "For the back pocket in your " + modelName(jk));
}
if (kit.some(function (x) { return /leather/i.test(x.ty + " " + x.t); })) add(pool.filter(function (e) { return e.ag === "care" && /leather/i.test(e.t); }).sort(byPop)[0], "For your leather gear");
var MAIN = { phone: /motorcycle|handlebar|mirror|moto/i, luggage: /bag|pack|duffel/i, security: /lock|alarm/i };
["phone", "luggage", "security"].forEach(function (g) {
var l = pool.filter(function (e) { return e.ag === g; }).sort(byPop);
add(l.filter(function (e) { return MAIN[g].test(e.t); })[0] || l[0]);
});
return pick;
}
function extrasHtml() {
var l = extrasFor(); if (!l.length) return "";
return '<div class="sy-kext"><b>Worth adding</b>' + l.map(function (x) {
var it = x.it;
return '<div class="sy-kexti">' + thumb(it) + '<span class="sy-kexn"><a href="' + url(it) + '" target="_blank" rel="noopener">' + esc(it.t) + "</a><small>" + (x.why ? esc(x.why) + " · " : "") + money(it.p) + "</small></span>" +
'<button type="button" class="sy-cardbtn" data-kit="' + esc(it.h) + '" data-kextra="1">+ Add</button></div>';
}).join("") + "</div>";
}
var STRETCH_KEY = "pmo.sys.stoff", KITSHUT_KEY = "pmo.sys.kitshut";
function stretchOff() { try { return localStorage.getItem(STRETCH_KEY) === "1"; } catch (e) { return false; } }
function renderKitSum() {
if (S.kitShut == null) { try { S.kitShut = localStorage.getItem(KITSHUT_KEY) === "1"; } catch (e) { S.kitShut = false; } }
var box = $("[data-sy-kitsum]"), bar = $("[data-sy-kitbar]");
if (!box) return;
var items = kitItems(), ready = kitReady(), total = kitTotal(), msg = S.cartMsg;
if (!items.length || S.step !== 4) {
box.innerHTML = ""; box.hidden = true;
if (bar) bar.hidden = true;
document.documentElement.classList.remove("sy-has-kitbar");
return;
}
box.hidden = false;
var ae = document.activeElement, keep = ae && box.contains(ae) && ae.hasAttribute("data-sy-budget") ? [ae.selectionStart, ae.selectionEnd] : null;
var readyTotal = ready.reduce(function (a, it) { return a + it.p; }, 0);
var budget = "", stretch = S.budget && overBy() <= 0 && !stretchOff() ? kitStretch() : null;
if (S.budget) {
var diff = S.budget * 100 - total;
budget = '<span class="sy-kbst ' + (diff < 0 ? "is-over" : "is-ok") + '">' + (diff < 0 ? money(-diff) + " over" : money(diff) + " left") + "</span>";
}
var disc = "";
if (discountOn()) {
var miss = kitMissingCore(), short = kitShort(), minTxt = kitMin() ? " on kits of " + money(kitMin()) + " or more" : "";
disc = '<div class="sy-kdisc' + (miss.length || short ? "" : " is-on") + '">' +
(miss.length ? "<b>" + esc(CFG.kitText) + "</b> when you buy a jacket, pants, gloves, boots and a helmet together" + minTxt + ". Still to add: " + esc(listJoin(miss.map(function (k) { return KIT_WORD[k]; }))) + "." :
short ? "<b>" + esc(CFG.kitText) + "</b>" + minTxt + ". Add " + money(short) + " more to your kit to get it." :
"<b>" + esc(CFG.kitText) + "</b> is applied when you add your kit to the cart.") +
"<small>One kit discount per account.</small></div>";
}
var kd = ready.length ? kitDispatch(ready) : null;
box.innerHTML = '<div class="sy-ksum">' +
'<div class="sy-kbudw"><label class="sy-kbud is-top"><span>Budget</span><span class="sy-kbin"><i>$</i><input type="text" inputmode="numeric" autocomplete="off" data-sy-budget="sum" value="' + (S.budget || "") + '" placeholder="Optional"></span>' + budget + "</label>" +
budgetHintHtml() + "</div>" +
'<button type="button" class="sy-ksh" data-sy-kitmin aria-expanded="' + !S.kitShut + '"><b>Your kit</b><span>' + items.length + " piece" + (items.length === 1 ? "" : "s") + '</span><i aria-hidden="true"></i></button>' +
(S.kitShut ? "" : '<ul class="sy-klines">' + items.slice().sort(byKit).map(function (it) {
var f = kitFit(it);
return '<li><span class="sy-kln">' + esc(catDef(it.cat).n) + '<small>' + esc(it.t) + (f ? " · " + esc(f.label) : "") + "</small></span><span>" + money(it.p) + "</span></li>";
}).join("") + "</ul>") +
'<div class="sy-ktot"><span>Total</span><b>' + money(total) + "</b></div>" +
(kd ? '<div class="sy-kwhen">' + (kd.pending ? '<span class="sy-kwp">Working out your dispatch date&hellip;</span>' :
'<div class="sy-kwd"><span>Dispatch date</span><b>' + esc(kd.day) + "</b></div>" +
(kd.text && !S.kitShut ? '<details class="sy-kwx"><summary>How we worked this out</summary><p>' + kd.text + "</p></details>" : "")) + "</div>" : "") +
(S.kitShut ? "" : (
(overBy() > 0 ? '<p class="sy-kover">Tap a piece in your kit to shop other options. The ones that bring you back within budget come first.</p>' : "") +
(stretch && S.stretchX ? '<div class="sy-kstretch is-x"><button type="button" class="sy-linkbtn" data-sy-stback>&lsaquo; Back</button><button type="button" class="sy-linkbtn" data-sy-stoff>Don\'t show again</button></div>' :
stretch ? '<div class="sy-kstretch"><button type="button" class="sy-kstx" data-sy-stx aria-label="Hide">&times;</button><b>' + (stretch.extra <= -overBy() ? "Room for more protection" : "Worth a small budget bump") + "</b>For " + money(stretch.extra) + " more, the <b class=\"sy-pn\">" + esc(stretch.it.t) + "</b> gives you " + whyText(stretch.why) + ", in place of your <b class=\"sy-pn\">" + esc(stretch.cur.t) + "</b>." +
'<div class="sy-kstbtns"><button type="button" class="sy-btn" data-swap="' + esc(stretch.it.h) + '">Swap it in</button>' +
'<button type="button" class="sy-btn is-ghost" data-cmpboth="' + esc(stretch.cur.h) + '" data-cmpwith="' + esc(stretch.it.h) + '">Compare both</button></div></div>' : "") +
disc +
(msg && msg.ok ? '<p class="sy-kitmsg is-ok">Added ' + msg.n + " item" + (msg.n === 1 ? "" : "s") + ' to your cart. <button type="button" class="sy-linkbtn" data-sy-opencart>View cart</button></p>' :
msg && msg.err ? '<p class="sy-kitmsg is-err">We couldn\'t add your kit just now. Try again, or add each piece from its page.</p>' : "") +
(function () {
var nosz = items.filter(function (it) { var f = kitFit(it); return f && f.nofit && !f.v; });
var out = items.length - ready.length - nosz.length;
return (nosz.length ? '<p class="sy-kitnote">Choose a size for your ' + listJoin(nosz.map(function (x) { return "<b>" + esc(x.t) + "</b>"; })) + " to add " + (nosz.length === 1 ? "it" : "them") + ".</p>" : "") +
(out > 0 ? '<p class="sy-kitnote">' + out + " not in stock in your size, so " + (out === 1 ? "it" : "they") + " won't be added.</p>" : "");
})() +
extrasHtml())) +
'<button type="button" class="sy-next sy-kitcart" data-sy-kitcart' + (ready.length && !S.cartBusy ? "" : " disabled") + ">" +
(S.cartBusy ? "Adding&hellip;" : "Add kit to cart · " + money(readyTotal)) + "</button>" +
'<p class="sy-kret"><b>Wrong size?</b> Easily exchange or return unworn gear with its tags and packaging within 30 days, excluding helmets and sale items. <a href="https://peakmotogear.com.au/policies/refund-policy" target="_blank" rel="noopener">Returns policy</a></p>' +
'<div class="sy-kshare"><button type="button" class="sy-outline" data-sy-share><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 13V3m0 0L6.5 6.5M10 3l3.5 3.5M4 10v6.5h12V10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>Share my kit</button>' +
'<button type="button" class="sy-outline" data-sy-gift><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 8h14v3H3zM4.5 11h11v6h-11zM10 8v9M10 8C8.5 4.5 5 5 6 7c.6 1.1 4 1 4 1zm0 0c1.5-3.5 5-3 4-1-.6 1.1-4 1-4 1z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>Send to someone</button></div>' +
'<div class="sy-kbtns"><button type="button" class="sy-btn sy-fitbtn" data-sy-fitcheck>Fit check</button><button type="button" class="sy-linkbtn sy-kmail" data-sy-mailopen>Email me my kit</button></div>' + askHtml() + "</div>";
if (keep) { var nb = box.querySelector("[data-sy-budget]"); if (nb) { nb.focus(); try { nb.setSelectionRange(keep[0], keep[1]); } catch (x) {} } }
if (bar) {
bar.hidden = false;
bar.innerHTML = '<span><b>Your kit</b> · ' + items.length + " piece" + (items.length === 1 ? "" : "s") + " · " + money(total) + "</span>" +
'<button type="button" class="sy-btn" data-sy-kitjump>View kit</button>';
}
document.documentElement.classList.toggle("sy-has-kitbar", !!bar);
}
function openCartDrawer() {
fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (cart) {
document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: cart }, bubbles: true }));
}).catch(function () {}).then(function () {
var d = document.querySelector('[data-drawer="drawer-cart"]');
if (!d) { location.href = "/cart"; return; }
document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
d.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: false }));
});
}
function ping(stage) {
var day = melbToday(), seen = {};
try { seen = JSON.parse(localStorage.getItem("pmo.sys.seen") || "{}"); } catch (e) {}
if (seen.day !== day) seen = { day: day };
if (seen[stage]) return;
seen[stage] = 1;
try { localStorage.setItem("pmo.sys.seen", JSON.stringify(seen)); } catch (e) {}
fetch("/apps/peakmoto/fit/usage", { method: "POST", credentials: "same-origin", keepalive: true, headers: { "content-type": "application/json" }, body: JSON.stringify({ stage: stage }) }).catch(function () {});
}
function addKitToCart() {
var lines = kitItems().map(function (it) { var f = kitFit(it); return f && f.v && f.v.a ? { id: +f.v.id, quantity: 1, properties: { _source: "The Gear Studio" } } : null; }).filter(Boolean);
if (!lines.length) return;
S.cartBusy = true; S.cartMsg = null; renderKitSum();
fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json", accept: "application/json" }, body: JSON.stringify({ items: lines }) })
.then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
.then(function () {
S.cartMsg = { ok: 1, n: lines.length }; ping("cart");
if (kitDiscountEarned()) return fetch("/discount/" + encodeURIComponent(CFG.kitCode), { credentials: "same-origin" }).catch(function () {}).then(openCartDrawer);
openCartDrawer();
})
.catch(function () { S.cartMsg = { err: 1 }; })
.then(function () { S.cartBusy = false; renderKitSum(); });
}
function linkBase() {
var v = new URLSearchParams(location.search).get("view");
return SITE + location.pathname + "?" + (v ? "view=" + encodeURIComponent(v) + "&" : "");
}
function shareIds() {
return kitItems().slice().sort(byKit).map(function (it) { var f = kitFit(it); return f && f.v ? f.v.id : null; }).filter(Boolean);
}
function shareLink(via) {
var q = new URLSearchParams();
q.set("sk", shareIds().join(","));
q.set("via", via);
if (S.shareName) q.set("n", S.shareName);
return linkBase() + q.toString();
}
var VAR_INDEX = null;
function byVariant(id) {
if (!VAR_INDEX) {
VAR_INDEX = {};
(ALL || []).forEach(function (it) { it.vars.forEach(function (v) { VAR_INDEX[v.id] = { it: it, v: v }; }); });
}
return VAR_INDEX[String(id)] || null;
}
function applyLinks() {
if (S.addH) {
var it = findItem(S.addH.h);
if (it) {
if (S.kit.indexOf(it.h) < 0) S.kit.push(it.h);
if (S.sel.indexOf(it.cat) < 0) { S.sel.push(it.cat); saveSel(); }
S.cat = it.cat;
var hit = S.addH.v ? byVariant(S.addH.v) : null;
if (hit && hit.it === it && it.colIdx > -1 && hit.v.o[it.colIdx]) S.colSel[it.h] = hit.v.o[it.colIdx];
S.addNote = it.h;
}
S.addH = null;
try {
var q = new URLSearchParams(location.search); ["add", "av", "src"].forEach(function (k) { q.delete(k); });
history.replaceState(history.state, "", location.pathname + (q.toString() ? "?" + q.toString() : "") + location.hash);
} catch (e) {}
}
if (S.shared) {
S.shared.lines = S.shared.ids.map(byVariant).filter(Boolean);
if (!S.shared.lines.length) S.shared = null;
else ping(S.shared.via === "gift" ? "gift_open" : "share_open");
}
if (S.src) ping(S.src);
}
function noticeBox() {
var box = rootEl.querySelector("[data-sy-notice]");
if (!box) {
box = document.createElement("div");
box.className = "sy-wrap sy-noticewrap"; box.setAttribute("data-sy-notice", ""); box.hidden = true;
var top = $(".sy-top");
if (top) top.insertAdjacentElement("afterend", box); else rootEl.insertBefore(box, rootEl.firstChild);
}
return box;
}
function renderNotice() {
var box = noticeBox(), html = "";
if (S.shared && !S.shared.hidden) html = sharedHtml();
else if (S.addNote) {
var it = findItem(S.addNote);
if (it && S.kit.indexOf(it.h) > -1) html = '<div class="sy-notice"><button type="button" class="sy-notex" data-sy-notex aria-label="Close">&times;</button>' +
"<p><b>" + esc(it.t) + "</b> is in your kit. " +
(S.step === 4 ? "We've sized it for you. Now add the rest of your kit around it." : "Add your measurements and we'll size it, then build the rest of your kit around it.") + "</p></div>";
else S.addNote = null;
}
box.innerHTML = html; box.hidden = !html;
}
function sharedHtml() {
var sh = S.shared, gift = sh.via === "gift", who = sh.name ? esc(sh.name) : "";
var ok = sh.lines.filter(function (x) { return x.v.a; });
var total = ok.reduce(function (n, x) { return n + x.it.p; }, 0);
var head = gift ? (who ? who + " would love this kit" : "Someone would love this kit") : (who ? who + "'s Gear Studio kit" : "A Gear Studio kit");
var sub = gift ? "Their sizes are already picked, so you can add the whole kit to your cart in one go." :
"Built in The Gear Studio and sized for " + (who || "them") + ". Like it? Build your own below. It takes about two minutes.";
var msg = sh.cartMsg;
return '<div class="sy-notice sy-shared"><button type="button" class="sy-notex" data-sy-shx aria-label="Close">&times;</button>' +
'<p class="sy-shhead"><b>' + head + "</b>" + sub + "</p>" +
'<ul class="sy-shlines">' + sh.lines.map(function (x) {
var it = x.it, v = x.v, col = it.colIdx > -1 ? v.o[it.colIdx] : "";
var size = it.sizeIdx > -1 ? "Size " + sizeTextOf(it, v) : "One size";
return '<li><a class="sy-shph" href="' + url(it, v) + '">' + (it.img ? '<img alt="" loading="lazy" src="' + esc(imgFor(it, v)) + '">' : "") + "</a>" +
'<span class="sy-shtx"><a href="' + url(it, v) + '">' + esc(it.t) + "</a><small>" + esc(size) + (col ? " · " + esc(col) : "") +
(v.a ? "" : ' · <em>sold out in this size</em>') + "</small></span><b>" + money(it.p) + "</b></li>";
}).join("") + "</ul>" +
(msg && msg.ok ? '<p class="sy-kitmsg is-ok">Added ' + msg.n + " item" + (msg.n === 1 ? "" : "s") + ' to your cart. <button type="button" class="sy-linkbtn" data-sy-opencart>View cart</button></p>' :
msg && msg.err ? '<p class="sy-kitmsg is-err">We couldn\'t add the kit just now. Try again, or add each piece from its page.</p>' : "") +
'<div class="sy-shbtns"><button type="button" class="sy-next" data-sy-shadd' + (ok.length && !sh.busy ? "" : " disabled") + ">" +
(sh.busy ? "Adding&hellip;" : "Add " + (gift || !who ? "this" : who + "'s") + " kit to cart · " + money(total)) + "</button>" +
(gift ? "" : '<button type="button" class="sy-outline" data-sy-shown>Build my own kit</button>') + "</div>" +
(ok.length < sh.lines.length ? '<p class="sy-kitnote">Pieces sold out in their size won\'t be added.</p>' : "") +
'<p class="sy-kret"><b>Wrong size?</b> Easily exchange or return unworn gear with its tags and packaging within 30 days, excluding helmets and sale items. <a href="https://peakmotogear.com.au/policies/refund-policy" target="_blank" rel="noopener">Returns policy</a></p></div>';
}
function addSharedToCart() {
var sh = S.shared; if (!sh || sh.busy) return;
var lines = sh.lines.filter(function (x) { return x.v.a; }).map(function (x) {
return { id: +x.v.id, quantity: 1, properties: { _source: "The Gear Studio", _via: sh.via } };
});
if (!lines.length) return;
sh.busy = true; sh.cartMsg = null; renderNotice();
fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json", accept: "application/json" }, body: JSON.stringify({ items: lines }) })
.then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
.then(function () { sh.cartMsg = { ok: 1, n: lines.length }; ping("shared_cart"); openCartDrawer(); })
.catch(function () { sh.cartMsg = { err: 1 }; })
.then(function () { sh.busy = false; renderNotice(); });
}
var STYLES = [
{ k: "learner", n: "Learners", su: "Learners", tag: "Top pick for learners" },
{ k: "track", n: "Track", su: "Track", tag: "Most popular for track" },
{ k: "touring", n: "Touring", rs: "Touring", tag: "Most popular for touring" },
{ k: "commute", n: "Commuting", rs: "Urban & Commuting", tag: "Most popular for commuting" },
{ k: "adv", n: "Adventure", rs: "Adventure & Off-Road", tag: "Most popular for adventure" }
];
var PICKS = null;
function stylePick(c, st) {
PICKS = PICKS || {};
var key = c.k + "|" + st.k;
if (key in PICKS) return PICKS[key];
PICKS["#" + c.k] = PICKS["#" + c.k] || (c.acc ? [] : candidates(c).filter(function (r) { return !r.it.suit; }));
var rows = PICKS["#" + c.k];
if (st.su) rows = rows.filter(function (r) { return r.it.su && r.it.su.indexOf(st.su) > -1; });
else rows = rows.filter(function (r) { return r.it.rs && r.it.rs.indexOf(st.rs) > -1; });
var best = rows.filter(function (r) { return r.it.bs; }).sort(function (a, b) { return popOf(b.it) - popOf(a.it); })[0];
return (PICKS[key] = best ? best.it : null);
}
function popTag(it) {
var c = catDef(it.cat); if (!c || c.acc || !ITEMS) return "";
var pref = {}; S.bikes.forEach(function (b) { (BIKE_STYLE[b] || []).forEach(function (x) { pref[x] = 1; }); });
var order = STYLES.slice().sort(function (a, b) { return (pref[b.rs] ? 1 : 0) - (pref[a.rs] ? 1 : 0); });
for (var i = 0; i < order.length; i++) if (stylePick(c, order[i]) === it) return order[i].tag;
return "";
}
function presetsHtml() {
return '<div class="sy-presets"><span>Start from what\'s popular with</span>' + STYLES.map(function (st) {
return '<button type="button" class="sy-preset" data-preset="' + st.k + '">' + esc(st.n) + "</button>";
}).join("") + "</div>";
}
function applyPreset(k) {
var st = STYLES.filter(function (x) { return x.k === k; })[0]; if (!st) return;
selCats().filter(function (c) { return !c.acc && !kitHas(c.k); }).forEach(function (c) { var it = stylePick(c, st); if (it) S.kit.push(it.h); });
S.prefill = "yes"; S.cartMsg = null; ping("preset"); render();
}
var ideaModal = null;
function ideaFooter() {
if (rootEl.querySelector("[data-sy-ideas]")) return;
var f = document.createElement("div");
f.className = "sy-wrap sy-ideas"; f.setAttribute("data-sy-ideas", "");
f.innerHTML = '<p>Spotted something strange, or have an idea? <button type="button" class="sy-linkbtn" data-sy-idea>Send feedback</button></p>';
var m = $("[data-sy-cmpmodal]"); if (m) rootEl.insertBefore(f, m); else rootEl.appendChild(f);
}
var FB_KINDS = [
["feature", "A feature I'd like", "I'd love it if..."],
["off", "Something looks wrong", "What did you see, and where?"],
["unclear", "Something was hard to understand", "What was confusing?"],
["other", "Something else", "Tell us anything"]
];
var FB_KEY = "pmo.sys.fb";
function fbContext() {
var w = window.innerWidth || 1024;
return { kit: S.kit.length, step: S.step, view: S.mode || "", device: w < 768 ? "phone" : w < 1100 ? "tablet" : "desktop" };
}
function sendFeedback(body) {
var ctx = fbContext(); for (var k in ctx) if (!(k in body)) body[k] = ctx[k];
return fetch("/apps/peakmoto/fit/idea", { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json" }, body: JSON.stringify(body) })
.then(function (r) { if (!r.ok) throw new Error(r.status); return r.json().catch(function () { return {}; }); });
}
function betaNote() {
var row = $(".sy-toprow"); if (!row) return;
var h = row.querySelector(".sy-h1"); if (h && !h.querySelector(".sy-betapill")) h.insertAdjacentHTML("beforeend", ' <span class="sy-betapill">Beta</span>');
var off = false; try { off = localStorage.getItem(BETA_KEY) === "1" || sessionStorage.getItem(BETA_KEY) === "1"; } catch (x) {}
if (rootEl.querySelector("[data-sy-beta]") || row.querySelector(".sy-fbtop")) {}
else if (off) betaLink();
else row.insertAdjacentHTML("afterend", '<div class="sy-beta" data-sy-beta><button type="button" class="sy-betax" data-beta-x aria-label="Close">&times;</button>' +
'<p><b>New from Peak Moto.</b> The Gear Studio is our new web app for sizing a whole riding kit, and we\'re testing it with riders now. If something looks off, is hard to follow, or you\'d like it to do more, we\'d love to hear.</p>' +
'<div class="sy-betaacts"><button type="button" class="sy-outline sy-betabtn" data-sy-idea>Give feedback</button><button type="button" class="sy-linkbtn" data-beta-never>Don\'t show this again</button></div></div>');
rootEl.addEventListener("input", function (e) { if (e.target.hasAttribute && e.target.hasAttribute("data-ask-text")) S.fbText = e.target.value; });
rootEl.addEventListener("click", function (e) {
var t = e.target.closest ? e.target.closest("button") : null; if (!t || !rootEl.contains(t)) return;
if (t.hasAttribute("data-beta-x") || t.hasAttribute("data-beta-never")) {
try { (t.hasAttribute("data-beta-never") ? localStorage : sessionStorage).setItem(BETA_KEY, "1"); } catch (x) {}
var nb = rootEl.querySelector("[data-sy-beta]"); if (nb) nb.remove();
betaLink(); return;
}
var r = t.getAttribute("data-ask");
if (r) {
if (S.fbAsk) {
S.fbAsk.r = r; S.fbAsk.back = false;
if (S.fbAsk.id) sendFeedback({ id: S.fbAsk.id, rating: r }).catch(function () {});
} else {
S.fbAsk = { r: r, id: null }; try { localStorage.setItem(FB_KEY, "1"); } catch (x) {}
sendFeedback({ kind: "rating", rating: r }).then(function (d) {
if (!S.fbAsk) return; S.fbAsk.id = d && d.id;
if (S.fbAsk.id && S.fbAsk.r !== r) sendFeedback({ id: S.fbAsk.id, rating: S.fbAsk.r }).catch(function () {});
}).catch(function () {});
}
refreshAsk(); var ta = rootEl.querySelector("[data-ask-text]"); if (ta) ta.focus();
return;
}
if (t.hasAttribute("data-ask-back")) { S.fbAsk.back = true; refreshAsk(); return; }
if (t.hasAttribute("data-ask-skip")) { S.fbAsk.skipped = true; refreshAsk(); return; }
if (t.hasAttribute("data-ask-undo")) { S.fbAsk.skipped = false; refreshAsk(); var tb = rootEl.querySelector("[data-ask-text]"); if (tb) tb.focus(); return; }
if (t.hasAttribute("data-ask-send")) {
var text = String(S.fbText || "").trim(); if (text.length < 2) { var f = rootEl.querySelector("[data-ask-text]"); if (f) f.focus(); return; }
t.disabled = true; t.textContent = "Sending…";
sendFeedback(S.fbAsk.id ? { id: S.fbAsk.id, text: text.slice(0, 1000) } : { kind: "rating", rating: S.fbAsk.r, text: text.slice(0, 1000) })
.then(function () { S.fbAsk.done = true; S.fbText = ""; refreshAsk(); })
.catch(function () { t.disabled = false; t.textContent = "Send"; });
}
});
}
var BETA_KEY = "pmo.sys.betaoff";
function betaLink() {
var row = $(".sy-toprow"); if (!row || row.querySelector(".sy-fbtop")) return;
var html = '<button type="button" class="sy-textbtn sy-fbtop" data-sy-idea><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 4h14v9H8l-4 3v-3H3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>Feedback</button>';
var seg = row.querySelector("[data-sy-mode]");
if (seg) seg.insertAdjacentHTML("beforebegin", html); else row.insertAdjacentHTML("beforeend", html);
}
function askHtml() {
if (S.kit.length < 2) return "";
var a = S.fbAsk;
if (!a || a.back) {
var seen = null; try { seen = localStorage.getItem(FB_KEY); } catch (x) {}
if (!a && seen) return "";
return '<div class="sy-ask" data-sy-ask><p><b>Quick question:</b> how easy was it to build your kit?</p><div class="sy-askbtns">' +
[["easy", "Easy"], ["okay", "Okay"], ["hard", "Hard"]].map(function (x) { return '<button type="button" class="sy-outline" data-ask="' + x[0] + '" aria-pressed="' + !!(a && a.r === x[0]) + '">' + x[1] + "</button>"; }).join("") + "</div></div>";
}
if (a.skipped) return '<div class="sy-ask" data-sy-ask><p class="sy-fsent">No problem, we won\'t ask again. <button type="button" class="sy-linkbtn" data-ask-undo>Undo</button></p></div>';
if (a.done) return '<div class="sy-ask" data-sy-ask><p class="sy-fsent">Thanks, that really helps us make it better.</p></div>';
var q = a.r === "easy" ? "Great! Anything you'd like it to do next?" : a.r === "okay" ? "Thanks! What would have made it easier?" : "Sorry about that. What was hard?";
return '<div class="sy-ask" data-sy-ask><p><b>' + q + '</b></p><textarea data-ask-text rows="2" maxlength="1000" placeholder="Optional">' + esc(S.fbText || "") + "</textarea>" +
'<div class="sy-askbtns"><button type="button" class="sy-btn" data-ask-send>Send</button><button type="button" class="sy-linkbtn" data-ask-skip>No thanks</button><button type="button" class="sy-linkbtn sy-askback" data-ask-back>&lsaquo; Back</button></div></div>';
}
function refreshAsk() { var el = rootEl.querySelector("[data-sy-ask]"); if (el) el.outerHTML = askHtml() || "<span hidden data-sy-ask></span>"; }
function openIdea(kind) {
S.fbKind = kind || S.fbKind || "";
if (!ideaModal) {
ideaModal = document.createElement("div");
ideaModal.className = "sy-modal is-top"; ideaModal.hidden = true;
ideaModal.setAttribute("role", "dialog"); ideaModal.setAttribute("aria-modal", "true"); ideaModal.setAttribute("aria-label", "Send feedback");
var host = $("[data-sy-fitmodal]"); (host ? host.parentNode : rootEl).appendChild(ideaModal);
if ("MutationObserver" in window) new MutationObserver(syncLock).observe(ideaModal, { attributes: true, attributeFilter: ["hidden"] });
ideaModal.addEventListener("click", function (e) {
e.stopPropagation();
var t = e.target.closest ? e.target.closest("button") : null;
if (e.target === ideaModal || (t && (t.classList.contains("sy-mclose") || t.hasAttribute("data-idea-close")))) { ideaModal.hidden = true; return; }
if (t && t.hasAttribute("data-fbk")) {
S.fbKind = t.getAttribute("data-fbk");
[].forEach.call(ideaModal.querySelectorAll("[data-fbk]"), function (b) { b.setAttribute("aria-pressed", String(b === t)); });
var k = FB_KINDS.filter(function (x) { return x[0] === S.fbKind; })[0], ta = ideaModal.querySelector("textarea");
if (k && ta) { ta.placeholder = k[2]; ta.focus(); }
}
});
ideaModal.addEventListener("keydown", function (e) { if (e.key === "Escape") { e.stopPropagation(); ideaModal.hidden = true; } });
ideaModal.addEventListener("submit", function (e) {
e.preventDefault(); e.stopPropagation();
var f = e.target, text = f.querySelector("textarea").value.trim(), email = f.querySelector("input").value.trim();
if (text.length < 3) { f.querySelector("textarea").focus(); return; }
var b = f.querySelector("button[type=submit]"); b.disabled = true; b.textContent = "Sending…";
sendFeedback({ kind: S.fbKind || "other", text: text.slice(0, 1000), email: email.slice(0, 200) })
.then(function () { ideaModal.querySelector(".sy-mbody").innerHTML = '<p class="sy-fsent">Thanks, we\'ve got it.</p><p class="sy-mailh">Every message goes to the Peak Moto team, and it\'s shaping what The Gear Studio does next.</p><div class="sy-mailact"><button type="button" class="sy-outline" data-idea-close>Close</button></div>'; })
.catch(function () { b.disabled = false; b.textContent = "Send"; var m = f.querySelector(".sy-kitmsg"); if (!m) f.insertAdjacentHTML("beforeend", '<p class="sy-kitmsg is-err">We couldn\'t send that just now. Please try again in a minute.</p>'); });
});
}
var cur = FB_KINDS.filter(function (x) { return x[0] === S.fbKind; })[0];
ideaModal.innerHTML = '<div class="sy-mpanel is-small"><div class="sy-mtop"><b>Send feedback</b><button type="button" class="sy-mclose" aria-label="Close">&times;</button></div>' +
'<div class="sy-mbody sy-share"><form><p class="sy-shintro">The Gear Studio is new and we\'re testing it with riders. Tell us what you\'d like it to do, anything that looks off, or anything that was hard to follow.</p>' +
'<div class="sy-fbkinds" role="group" aria-label="What is it about?">' + FB_KINDS.map(function (x) {
return '<button type="button" class="sy-pill" data-fbk="' + x[0] + '" aria-pressed="' + (S.fbKind === x[0]) + '">' + esc(x[1]) + "</button>";
}).join("") + "</div>" +
'<label class="sy-shfield"><span>Your feedback</span><textarea rows="4" maxlength="1000" required placeholder="' + esc(cur ? cur[2] : "Tell us anything") + '"></textarea></label>' +
'<label class="sy-shfield"><span>Your email <i>(optional, if you\'d like to hear back)</i></span><input type="email" maxlength="200" autocomplete="email"></label>' +
'<div class="sy-shacts"><button type="submit" class="sy-btn">Send</button></div></form></div></div>';
ideaModal.hidden = false;
var ta = ideaModal.querySelector("textarea"); if (ta && window.matchMedia("(min-width: 768px)").matches) ta.focus();
}
var MODE_KEY = "pmo.sys.mode";
function prefsOn() {
return !!(S.bikes.length || S.tempOn || S.kitColour || S.wet || S.heights.length || Object.keys(S.minProt || {}).length);
}
function initMode() {
var m = null;
try { m = localStorage.getItem(MODE_KEY); } catch (e) {}
S.mode = m === "advanced" || m === "simple" ? m : prefsOn() ? "advanced" : "simple";
var row = $(".sy-toprow");
if (row && !row.querySelector("[data-sy-mode]")) row.insertAdjacentHTML("beforeend",
'<div class="sy-seg sy-modeseg" data-sy-mode role="group" aria-label="View"><button type="button" class="sy-segbtn" data-mode="simple">Simple</button><button type="button" class="sy-segbtn" data-mode="advanced">Advanced</button></div>');
applyMode();
}
function applyMode() {
rootEl.classList.toggle("is-simple", S.mode === "simple");
$$("[data-mode]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-mode") === S.mode)); });
var bar = $(".sy-resbar"), note = bar && bar.querySelector("[data-sy-simplenote]");
if (bar && !note) { bar.insertAdjacentHTML("beforeend", '<p class="sy-simplenote" data-sy-simplenote hidden>Some of your gear preferences are on. <button type="button" class="sy-linkbtn" data-mode="advanced">Switch to Advanced</button> to see or change them.</p>'); note = bar.querySelector("[data-sy-simplenote]"); }
if (note) note.hidden = true;
}
function cardImg(src) {
return new Promise(function (res) {
if (!src) { res(null); return; }
var u = src.indexOf("//") === 0 ? "https:" + src : src;
u = /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, "$1width=600") : u + (u.indexOf("?") > -1 ? "&" : "?") + "width=600";
var im = new Image();
im.crossOrigin = "anonymous";
im.onload = function () { res(im); };
im.onerror = function () { res(null); };
im.src = u;
});
}
function rr(ctx, x, y, w, h, r) {
ctx.beginPath();
ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
}
function lines(ctx, text, maxW, maxLines) {
var words = String(text).split(/\s+/), out = [], cur = "";
words.forEach(function (w) {
var t = cur ? cur + " " + w : w;
if (ctx.measureText(t).width <= maxW || !cur) cur = t; else { out.push(cur); cur = w; }
});
if (cur) out.push(cur);
if (out.length > maxLines) {
out = out.slice(0, maxLines);
var last = out[maxLines - 1];
while (last.length && ctx.measureText(last + "…").width > maxW) last = last.slice(0, -1);
out[maxLines - 1] = last.replace(/[\s,.-]+$/, "") + "…";
}
return out;
}
function spaced(ctx, text, x, y, gap, align) {
var w = 0, chars = String(text).split("");
chars.forEach(function (c) { w += ctx.measureText(c).width + gap; });
w -= gap;
var cx = align === "right" ? x - w : x;
var a = ctx.textAlign; ctx.textAlign = "left";
chars.forEach(function (c) { ctx.fillText(c, cx, y); cx += ctx.measureText(c).width + gap; });
ctx.textAlign = a;
}
var CARD_WORD = { helmets: "Helmet", jackets: "Jacket", base: "Base layer", pants: "Pants", boots: "Boots", gloves: "Gloves" };
var STORY_FMT = { story: [1080, 1920, "Story"], post: [1080, 1350, "Post"], square: [1080, 1080, "Square"] };
var STORY_LAY = [["kit", "Kit"], ["fit", "Fit Check"]];
var STORY_BG = [["navy", "Navy"], ["light", "Light"], ["clear", "No background"], ["photo", "My photo"]];
var STORY = { f: "story", l: "kit", b: "navy", names: true, prices: true };
var STORY_PHOTO = null, STORY_PHOTO_ID = 0, LOGO = null;
function storyLogo() {
if (LOGO) return LOGO;
var el = [].slice.call(document.querySelectorAll(".logo__img")).filter(function (x) { return /text ?logo/i.test(x.currentSrc || x.src || ""); })[0];
var src = (el && (el.currentSrc || el.src)) || CFG.logo || "https://peakmotogear.com.au/cdn/shop/files/PeakMototextlogo500x.png";
src = src.replace(/([?&])width=\d+/, "$1width=900");
LOGO = new Promise(function (res) {
var im = new Image(); im.crossOrigin = "anonymous";
im.onload = function () { res(im); }; im.onerror = function () { res(null); };
im.src = src;
});
return LOGO;
}
function tintLogo(im, colour) {
var c = document.createElement("canvas"); c.width = im.width; c.height = im.height;
var x = c.getContext("2d"); x.drawImage(im, 0, 0);
x.globalCompositeOperation = "source-in"; x.fillStyle = colour; x.fillRect(0, 0, c.width, c.height);
return c;
}
function storyTheme(b) {
if (b === "light") return { dark: false, text: "#1f2530", sub: "#5c6879", acc: "#c46c47", panel: "#ffffff", line: "rgba(31,37,48,.12)" };
return { dark: true, text: "#ffffff", sub: "rgba(255,255,255,.78)", acc: "#f2b79c", panel: b === "navy" ? "rgba(255,255,255,.1)" : "rgba(16,22,32,.58)", line: "rgba(255,255,255,.18)", shadow: b !== "navy" };
}
function coverDraw(ctx, im, W, H) {
var s = Math.max(W / im.width, H / im.height), w = im.width * s, h = im.height * s;
ctx.drawImage(im, (W - w) / 2, (H - h) / 2, w, h);
}
function sizeChip(it, v) {
var size = v ? (it.sizeIdx > -1 ? "Size " + sizeTextOf(it, v) : "One size") : "";
var col = v && it.colIdx > -1 ? v.o[it.colIdx] : "";
return [size, col].filter(Boolean).join(" · ");
}
function topStyle(items) {
var n = {};
items.forEach(function (it) { (it.rs || []).forEach(function (r) { n[r] = (n[r] || 0) + 1; }); });
var best = Object.keys(n).sort(function (a, b) { return n[b] - n[a]; })[0];
return best || "";
}
function bestRating(items) {
var g = items.filter(function (it) { return PROT_FAMILY[it.cat] === "garment" && /^CE A/.test(it.prot || ""); })
.sort(function (a, b) { return protRank(b) - protRank(a); })[0];
return g ? g.prot : "";
}
function drawCard() {
var o = STORY, dim = STORY_FMT[o.f] || STORY_FMT.story, W = dim[0], H = dim[1];
var all = kitItems().slice().sort(byKit).map(function (it) { var f = kitFit(it); return { it: it, v: f && f.v }; });
var font = (getComputedStyle(rootEl).fontFamily || "sans-serif");
var ready = document.fonts && document.fonts.load ? Promise.all(["400 28px ", "600 28px ", "700 64px "].map(function (s) { return document.fonts.load(s + font).catch(function () {}); })) : Promise.resolve();
var shown;
if (o.l === "fit") shown = FIT_SLOTS.map(function (sl) {
var l = fitPieces(sl.k, sl.alt); if (!l.length) return null;
var it = l[(S.fitIdx[sl.k] || 0) % l.length], f = kitFit(it);
return { it: it, v: f && f.v, sl: sl };
});
else if (o.l === "stats") shown = all.slice(0, 6);
else shown = all.length > 6 ? all.slice(0, 5) : all;
return ready.then(function () {
return Promise.all([storyLogo()].concat(shown.map(function (x) { return x ? cardImg(imgFor(x.it, x.v)) : null; })));
}).then(function (got) {
var logo = got[0], imgs = got.slice(1), T = storyTheme(o.b);
var c = document.createElement("canvas"); c.width = W; c.height = H;
var ctx = c.getContext("2d");
var F = function (w, s) { return w + " " + s + "px " + font; };
var P = 72, NAVY = "#3a506b", INK = "#1f2530", ACC = "#d2815f";
if (o.b === "navy") { ctx.fillStyle = NAVY; ctx.fillRect(0, 0, W, H); }
else if (o.b === "light") { ctx.fillStyle = "#f3efe9"; ctx.fillRect(0, 0, W, H); }
else if (o.b === "photo") {
if (STORY_PHOTO) {
coverDraw(ctx, STORY_PHOTO, W, H);
var g = ctx.createLinearGradient(0, 0, 0, H);
g.addColorStop(0, "rgba(10,14,22,.62)"); g.addColorStop(.28, "rgba(10,14,22,.12)");
g.addColorStop(.62, "rgba(10,14,22,.12)"); g.addColorStop(1, "rgba(10,14,22,.72)");
ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
} else { ctx.fillStyle = NAVY; ctx.fillRect(0, 0, W, H); }
}
var shade = function (on) {
if (on && T.shadow) { ctx.shadowColor = "rgba(0,0,0,.45)"; ctx.shadowBlur = 14; ctx.shadowOffsetY = 2; }
else { ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0; }
};
ctx.textBaseline = "alphabetic";
var safeT = o.f === "story" ? 200 : 64, safeB = o.f === "story" ? 230 : 56;
var brandY = safeT;
shade(true);
if (logo) {
var lh = 72, lw = logo.width * lh / logo.height;
if (lw > 520) { lw = 520; lh = logo.height * lw / logo.width; }
ctx.drawImage(tintLogo(logo, T.dark ? "#ffffff" : NAVY), P, brandY, lw, lh);
} else { ctx.fillStyle = T.text; ctx.font = F(600, 32); spaced(ctx, "PEAK MOTO", P, brandY + 40, 9); }
ctx.fillStyle = T.acc; ctx.font = F(600, 24); spaced(ctx, "THE GEAR STUDIO", W - P, brandY + 46, 4, "right");
var ty = brandY + (o.f === "square" ? 150 : 175);
ctx.fillStyle = T.text; ctx.font = F(700, o.f === "square" ? 60 : 72);
ctx.fillText(lines(ctx, S.shareName ? S.shareName + "'s riding kit" : "My riding kit", W - 2 * P, 1)[0], P, ty);
ctx.fillStyle = T.sub; ctx.font = F(400, 30);
var subl = o.l === "fit" ? "My Fit Check, sized to fit" : all.length + " piece" + (all.length === 1 ? "" : "s") + ", each sized to fit";
ctx.fillText(subl, P, ty + 50);
shade(false);
var footY = H - safeB;
shade(true);
if (o.prices) {
ctx.fillStyle = T.sub; ctx.font = F(400, 26); ctx.fillText("Total", P, footY - 64);
ctx.fillStyle = T.text; ctx.font = F(700, 60); ctx.fillText(money(kitTotal()), P, footY);
}
ctx.textAlign = "right";
ctx.fillStyle = T.sub; ctx.font = F(400, 24); ctx.fillText("Build yours at", W - P, footY - 44);
ctx.fillStyle = T.text; ctx.font = F(600, 34); ctx.fillText("peakmotogear.com.au", W - P, footY);
ctx.textAlign = "left";
shade(false);
var top = ty + 100, bottom = footY - 120;
if (o.l === "fit") drawFit(ctx, shown, imgs, top, bottom);
else if (o.l === "stats") drawStats(ctx, all, shown, imgs, top, bottom);
else drawTiles(ctx, all, shown, imgs, top, bottom);
var png = o.b === "clear";
return new Promise(function (res) { c.toBlob(function (b) { res(b); }, png ? "image/png" : "image/jpeg", 0.92); });
function drawTiles(ctx, items, shown, imgs, top, bottom) {
var n = items.length > 6 ? 6 : items.length, cols = n <= 3 ? 1 : 2, rows = Math.ceil(n / cols), gap = 22;
var tw = (W - 2 * P - (cols - 1) * gap) / cols;
var cap = cols === 1 ? (n === 1 ? 420 : n === 2 ? 360 : 300) : (o.f === "story" ? 320 : 260);
var th = Math.min(cap, (bottom - top - (rows - 1) * gap) / rows);
var y0 = top + Math.max(0, ((bottom - top) - (rows * th + (rows - 1) * gap)) / 2);
for (var i = 0; i < n; i++) {
var x = P + (i % cols) * (tw + gap), y = y0 + Math.floor(i / cols) * (th + gap);
ctx.fillStyle = "#fff"; rr(ctx, x, y, tw, th, 18); ctx.fill();
if (items.length > 6 && i === 5) {
ctx.fillStyle = NAVY; ctx.font = F(700, 52); ctx.textAlign = "center";
ctx.fillText("+" + (items.length - 5), x + tw / 2, y + th / 2 + 4);
ctx.font = F(400, 26); ctx.fillStyle = "#5c6879"; ctx.fillText("more pieces", x + tw / 2, y + th / 2 + 44);
ctx.textAlign = "left";
continue;
}
var it = shown[i].it, v = shown[i].v, im = imgs[i];
var pad = 18, side = cols === 1 ? th - 2 * pad : Math.min(th - 2 * pad, o.f === "story" ? 210 : 172);
var iy = y + (th - side) / 2;
ctx.fillStyle = "#f4f6f8"; rr(ctx, x + pad, iy, side, side, 12); ctx.fill();
if (im) {
var s = Math.min((side - 16) / im.width, (side - 16) / im.height), iw = im.width * s, ih = im.height * s;
ctx.drawImage(im, x + pad + (side - iw) / 2, iy + (side - ih) / 2, iw, ih);
}
var tx = x + pad + side + 22, tW = x + tw - pad - tx;
var cat = catDef(it.cat);
ctx.fillStyle = ACC; ctx.font = F(600, cols === 1 ? 22 : 19);
spaced(ctx, String(CARD_WORD[it.cat] || (cat ? cat.n : "")).toUpperCase(), tx, y + pad + 28, 2);
var lhh = cols === 1 ? 37 : 31;
if (o.names) {
ctx.fillStyle = INK; ctx.font = F(600, cols === 1 ? 30 : 25);
lines(ctx, it.t, tW, 2).forEach(function (l, k) { ctx.fillText(l, tx, y + pad + 68 + k * lhh); });
}
var chip = sizeChip(it, v), by = y + th - pad - 4, price = o.prices ? money(it.p) : "";
if (cols === 1) {
var pw = 0;
if (price) { ctx.font = F(700, 30); ctx.fillStyle = INK; ctx.textAlign = "right"; ctx.fillText(price, x + tw - pad, by); pw = ctx.measureText(price).width; ctx.textAlign = "left"; }
if (chip) {
ctx.font = F(500, 22);
var cl = lines(ctx, chip, Math.max(60, tW - pw - 36), 1)[0], cw = ctx.measureText(cl).width + 24;
ctx.fillStyle = "#eef1f5"; rr(ctx, tx, by - 29, cw, 38, 19); ctx.fill();
ctx.fillStyle = NAVY; ctx.fillText(cl, tx + 12, by - 3);
}
} else {
if (price) { ctx.font = F(700, 26); ctx.fillStyle = INK; ctx.fillText(price, tx, by); }
if (chip) {
ctx.font = F(500, 19);
var cy = price ? by - 70 : by - 26;
var cl2 = lines(ctx, chip, tW - 24, 1)[0], cw2 = ctx.measureText(cl2).width + 24;
ctx.fillStyle = "#eef1f5"; rr(ctx, tx, cy, cw2, 34, 17); ctx.fill();
ctx.fillStyle = NAVY; ctx.fillText(cl2, tx + 12, cy + 23);
}
}
}
}
function drawFit(ctx, slots, imgs, top, bottom) {
var rowsDef = [["is-head"], ["is-handl", "is-torso", "is-handr"], ["is-legs"], ["is-feet"]];
var weight = [0.22, 0.31, 0.27, 0.2], gap = o.names || o.prices ? 20 : 4;
var byCls = {};
slots.forEach(function (x, i) { if (x) byCls[x.sl.cls] = { x: x, im: imgs[i] }; });
var keep = rowsDef.map(function (row, ri) { return row.some(function (c) { return byCls[c]; }) ? ri : -1; }).filter(function (ri) { return ri > -1; });
var wsum = keep.reduce(function (a, ri) { return a + weight[ri]; }, 0) || 1;
var avail = bottom - top - gap * Math.max(0, keep.length - 1);
var lab = o.names || o.prices, gs = lab ? 0.45 : 0.6;
var maxMain = (W - 2 * P) * (lab ? 0.34 : o.f === "story" ? 0.5 : 0.42), cap = [0.7, 1, 0.9, 0.75], rhs = keep.map(function (ri) { return Math.min(avail * weight[ri] / wsum, maxMain * cap[ri]); });
var CX = lab ? P + (maxMain * (1 + 2 * gs) + 2 * gap) / 2 : W / 2;
var used = rhs.reduce(function (a, b) { return a + b; }, 0) + gap * Math.max(0, keep.length - 1);
var y = top + Math.max(0, (bottom - top - used) / 2);
keep.forEach(function (ri, k) {
var row = rowsDef[ri], rh = rhs[k], main = rh;
row.forEach(function (cls) {
var hit = byCls[cls], side = cls === "is-handl" || cls === "is-handr" ? main * gs : main;
var cx = cls === "is-handl" ? CX - main / 2 - gap - side : cls === "is-handr" ? CX + main / 2 + gap : CX - side / 2;
var cy = y + (rh - side) / 2;
if (!hit) return;
ctx.fillStyle = "#fff"; rr(ctx, cx, cy, side, side, 18); ctx.fill();
var im = hit.im;
if (im) {
var s = Math.min((side - 24) / im.width, (side - 24) / im.height), iw = im.width * s, ih = im.height * s;
ctx.save();
if (hit.x.sl.mirror) { ctx.translate(cx + side, 0); ctx.scale(-1, 1); ctx.drawImage(im, (side - iw) / 2, cy + (side - ih) / 2, iw, ih); }
else ctx.drawImage(im, cx + (side - iw) / 2, cy + (side - ih) / 2, iw, ih);
ctx.restore();
}
if (hit.x.sl.mirror) return;
var chip = hit.x.v && hit.x.it.sizeIdx > -1 ? sizeTextOf(hit.x.it, hit.x.v) : "";
if (chip) {
ctx.font = F(600, 22); var cw = ctx.measureText(chip).width + 24;
ctx.fillStyle = NAVY; rr(ctx, cx + side - cw - 10, cy + side - 48, cw, 38, 19); ctx.fill();
ctx.fillStyle = "#fff"; ctx.fillText(chip, cx + side - cw + 2, cy + side - 21);
}
if ((o.names || o.prices) && cls !== "is-handl") {
var tx = cls === "is-torso" && byCls["is-handr"] ? cx + side + gap + side * gs + 24 : cx + side + 24;
var tW = W - P - tx;
if (tW < 130) return;
shade(true);
var ly = cy + side / 2 - 10;
if (o.names) { ctx.fillStyle = T.text; ctx.font = F(600, 28); lines(ctx, hit.x.it.t, tW, 2).forEach(function (l, k) { ctx.fillText(l, tx, ly + k * 34); }); ly += 76; }
if (o.prices) { ctx.fillStyle = T.sub; ctx.font = F(600, 28); ctx.fillText(money(hit.x.it.p), tx, ly); }
shade(false);
}
});
y += rh + gap;
});
}
function drawStats(ctx, items, shown, imgs, top, bottom) {
var its = items.map(function (x) { return x.it; });
var stats = [["Pieces", String(items.length)]];
if (o.prices) stats.push(["Kit total", money(kitTotal())]);
var ce = bestRating(its); if (ce) stats.push(["Abrasion rating", ce]);
var rs = topStyle(its); if (rs) stats.push(["Built for", rs]);
stats.push(["Sized to", "My measurements"]);
stats = stats.slice(0, 4);
var cols = 2, gap = 22, rows = Math.ceil(stats.length / cols), sw = (W - 2 * P - gap) / 2, sh = o.f === "square" ? 150 : 190;
var y = top;
stats.forEach(function (s, i) {
var x = P + (i % cols) * (sw + gap), yy = y + Math.floor(i / cols) * (sh + gap);
ctx.fillStyle = T.panel; rr(ctx, x, yy, sw, sh, 20); ctx.fill();
ctx.fillStyle = T.acc; ctx.font = F(600, 21); spaced(ctx, s[0].toUpperCase(), x + 28, yy + 48, 2);
ctx.fillStyle = T.text; var big = s[1].length > 10 ? 40 : 64; ctx.font = F(700, big);
lines(ctx, s[1], sw - 56, 2).forEach(function (l, k) { ctx.fillText(l, x + 28, yy + (big > 50 ? 128 : 104) + k * 46); });
});
var ty2 = y + rows * (sh + gap) + 18, left = bottom - ty2;
if (left < 120) return;
var n = shown.length, tg = 16, ts = Math.min((W - 2 * P - (Math.min(n, 3) - 1) * tg) / Math.min(n, 3), n > 3 ? (left - tg) / 2 : left, 300);
var per = n > 3 ? 3 : n, rowsT = Math.ceil(n / per), used = rowsT * ts + (rowsT - 1) * tg;
var yT = ty2 + Math.max(0, (left - used) / 2);
for (var i = 0; i < n; i++) {
var r = Math.floor(i / per), inRow = Math.min(per, n - r * per), rowW = inRow * ts + (inRow - 1) * tg;
var x = (W - rowW) / 2 + (i % per) * (ts + tg), yy = yT + r * (ts + tg);
ctx.fillStyle = "#fff"; rr(ctx, x, yy, ts, ts, 18); ctx.fill();
var im = imgs[i];
if (im) { var s2 = Math.min((ts - 24) / im.width, (ts - 24) / im.height); ctx.drawImage(im, x + (ts - im.width * s2) / 2, yy + (ts - im.height * s2) / 2, im.width * s2, im.height * s2); }
if (o.names) {
ctx.font = F(500, 18); var nm = lines(ctx, modelName(shown[i].it), ts - 24, 1)[0], nw = ctx.measureText(nm).width + 20;
ctx.fillStyle = "rgba(255,255,255,.92)"; rr(ctx, x + (ts - nw) / 2, yy + ts - 42, nw, 32, 16); ctx.fill();
ctx.fillStyle = INK; ctx.fillText(nm, x + (ts - nw) / 2 + 10, yy + ts - 20);
}
}
}
});
}
var shareModal = null, shareCard = null, cardTimer = null;
function shareGiftText() {
return "Here's the riding gear I love from Peak Moto. I've already selected the sizes and colours to make it easier to add the whole kit to cart \uD83D\uDE09";
}
function openShare(mode) {
if (!shareIds().length) return;
S.shareMode = mode; S.shareMsg = ""; S.shareText = S.shareText || shareGiftText();
if (!shareModal) {
shareModal = document.createElement("div");
shareModal.className = "sy-modal is-top"; shareModal.hidden = true;
shareModal.setAttribute("role", "dialog"); shareModal.setAttribute("aria-modal", "true");
var host = $("[data-sy-fitmodal]"); (host ? host.parentNode : rootEl).appendChild(shareModal);
shareModal.addEventListener("click", function (e) {
e.stopPropagation();
var t = e.target.closest ? e.target.closest("button") : null;
if (e.target === shareModal || (t && t.classList.contains("sy-mclose"))) { closeShare(); return; }
if (!t) return;
var so = t.getAttribute("data-so");
if (so) {
var kv = so.split(":");
if (kv[0] === "names" || kv[0] === "prices") STORY[kv[0]] = kv[1] === "1"; else STORY[kv[0]] = kv[1];
if (kv[0] === "b" && kv[1] === "photo" && !STORY_PHOTO) pickPhoto();
renderShare(); makeCard(); return;
}
var act = t.getAttribute("data-sh");
if (act) shareAct(act);
});
shareModal.addEventListener("input", function (e) {
e.stopPropagation();
if (e.target.hasAttribute("data-sh-name")) {
S.shareName = e.target.value.replace(/[^\p{L}\p{M}' .-]/gu, "").trim().slice(0, 30);
if (S.shareMode === "card") { clearTimeout(cardTimer); cardTimer = setTimeout(makeCard, 450); }
}
if (e.target.hasAttribute("data-sh-text")) S.shareText = e.target.value;
});
shareModal.addEventListener("keydown", function (e) { if (e.key === "Escape") { e.stopPropagation(); closeShare(); } });
}
if ("MutationObserver" in window && !shareModal.__obs) { shareModal.__obs = 1; new MutationObserver(syncLock).observe(shareModal, { attributes: true, attributeFilter: ["hidden"] }); }
shareModal.setAttribute("aria-label", mode === "card" ? "Share my kit" : "Send my kit to someone");
renderShare();
shareModal.hidden = false;
var f = shareModal.querySelector("[data-sh-name]"); if (f && window.matchMedia("(min-width: 768px)").matches) f.focus();
if (mode === "card") makeCard();
}
function closeShare() { if (shareModal) shareModal.hidden = true; }
function canShareFiles() {
try { return !!(navigator.canShare && navigator.share && navigator.canShare({ files: [new File([""], "kit.jpg", { type: "image/jpeg" })] })); } catch (e) { return false; }
}
function renderShare() {
var card = S.shareMode === "card";
var name = '<label class="sy-shfield"><span>Your first name <i>(optional)</i></span><input type="text" data-sh-name maxlength="30" autocomplete="given-name" value="' + esc(S.shareName || "") + '" placeholder="So they know it\'s from you"></label>';
var note = '<p class="sy-shnote">The link opens your kit with your sizes picked. It doesn\'t include your measurements.</p>';
var msg = S.shareMsg ? '<p class="sy-shmsg">' + esc(S.shareMsg) + "</p>" : "";
var body = card ?
name + storyControls() + '<div class="sy-shprev" data-sh-prev style="aspect-ratio:' + STORY_FMT[STORY.f][0] + "/" + STORY_FMT[STORY.f][1] + ";width:min(100%,calc(52vh*" + STORY_FMT[STORY.f][0] + "/" + STORY_FMT[STORY.f][1] + '))"' + (STORY.b === "clear" ? ' data-clear' : "") + '><span class="sy-kwp">Making your picture&hellip;</span></div>' +
'<div class="sy-shacts">' + (canShareFiles() ? '<button type="button" class="sy-btn" data-sh="sharecard">Share</button>' : "") +
'<button type="button" class="' + (canShareFiles() ? "sy-outline" : "sy-btn") + '" data-sh="save">Save image</button>' +
'<button type="button" class="sy-outline" data-sh="copycard">Copy link</button></div>' + msg + note :
'<p class="sy-shintro">Send your kit to someone who might gift it to you.</p>' + name +
'<label class="sy-shfield"><span>Your message</span><textarea data-sh-text rows="3">' + esc(S.shareText) + "</textarea></label>" +
'<div class="sy-shacts">' + (navigator.share ? '<button type="button" class="sy-btn" data-sh="sendnative">Share</button>' : "") +
'<button type="button" class="sy-outline" data-sh="whatsapp">WhatsApp</button>' +
'<button type="button" class="sy-outline" data-sh="sms">Text message</button>' +
'<button type="button" class="sy-outline" data-sh="email">Email</button>' +
'<button type="button" class="sy-outline" data-sh="copygift">Copy link</button></div>' + msg + note;
shareModal.innerHTML = '<div class="sy-mpanel is-small"><div class="sy-mtop"><b>' + (card ? "Share my kit" : "Send to someone") + '</b><button type="button" class="sy-mclose" aria-label="Close">&times;</button></div>' +
'<div class="sy-mbody sy-share">' + body + "</div></div>";
if (card && shareCard) showCard();
}
var photoInput = null;
function pickPhoto() {
if (!photoInput) {
photoInput = document.createElement("input");
photoInput.type = "file"; photoInput.accept = "image/*"; photoInput.hidden = true;
rootEl.appendChild(photoInput);
photoInput.addEventListener("cancel", clearResume);
photoInput.addEventListener("change", function () {
clearResume();
var file = photoInput.files && photoInput.files[0]; if (!file) return;
var im = new Image();
im.onload = function () { STORY_PHOTO = im; STORY_PHOTO_ID++; STORY.b = "photo"; renderShare(); makeCard(); };
im.src = URL.createObjectURL(file);
photoInput.value = "";
});
}
try { sessionStorage.setItem(RESUME_KEY, JSON.stringify({ m: S.shareMode, y: window.pageYOffset, t: Date.now() })); } catch (x) {}
photoInput.click();
}
var RESUME_KEY = "pmo.sys.resume";
function clearResume() { try { sessionStorage.removeItem(RESUME_KEY); } catch (x) {} }
function resumeAfterPhoto() {
var r = null; try { r = JSON.parse(sessionStorage.getItem(RESUME_KEY) || "null"); } catch (x) {}
clearResume();
if (!r || Date.now() - r.t > 10 * 60 * 1000 || S.step !== 4) return;
window.scrollTo(0, r.y || 0);
if (r.m) openShare(r.m);
}
function storyControls() {
var seg = function (label, key, opts) {
return '<div class="sy-shrow"><span>' + label + '</span><div class="sy-seg sy-pillseg is-mini" role="group" aria-label="' + label + '">' + opts.map(function (x) {
return '<button type="button" class="sy-segbtn" data-so="' + key + ":" + x[0] + '" aria-pressed="' + (String(STORY[key]) === String(x[0]) || (typeof STORY[key] === "boolean" && (STORY[key] ? "1" : "0") === x[0])) + '">' + esc(x[1]) + "</button>";
}).join("") + "</div></div>";
};
return '<div class="sy-shopts">' +
seg("Size", "f", Object.keys(STORY_FMT).map(function (k) { return [k, STORY_FMT[k][2]]; })) +
seg("Layout", "l", STORY_LAY) +
seg("Background", "b", STORY_BG) +
seg("Names", "names", [["1", "Show"], ["0", "Hide"]]) +
seg("Prices", "prices", [["1", "Show"], ["0", "Hide"]]) +
(STORY.b === "photo" ? '<button type="button" class="sy-linkbtn sy-shphoto" data-sh="photo">' + (STORY_PHOTO ? "Change photo" : "Choose a photo") + '</button><span class="sy-shpnote">Your photo stays on your device.</span>' : "") +
"</div>";
}
function showCard() {
var p = shareModal && shareModal.querySelector("[data-sh-prev]"); if (!p || !shareCard) return;
if (shareCard.url) URL.revokeObjectURL(shareCard.url);
shareCard.url = URL.createObjectURL(shareCard.blob);
p.innerHTML = '<img alt="Your kit picture" src="' + shareCard.url + '">';
}
function makeCard() {
var sig = shareIds().join(",") + "|" + (S.shareName || "") + "|" + kitTotal() + "|" + [STORY.f, STORY.l, STORY.b, STORY.names, STORY.prices, STORY_PHOTO_ID, JSON.stringify(S.fitIdx || {})].join("|");
if (shareCard && shareCard.sig === sig) { showCard(); return Promise.resolve(shareCard); }
return drawCard().then(function (blob) {
if (!blob) throw new Error("no card");
shareCard = { sig: sig, blob: blob }; showCard(); return shareCard;
}).catch(function () {
var p = shareModal && shareModal.querySelector("[data-sh-prev]");
if (p) p.innerHTML = '<span class="sy-kwp">We couldn\'t make the picture just now. You can still copy the link.</span>';
});
}
function copyText(t) {
if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t);
return new Promise(function (res, rej) {
var a = document.createElement("textarea"); a.value = t; a.setAttribute("readonly", ""); a.style.position = "fixed"; a.style.opacity = "0";
document.body.appendChild(a); a.select();
try { document.execCommand("copy") ? res() : rej(); } catch (e) { rej(e); }
a.remove();
});
}
function shareMsg(t) { S.shareMsg = t; var m = shareModal.querySelector(".sy-shmsg"); if (m) m.textContent = t; else { var a = shareModal.querySelector(".sy-shacts"); if (a) a.insertAdjacentHTML("afterend", '<p class="sy-shmsg">' + esc(t) + "</p>"); } }
function shareAct(act) {
var gift = S.shareMode === "gift", link = shareLink(gift ? "gift" : "share");
var text = gift ? (S.shareText || shareGiftText()).trim() : "Here's the riding kit I built in the Peak Moto Gear Studio.";
if (act === "photo") { pickPhoto(); return; }
ping(gift ? "gift" : "card");
if (act === "copycard" || act === "copygift") {
copyText(link).then(function () { shareMsg("Link copied. Paste it anywhere."); }, function () { shareMsg(link); });
return;
}
var fname = "my-peak-moto-kit." + (STORY.b === "clear" ? "png" : "jpg"), ftype = STORY.b === "clear" ? "image/png" : "image/jpeg";
if (act === "save") {
makeCard().then(function (cd) {
if (!cd) return;
var ios = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
if (ios && canShareFiles()) {
navigator.share({ files: [new File([cd.blob], fname, { type: ftype })] }).catch(function () {});
shareMsg("Tap Save Image to put it in your Photos.");
return;
}
var a = document.createElement("a"); a.href = URL.createObjectURL(cd.blob); a.download = fname;
document.body.appendChild(a); a.click(); a.remove();
shareMsg("Saved. Post it with the link so friends can open your kit.");
});
return;
}
if (act === "sharecard") {
makeCard().then(function (cd) {
if (!cd) return;
var file = new File([cd.blob], fname, { type: ftype });
return navigator.share({ files: [file], title: "My riding kit", text: text + " " + link });
}).catch(function () {});
return;
}
if (act === "sendnative") { navigator.share({ title: "My riding kit", text: text, url: link }).catch(function () {}); return; }
var both = text + "\n\n" + link;
if (act === "whatsapp") window.open("https://wa.me/?text=" + encodeURIComponent(both), "_blank", "noopener");
if (act === "sms") location.href = "sms:?&body=" + encodeURIComponent(both);
if (act === "email") location.href = "mailto:?subject=" + encodeURIComponent("The riding gear I'd love") + "&body=" + encodeURIComponent(both);
}
function estimateFromVariant(it, vid) {
var hit = null;
(it.charts || []).some(function (c) {
var rows = rowsOf(c.table), col = (c.calc && c.calc.size) || 0;
for (var r = 1; r < rows.length; r++) {
var vars = F.variantsFor(it, cellText(rows[r][col]));
if (vars.some(function (v) { return v.id === String(vid); })) { hit = { c: c, r: r }; return true; }
}
return false;
});
if (!hit) return null;
var out = {};
usedFields(hit.c, null).forEach(function (fl) {
var b = bandAt(hit.c, hit.r, fl.col);
if (b && b.hi > 0) out[fl.area] = Math.round((b.lo + (b.hi - b.lo) / 2) * 2) / 2;
});
return Object.keys(out).length ? out : null;
}
function applyOwned(h, vid) {
var it = findItem(h); if (!it) return;
var est = estimateFromVariant(it, vid); if (!est) return;
var v = it.vars.filter(function (x) { return x.id === String(vid); })[0];
var label = v ? sizeTextOf(it, v) : "";
Object.keys(est).forEach(function (a) { profile.meas[a] = est[a]; S.refFrom[a] = { h: h, t: it.t }; });
S.ref = { h: h, label: label, name: it.t.toLowerCase().indexOf(it.v.toLowerCase()) === 0 ? it.t : it.v + " " + it.t, est: it.est, axes: est };
S.refs = (S.refs || []).filter(function (r) { return r.h !== h; }).concat([S.ref]);
if (!S.gender && it.gen.length === 1 && it.gen[0] !== "Unisex") { S.gender = it.gen[0]; }
if (S.step === 1) selectCat(it.cat);
S.ownPick = null; S.ownQ = ""; measKey = null;
var oq = $("[data-sy-ownq]"); if (oq) oq.value = "";
saveRider();
render();
}
function clearRef() {
Object.keys(S.refFrom).forEach(function (a) { delete profile.meas[a]; });
S.refFrom = {}; S.ref = null; S.refs = []; measKey = null; saveRider(); render();
}
function dropRef(h) {
Object.keys(S.refFrom).forEach(function (a) { if (S.refFrom[a].h === h) { delete profile.meas[a]; delete S.refFrom[a]; } });
S.refs = (S.refs || []).filter(function (r) { return r.h !== h; });
S.ref = S.refs[S.refs.length - 1] || null; measKey = null; saveRider(); render();
}
function liveRefs() {
return (S.refs || []).map(function (r) { return { r: r, still: Object.keys(S.refFrom).filter(function (a) { return S.refFrom[a].h === r.h; }) }; })
.filter(function (x) { return x.still.length; });
}
function refOf(h) { return (S.refs || []).filter(function (r) { return r.h === h; })[0] || null; }
function refHtml() {
var l = liveRefs(); if (!l.length) return "";
var est = l.some(function (x) { return x.r.est; });
return '<div class="sy-box sy-ref"><div class="sy-reftext">' + l.map(function (x) {
var r = x.r;
return "<b>Sized from your " + esc(r.name) + (r.label ? " in " + esc(r.label) : "") + ".</b> " +
esc(x.still.map(function (a) { return MEAS[a] + " about " + show(r.axes[a]); }).join(", ")) + ". ";
}).join("") +
'<span class="sy-refnote">' + (est ? "Some of these charts are the garment's own measurements, so treat them as a rough guide." : "A tape measure is closer, so type over any of them if you know your own.") +
'</span></div><button type="button" class="sy-linkbtn" data-clearref>Measure myself instead</button></div>';
}
function renderOwnHave() {
var box = $("[data-sy-ownhave]"); if (!box) return;
var l = liveRefs();
if (!l.length) { box.innerHTML = ""; return; }
var need = S.sel.length ? missing() : [];
box.innerHTML = '<div class="sy-ownhave"><span class="sy-lab">Sizing from</span><ul>' + l.map(function (x) {
return '<li><span><b>' + esc(x.r.name) + "</b>" + (x.r.label ? " · " + esc(x.r.label) : "") + '<small>' + esc(listJoin(x.still.map(function (a) { return MEAS[a].toLowerCase(); }))) + '</small></span>' +
'<button type="button" class="sy-x" data-unref="' + esc(x.r.h) + '" aria-label="Stop using ' + esc(x.r.name) + '">&times;</button></li>';
}).join("") + "</ul>" +
'<p class="sy-ownmore">' + (need.length ? "Still needed: " + esc(listJoin(need.map(function (a) { return MEAS[a].toLowerCase(); }))) + ". Add another piece you own, or measure." : "That covers everything you need. You can still add another piece.") + "</p></div>";
}
function info(t) { return '<span class="sy-info" tabindex="0" role="note" aria-label="' + esc(t) + '" data-tip="' + esc(t) + '">i</span>'; }
function renderOwn() {
var box = $("[data-sy-own]"), c = catDef(S.cat);
if (!box.firstChild) {
box.innerHTML = '<div class="sy-labrow"><p class="sy-step" data-sy-ownh></p>' + info("Pick something that fits you well and we'll work out your measurements from its size chart") + "</div>" +
'<div class="sy-seg is-small sy-ownseg" role="group" aria-label="Where to find it"><button type="button" class="sy-segbtn" data-own="orders" aria-pressed="true">From my orders</button><button type="button" class="sy-segbtn" data-own="search" aria-pressed="false">Search our gear</button></div>' +
'<p class="sy-ownnote"><b>Only gear we sell will work</b>, because we use that exact product\'s size chart. Can\'t find yours? Don\'t pick something similar, as sizes vary between brands. Measure yourself instead for the most accurate fit. <a href="' + esc(GUIDE_URL) + '" target="_blank" rel="noopener">How to measure</a></p>' +
'<div data-sy-ownorders></div><div data-sy-ownsearch hidden><input class="sy-input" data-sy-ownq type="search" autocomplete="off"><div data-sy-ownres></div></div><div data-sy-ownpick></div><div data-sy-ownother></div>' +
(CFG.signedIn ? "" : '<p class="sy-ownsignin"><a href="' + esc(loginHref()) + encodeURIComponent(location.pathname + location.search) + '">Sign in</a> to pick from your orders</p>');
if (!CFG.signedIn) { S.ownMode = "search"; box.querySelector(".sy-ownseg").hidden = true; }
$("[data-sy-ownq]").addEventListener("input", function (e) { S.ownQ = e.target.value; S.ownPick = null; renderOwnSearch(); renderOwnPick(); });
}
$("[data-sy-ownh]").textContent = "Or size from gear you own";
$("[data-sy-ownq]").placeholder = "Search all our gear by brand or model";
$("[data-sy-ownq]").setAttribute("aria-label", "Search gear you own");
$$("[data-own]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-own") === S.ownMode)); });
if (S.ownPick && !findItem(S.ownPick)) S.ownPick = null;
$("[data-sy-ownorders]").hidden = S.ownMode !== "orders";
$("[data-sy-ownsearch]").hidden = S.ownMode !== "search";
if (!box.querySelector("[data-sy-ownhave]")) box.querySelector(".sy-labrow").insertAdjacentHTML("afterend", "<div data-sy-ownhave></div>");
renderOwnHave();
if (S.ownMode === "orders") renderOwnOrders(); else renderOwnSearch();
renderOwnPick(); renderOwnOther();
}
function loginHref() {
var u = CFG.loginUrl || "/account/login";
return u + (u.indexOf("?") > -1 ? "&" : "?") + "return_url=";
}
function myOrders() {
var seenV = {};
return ORDERS.filter(function (o) { var k = o.vid; if (seenV[k]) return false; seenV[k] = 1; return true; })
.map(function (o) { return { o: o, it: findItem(o.h) }; }).filter(function (x) { return x.it; });
}
function renderOwnOrders() {
var box = $("[data-sy-ownorders]");
if (!CFG.signedIn) {
box.innerHTML = '<div class="sy-signin"><p>Sign in and pick from what you\'ve bought from us &mdash; we already know the size.</p><a href="' + esc(loginHref()) + encodeURIComponent(location.pathname + location.search) + '">Sign in</a></div>';
return;
}
var mine = myOrders().filter(function (x) { var c = catDef(x.it.cat); return c && !c.acc && x.it.sizeIdx > -1; });
box.innerHTML = mine.length ? '<ul class="sy-orders">' + mine.map(function (x) {
var v = x.it.vars.filter(function (y) { return y.id === x.o.vid; })[0], label = v ? sizeTextOf(x.it, v) : "";
if (x.o.r) return '<li class="sy-ord is-off">' + thumb(x.it) + '<span class="sy-ot"><span class="sy-otn">' + esc(x.it.t) + '</span><span class="sy-os">' + esc(label) + " · Returned</span></span></li>";
if (!estimateFromVariant(x.it, x.o.vid)) return '<li class="sy-ord is-off">' + thumb(x.it) + '<span class="sy-ot"><span class="sy-otn">' + esc(x.it.t) + '</span><span class="sy-os">' + esc(label) + " · Its chart is the garment's own measurements</span></span></li>";
return '<li><button type="button" class="sy-ord' + (refOf(x.it.h) ? " is-on" : "") + '" data-ownpick="' + esc(x.it.h) + '" data-ownvid="' + esc(x.o.vid) + '">' + thumb(x.it) +
'<span class="sy-ot"><span class="sy-otn">' + esc(x.it.t) + '</span><span class="sy-os">' + esc(label) + " · Purchased " + esc(x.o.d) + "</span></span></button></li>";
}).join("") + "</ul>" : '<p class="sy-hint">Nothing with a size chart in your orders yet. Try Search our gear.</p>';
}
function renderOwnSearch() {
var box = $("[data-sy-ownres]"), q = norm(S.ownQ);
if (q.length < 2) { box.innerHTML = ""; return; }
var words = q.split(/\s+/);
var hits = (ALL || []).filter(function (it) {
var c = catDef(it.cat); if (!c || c.acc || it.sizeIdx < 0) return false;
var hay = norm(it.v + " " + it.t + " " + it.ty);
return words.every(function (w) { return hay.indexOf(w) > -1; });
}).slice(0, 8);
box.innerHTML = hits.length ? '<ul class="sy-orders">' + hits.map(function (it) {
return '<li><button type="button" class="sy-ord' + (S.ownPick === it.h ? " is-on" : "") + '" data-ownpick="' + esc(it.h) + '">' + thumb(it) +
'<span class="sy-ot"><span class="sy-otn">' + esc(it.t) + '</span><span class="sy-os">' + esc(it.v) + " · " + esc(catDef(it.cat).n) + "</span></span></button></li>";
}).join("") + "</ul>" : '<p class="sy-hint"><b>We don\'t sell that one</b>, so we don\'t have its size chart. Please don\'t pick something similar instead, as sizes differ between brands. Measuring yourself is the most accurate way.</p>';
}
function renderOwnPick() {
var box = $("[data-sy-ownpick]");
var it = S.ownMode === "search" && S.ownPick ? findItem(S.ownPick) : null;
if (!it || it.sizeIdx < 0) { box.innerHTML = ""; return; }
var sizes = uniq(it.vars.filter(function (v) { return estimateFromVariant(it, v.id); }).map(function (v) { return String(v.o[it.sizeIdx]); }));
if (!sizes.length) { box.innerHTML = '<div class="sy-pickbox"><p class="sy-pickname">' + esc(it.t) + '</p><p class="sy-hint" style="margin:0">Its size chart is the garment\'s own measurements, so we can\'t work out yours from it. Try another piece.</p></div>'; return; }
box.innerHTML = '<div class="sy-pickbox"><p class="sy-pickname">' + esc(it.t) + '</p><span class="sy-lab">Tap the size you have</span><div class="sy-pills" style="margin-top:6px">' +
sizes.map(function (s) { return '<button type="button" class="sy-pill is-small" data-ownsize="' + esc(s) + '">' + esc(s) + "</button>"; }).join("") + "</div>" +
(it.est ? '<p class="sy-caveat" style="margin-top:10px">' + esc(EST_NOTE) + "</p>" : "") + "</div>";
}
function renderOwnOther() {
var box = $("[data-sy-ownother]"); box.innerHTML = ""; return;
var others;
if (S.sel.length < 2) { box.innerHTML = ""; return; }
if (S.ownMode === "orders") {
if (!CFG.signedIn) { box.innerHTML = ""; return; }
var by = {};
myOrders().forEach(function (x) { if (x.it.cat !== S.cat && !x.o.r) by[x.it.cat] = 1; });
others = selCats().filter(function (c) { return by[c.k]; });
box.innerHTML = others.length ? '<p class="sy-other">You\'ve also bought ' + esc(listJoin(others.map(function (c) { return c.n.toLowerCase(); }))) + ' from us. Size from those instead:</p><div class="sy-pills">' +
others.map(function (c) { return '<button type="button" class="sy-pill is-small" data-gotab="' + c.k + '">' + esc(c.n) + "</button>"; }).join("") + "</div>" : "";
return;
}
others = selCats().filter(function (c) { return c.k !== S.cat; });
box.innerHTML = '<p class="sy-other">Searching ' + esc(catDef(S.cat).n.toLowerCase()) + ' only. To size from something else:</p><div class="sy-pills">' +
others.map(function (c) { return '<button type="button" class="sy-pill is-small" data-gotab="' + c.k + '">' + esc(c.n) + "</button>"; }).join("") + "</div>";
}
function topPicks() {
return selCats().filter(haveFor).map(function (c) {
var rows = rowsFor(c, "own");
var r = rows.filter(function (x) { return x.fit.exact && !x.fit.missing && x.fit.a; })[0] || rows.filter(function (x) { return x.fit.exact; })[0];
return r ? { c: c, r: r } : null;
}).filter(Boolean);
}
function fitLink() {
var q = new URLSearchParams();
var m = Object.keys(body()).filter(function (a) { return MEAS[a] && F.measValue(body()[a]) != null; }).map(function (a) { return a.replace(" ", "_") + ":" + Math.round(body()[a] * 10) / 10; });
if (m.length) q.set("m", m.join(","));
if (S.sel.length) q.set("c", S.sel.join(","));
if (S.gender) q.set("g", S.gender);
if (S.tempOn) q.set("t", S.tlo + "-" + S.thi);
if (S.bikes.length) q.set("b", S.bikes.join(","));
if (S.heights.length) q.set("bh", S.heights.join(","));
if (S.wet) q.set("wet", "1");
if (S.unit === "in") q.set("u", "in");
if (S.kit.length) q.set("k", S.kit.join(","));
if (S.kitColour) q.set("kc", S.kitColour);
if (S.budget) q.set("bud", String(S.budget));
return SITE + location.pathname + "?" + q.toString();
}
function sendFit(email, mkt, who) {
who = who || {};
var meas = {}, lines = [];
selAxes().forEach(function (a) {
if (!hasM(a)) return;
meas[MEAS[a]] = Math.round(body()[a] * 10) / 10;
lines.push(MEAS[a] + " " + show(body()[a]));
});
var abs = function (u) { return !u ? "" : u.indexOf("//") === 0 ? "https:" + u : u; };
var line = function (c, it, fit, d) {
var v = fit && fit.v, st = v ? stockFor(v) : { pending: true };
return {
Category: c.n, Brand: it.v, Title: it.t, Size: d ? d.sizeText : fit ? fit.label : "", Fit: d ? d.word : "", FitKey: d ? d.key : "",
FitNote: d ? String(d.text).replace(/<[^>]+>/g, "") : "",
Price: it.p / 100, PriceText: (it.pm > it.p ? "From " : "") + money(it.p), CompareAtText: it.cp > it.p ? money(it.cp) : "",
URL: url(it, v), ImageURL: abs(it.img),
Stock: st.pending ? "" : st.label, Dispatch: st.pending ? "" : st.when || "", InStock: !!(fit && fit.a)
};
};
var picks = topPicks().map(function (x) { return line(x.c, x.r.it, x.r.fit, x.r.d); });
var kit = kitItems().map(function (it) { var c = catDef(it.cat), f = kitFit(it); return line(c, it, f, f ? detail(it, f, bodyFor(c)) : null); });
var kitTotal = kitItems().reduce(function (n, it) { return n + it.p; }, 0);
var bike = S.bikes.length ? bikeNames().join(", ") : null;
var props = { "Fit measurements": meas, "Fit gender": S.gender || null, "Fit temperatures": S.tempOn ? degText(S.tlo, S.thi) : null, "Fit bike style": bike, "Fit link": fitLink() };
var payload = {
FirstName: who.first || "", LastName: who.last || "", Marketing: !!mkt,
Measurements: meas, MeasurementLines: lines, Unit: S.unit,
Gear: selCats().map(function (c) { return c.n; }), Gender: S.gender || null, Cut: cutName(),
BikeStyle: bike, BikeStyles: bikeNames(), BootHeights: S.heights.slice(), KitColour: S.kitColour || null, Budget: S.budget || null, Waterproof: !!S.wet, Temperatures: props["Fit temperatures"], Protection: protText() || null,
Picks: picks, PickCount: picks.length,
Kit: kit, KitCount: kit.length, KitTotal: kitTotal / 100, KitTotalText: money(kitTotal),
Link: props["Fit link"]
};
var sent = false;
try {
if (window.klaviyo && typeof window.klaviyo.identify === "function") {
var idp = { email: email }; if (who.first) idp.first_name = who.first; if (who.last) idp.last_name = who.last; Object.keys(props).forEach(function (k) { idp[k] = props[k]; });
window.klaviyo.identify(idp);
window.klaviyo.track(CFG.eventName || "Gear Studio Saved", payload);
sent = true;
} else if (window._learnq && window._learnq.push) {
var lq = { $email: email }; if (who.first) lq.$first_name = who.first; if (who.last) lq.$last_name = who.last; Object.keys(props).forEach(function (k) { lq[k] = props[k]; });
window._learnq.push(["identify", lq]);
window._learnq.push(["track", CFG.eventName || "Gear Studio Saved", payload]);
sent = true;
}
} catch (e) {}
var key = CFG.klaviyoKey;
if (!key) { var ks = [].slice.call(document.scripts).map(function (x) { return x.src; }).filter(function (u) { return /klaviyo\.js\?company_id=/.test(u); })[0]; if (ks) key = (ks.match(/company_id=([^&]+)/) || [])[1]; }
if (mkt && key && CFG.klaviyoList) {
fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(key), {
method: "POST", headers: { "content-type": "application/json", revision: "2024-10-15" },
body: JSON.stringify({ data: { type: "subscription", attributes: { custom_source: "The Gear Studio", profile: { data: { type: "profile", attributes: { email: email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } } },
relationships: { list: { data: { type: "list", id: CFG.klaviyoList } } } } })
}).catch(function () {});
}
return sent;
}
function openMail() {
var m = $("[data-sy-mailmodal]");
m.hidden = false; renderMail();
var i = m.querySelector("[name=email]") || m.querySelector(".sy-mclose"); if (i) i.focus();
}
function closeMail() { var m = $("[data-sy-mailmodal]"); if (m) m.hidden = true; }
function renderMail() {
var box = $("[data-sy-mail]");
var picks = topPicks();
var what = '<ul class="sy-mailwhat"><li>Your measurements</li><li>Your top pick' + (picks.length === 1 ? "" : "s") + " in " +
esc(listJoin(picks.map(function (x) { return x.c.n.toLowerCase(); })) || "your size") + "</li>" +
(S.kit.length ? "<li>Your kit of " + S.kit.length + " piece" + (S.kit.length === 1 ? "" : "s") + "</li>" : "") +
"<li>A link back here with everything filled in, on any device</li></ul>";
if (S.email) {
box.innerHTML = (S.mailFailed ? '<p class="sy-kitmsg is-err">We couldn\'t send that just now. Please try again in a minute.</p>' :
'<p class="sy-fsent">Sent to ' + esc(S.email) + '</p><p class="sy-mailh">It should land in a minute or two. Check your promotions folder if it doesn\'t.</p>' +
(S.mktSent ? '<p class="sy-mailwelcome">Thanks for using The Gear Studio and for joining our email community! We\'ll send out a welcome code for you to use on your first shop, which is valid on all orders over $500. You can expect an email from us shortly. We appreciate you!</p>' : "")) +
'<div class="sy-mailact"><button type="button" class="sy-outline" data-resend>Send again with my latest picks</button><button type="button" class="sy-linkbtn" data-changemail>Use a different email</button></div>';
return;
}
box.innerHTML = '<p class="sy-mailh">We\'ll email you:</p>' + what +
'<form data-sy-mailform class="sy-mailform"><div class="sy-namerow"><label class="sy-flabel"><span>First name</span><input class="sy-input" name="first" autocomplete="given-name" value="' + esc(S.firstDraft || "") + '"></label>' +
'<label class="sy-flabel"><span>Last name</span><input class="sy-input" name="last" autocomplete="family-name" value="' + esc(S.lastDraft || "") + '"></label></div>' +
'<label class="sy-flabel"><span>Email</span><input class="sy-input" name="email" type="email" required autocomplete="email" placeholder="you@email.com" value="' + esc(S.emailDraft || "") + '"></label>' +
'<label class="sy-mkt"><input type="checkbox" data-sy-mkt' + (S.mkt ? " checked" : "") + "> Also send me new gear and offers</label>" +
'<button type="submit" class="sy-next sy-mailsend"' + (S.mailBusy ? " disabled" : "") + ">" + (S.mailBusy ? "Sending&hellip;" : "Send my fit") + "</button></form>";
}
function fitLeadPayload(email, who, mkt) {
var meas = {};
selAxes().forEach(function (a) { if (hasM(a)) meas[a] = Math.round(body()[a] * 10) / 10; });
var line = function (it) {
var f = kitFit(it), v = f && f.v;
return { category: (catDef(it.cat) || {}).n, title: it.t, vendor: it.v, size: f ? f.label : null, price: it.p / 100, url: url(it, v), variantId: v ? v.id : null };
};
return {
email: email, firstName: who.first || null, lastName: who.last || null, marketing: !!mkt, gender: S.gender || null,
categories: selCats().map(function (c) { return c.n; }), measurements: meas,
riding: { bike: S.bikes.length ? bikeNames().join(", ") : null, waterproof: !!S.wet, temperatures: S.tempOn ? degText(S.tlo, S.thi) : null, protection: protText() || null },
picks: topPicks().map(function (x) { var o = line(x.r.it); o.fit = x.r.d ? x.r.d.word : null; return o; }),
kit: kitItems().map(line), link: fitLink()
};
}
function primeStock(done) {
var vs = [];
topPicks().forEach(function (x) { if (x.r.fit.v) vs.push(x.r.fit.v); });
kitItems().forEach(function (it) { var f = kitFit(it); if (f && f.v) vs.push(f.v); });
vs.forEach(function (v) { if (v.a) askStock(v.id); });
var t0 = Date.now();
(function wait() {
if (!vs.some(function (v) { return stockFor(v).pending; }) || Date.now() - t0 > 2500) done();
else setTimeout(wait, 150);
})();
}
function submitFit(email, who, mkt) {
who = who || {};
S.mailBusy = true; S.email = ""; renderMail();
primeStock(function () { submitFitNow(email, who, mkt); });
}
function submitFitNow(email, who, mkt) {
var sent = sendFit(email, mkt, who);
fetch("/apps/peakmoto/fit", { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json" }, body: JSON.stringify(fitLeadPayload(email, who, mkt)) })
.then(function (r) { return r.ok; }).catch(function () { return false; })
.then(function (recorded) {
S.mailBusy = false; S.email = email; S.who = who; S.mktSent = S.mktSent || !!mkt;
S.mailFailed = !sent && !recorded;
renderMail();
});
}
function readFitLink() {
var q = new URLSearchParams(location.search), any = false;
var m = q.get("m");
if (m) m.split(",").forEach(function (p) {
var kv = p.split(":"), k = kv[0].replace("_", " "), v = parseFloat(kv[1]);
if (MEAS[k] && !isNaN(v)) { profile.meas[k] = v; any = true; }
});
var g = q.get("g"); if (g === "Women" || g === "Men") { S.gender = g; any = true; }
var cs = q.get("c"); if (cs) { S.sel = cs.split(","); saveSel(); any = true; }
var t = q.get("t"); if (t && /^\d+-\d+$/.test(t)) { var a = t.split("-"); S.tempOn = true; S.tlo = +a[0]; S.thi = +a[1]; any = true; }
var b = (q.get("b") || "").split(",").filter(function (k) { return BIKE_STYLE[k]; }); if (b.length) { S.bikes = b; any = true; }
var bh = (q.get("bh") || "").split(",").filter(function (k) { return HEIGHTS.indexOf(k) > -1; }); if (bh.length) { S.heights = bh; any = true; }
var kc = q.get("kc"); if (kc && FAMILY.some(function (x) { return x[0] === kc; })) S.kitColour = kc;
var bud = parseInt(q.get("bud"), 10); if (bud > 0) S.budget = bud;
if (q.get("wet") === "1") { S.wet = true; any = true; }
if (q.get("u") === "in") S.unit = "in";
var kq = q.get("k"); if (kq) { S.kit = kq.split(",").filter(Boolean).slice(0, 30); any = true; }
var sk = q.get("sk");
if (sk) S.shared = { ids: sk.split(",").filter(function (x) { return /^\d+$/.test(x); }).slice(0, 30), via: q.get("via") === "gift" ? "gift" : "share", name: String(q.get("n") || "").replace(/[<>]/g, "").trim().slice(0, 30) };
var ad = q.get("add"); if (ad) S.addH = { h: ad, v: q.get("av") || "" };
var src = q.get("src"); if (src === "pdp" || src === "banner") S.src = src;
if (any) { S.welcome = true; saveRider(); }
}
var ORDER = ["chest", "waist", "hips", "inseam", "palm", "hand length", "foot", "head"];
function selCats() { return CATS.filter(function (c) { return S.sel.indexOf(c.k) > -1; }); }
function selAxes() {
var ax = [];
selCats().forEach(function (c) { axesFor(c).forEach(function (a) { if (ax.indexOf(a) < 0) ax.push(a); }); });
return ax;
}
function hasM(a) { return F.measValue(body()[a]) != null; }
function missing() { return selAxes().filter(function (a) { return !hasM(a); }); }
function measured() { return S.sel.length > 0 && !missing().length; }
function attrKeys(cats) {
var k = {};
(ITEMS || []).forEach(function (it) {
if (cats.indexOf(catDef(it.cat)) < 0) return;
if (it.rs) k.rs = 1; if (it.wp != null) k.wp = 1; if (it.tp) k.tp = 1; if (it.bh) k.bh = 1;
});
if (kitFamilies(cats).length > 1) k.col = 1;
if (cats.length > 1) k.budget = 1;
if (protFamilies(cats).length) k.prot = 1;
if (k.prot || k.bh) k.protarea = 1;
if (k.wp || k.tp) k.weather = 1;
return k;
}
function kitFamilies(cats) {
var f = {};
(ITEMS || []).forEach(function (it) { if (cats.indexOf(catDef(it.cat)) > -1 && isOwn(it) && attrOk(it, true)) itemFams(it).forEach(function (x) { f[x] = 1; }); });
return FAMILY.map(function (x) { return x[0]; }).filter(function (x) { return f[x]; });
}
function shownFamilies() {
var c = catDef(S.cat);
if (!c || S.step !== 4 || !haveFor(c)) return null;
var kc = S.kitColour; S.kitColour = "";
var rows; try { rows = rowsFor(c, "own"); } finally { S.kitColour = kc; }
if (!S.showSold) rows = rows.filter(function (r) { return r.fit.a; });
var n = {}; rows.forEach(function (r) { itemFams(r.it).forEach(function (x) { n[x] = (n[x] || 0) + 1; }); });
return { c: c, n: n };
}
function renderKitColours() {
var box = $("[data-sy-kc]"); if (!box) return;
var hex = {}; FAMILY.forEach(function (x) { hex[x[0]] = x[2]; });
var sh = shownFamilies(), fams, cnt = {};
if (sh) {
cnt = sh.n;
fams = FAMILY.map(function (x) { return x[0]; }).filter(function (x) { return cnt[x] || x === S.kitColour; });
} else {
fams = kitFamilies(selCats());
if (S.kitColour && fams.indexOf(S.kitColour) < 0) { S.kitColour = ""; setTimeout(render, 0); }
}
var hint = box.parentNode.querySelector(".sy-kchint");
if (!hint) { box.insertAdjacentHTML("beforebegin", '<p class="sy-kchint"></p>'); hint = box.parentNode.querySelector(".sy-kchint"); }
hint.textContent = sh ? "What's in " + sh.c.n.toLowerCase() + " for you right now, with how many of each." : "";
box.innerHTML = '<button type="button" class="sy-pill" data-kc="">Any</button>' + fams.map(function (f) {
return '<button type="button" class="sy-pill sy-cpill" data-kc="' + f + '"><i aria-hidden="true" style="background:' + hex[f] + '"></i>' + f + (sh ? ' <small class="sy-kcn">' + (cnt[f] || 0) + "</small>" : "") + "</button>";
}).join("");
}
function hasRide() { return Object.keys(attrKeys(selCats())).length > 0; }
function canReach(n) { return n === 1 || measured(); }
function saveSel() { try { localStorage.setItem("pmo.sys.cats", JSON.stringify(S.sel)); } catch (e) {} }
function loadSel() { try { var a = JSON.parse(localStorage.getItem("pmo.sys.cats") || "[]"); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
function goStep(n) {
if (n === 2 || n === 3) n = 4;
if (n === 4 && !measured()) n = 1;
S.step = n;
if (S.sel.indexOf(S.cat) < 0 && S.sel.length) S.cat = S.sel[0];
if (n !== 4) closeCmp();
measKey = null;
render();
var top = rootEl.getBoundingClientRect().top + window.pageYOffset;
if (window.pageYOffset > top) window.scrollTo(0, top);
}
function renderSteps() {
$$("[data-sy-step]").forEach(function (el) { el.hidden = +el.getAttribute("data-sy-step") !== S.step; });
$$("[data-sy-stepper] [data-go]").forEach(function (b) {
var n = +b.getAttribute("data-go");
b.classList.toggle("is-on", n === S.step);
b.classList.toggle("is-done", n < S.step);
b.disabled = !canReach(n);
if (n === S.step) b.setAttribute("aria-current", "step"); else b.removeAttribute("aria-current");
});
$("[data-sy-cmpbar]").hidden = S.step !== 4 || cmpList().length === 0;
$("[data-sy-mailopen]").hidden = S.step !== 4 || !selCats().some(haveFor);
if (S.step === 4) ping("results");
}
function cutName() { return S.gender === "Women" ? "Women's" : S.gender === "Men" ? "Men's" : "Any cut"; }
function needText(c) { return listJoin(axesFor(c).map(function (a) { return SHORT[a]; })); }
var CAT_ICON = {
acc: '<path d="M14 18h20l2 22H12z"/><path d="M19 18v-3a5 5 0 0 1 10 0v3"/><path d="M18 24h12"/>',
extras: '<rect x="13" y="22" width="22" height="17" rx="2"/><path d="M18 22v-5a6 6 0 0 1 12 0v5"/><path d="M24 29v4"/>',
jackets: '<path d="M20 9.6c0-1.6 1.8-2.6 4-2.6s4 1 4 2.6v3.2c-1.2.6-2.5.9-4 .9s-2.8-.3-4-.9z"/><circle cx="24" cy="10.3" r=".6"/>'+
'<path d="M20 11.4l-7 2.7c-1.9.7-3.1 2.4-3.3 4.4L7.7 37.4M28 11.4l7 2.7c1.9.7 3.1 2.4 3.3 4.4l2 18.9"/>'+
'<path d="M14.6 20l-.2 14.4M33.4 20l.2 14.4M12.6 37.4l1.9-14.8M35.4 37.4l-1.9-14.8"/>'+
'<path d="M14.2 34.4h19.6c.6 0 1 .4 1 1v2.2c0 .6-.4 1-1 1H14.2c-.6 0-1-.4-1-1v-2.2c0-.6.4-1 1-1z"/><path d="M24 13.7v24.9"/>'+
'<path d="M17.6 18.8h4.2M26.2 18.8h4.2M17.2 26.6l.4 4.6M30.8 26.6l-.4 4.6"/>'+
'<path d="M7.7 37.4l-.3 3h5l.3-3zM40.3 37.4l.3 3h-5l-.3-3z"/>',
pants: '<path d="M14.4 7h19.2c.6 0 1 .4 1 1v2.6c0 .6-.4 1-1 1H14.4c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1z"/><path d="M18 7v4.6M30 7v4.6M24 7v4.6"/>'+
'<path d="M13.6 11.6l-1.9 29.4h8.6L24 20.4l3.7 20.6h8.6l-1.9-29.4"/><path d="M24 11.6v8.8"/>'+
'<path d="M16.4 11.6c0 2.6 1.6 4.4 4.2 4.6M31.6 11.6c0 2.6-1.6 4.4-4.2 4.6"/><path d="M14.4 26.6h5.4M28.2 26.6h5.4"/>',
helmets: '<path d="M10.2 14.6 7.6 12.9c4.3-3.4 10.1-5.1 15.7-5.1 9.7 0 17.3 6.8 17.6 16.3v8.3c0 1.3-1.2 2.2-2.5 1.9l-22.3-5.4c-3.5-.8-6.2-3.7-6.7-7.3-.3-2.5 0-4.9.8-7z"/>'+
'<path d="M40.9 19.7H24.6c-1 0-1.8.8-1.8 1.8v4.3c0 .9.6 1.6 1.4 1.8l16.7 3.9"/><circle cx="15.6" cy="22.6" r="2.1"/>',
boots: '<path d="M14.4 8.3 30.6 6.4v20.2c0 1 .6 1.9 1.6 2.3l3.6 1.3c2.4.9 4 3 4 5.5 0 .9-.7 1.6-1.6 1.6H24.6c-1.2 0-2.3-.4-3.2-1-1.3-.9-3-.9-4.3 0-.9.6-2 .9-3.2.9-1.4 0-2.5-1.1-2.5-2.5 0-2.6.7-4.3 1.6-6.4V9.9c0-.8.6-1.5 1.4-1.6z"/>'+
'<path d="M18.8 7.8c.4 5.9 1.4 10.9 3.4 14.3.5.8.1 1.8-.7 2.2l-8.1 3.4"/><path d="M12.4 31.4c2.6 0 4.8 1.8 5.3 4.4M25 36.2c1-2.4 3.4-3.6 6-3.2 2.4.4 4.6 1.4 6.2 3.2"/>',
gloves: '<path d="M11.4 32.2 7.6 24.6a1.9 1.9 0 0 1 3.4-1.7l2.2 4.1V13.4a1.9 1.9 0 0 1 3.8 0v8.4V10.8a1.9 1.9 0 0 1 3.8 0v11V11.8a1.9 1.9 0 0 1 3.8 0v10.4V15.6a1.9 1.9 0 0 1 3.8 0v10.8c0 2.3-.5 4.2-1.6 5.8"/>'+
'<path d="M28.4 18.6v-5a1.9 1.9 0 0 1 3.8 0v11.2V15a1.9 1.9 0 0 1 3.8 0v12.2l2.2-3.2a1.9 1.9 0 0 1 3.1 2.2l-4.6 6.6c-.8 1.2-1.3 2.6-1.4 4v2.4h-6.5"/>'+
'<path d="M11 32.2h16.8c.6 0 1 .4 1 1v3.6c0 .6-.4 1-1 1H11c-.6 0-1-.4-1-1v-3.6c0-.6.4-1 1-1z"/><path d="M13.6 35h11.6"/>'
};
CAT_ICON.base = CAT_ICON.jackets;
function catIcon(k) { return '<svg class="sy-cico" viewBox="0 0 48 48" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="2.6" stroke-linejoin="round" stroke-linecap="round">' + (CAT_ICON[k] || "") + "</g></svg>"; }
var TILE_MEAS = { chest: "Chest", waist: "Waist", hips: "Hips", inseam: "Inseam", palm: "Palm circumference", "hand length": "Hand length", foot: "Foot length", head: "Head circumference" };
function renderTiles() {
var host = $("[data-sy-tiles]"), act = document.activeElement, fid = act && host.contains(act) ? act.id : null;
host.innerHTML = CATS.map(function (c) {
var n = ITEMS.filter(function (i) { return i.cat === c.k; }).length, on = S.sel.indexOf(c.k) > -1;
return '<div class="sy-tcard' + (on ? " is-on" : "") + '" data-tcard="' + c.k + '">' +
'<button type="button" class="sy-tile" data-tile="' + c.k + '" aria-pressed="' + on + '">' +
'<span class="sy-tick" aria-hidden="true"></span><span class="sy-tn">' + catIcon(c.k) + esc(c.n) + '</span><span class="sy-tc">' + n + " to choose from</span></button>" +
(c.acc ? '<p class="sy-tnone"><span class="sy-tlist">' + esc(groupList(c.k)) + '</span>No measurements needed. Tick it to add it.</p>' :
'<div class="sy-tfields">' + axesFor(c).map(function (a) {
var v = F.measValue(body()[a]), id = "sy-t-" + c.k + "-" + a.replace(" ", "-");
return '<label class="sy-tf" for="' + id + '"><span>' + esc(FIELD_NAME[a] || MEAS[a]) + '</span><span class="sy-tfin">' +
'<input class="sy-meas" type="text" inputmode="decimal" autocomplete="off" spellcheck="false" id="' + id + '" data-ax="' + a + '" data-tcat="' + c.k + '" value="' + (v == null ? "" : Math.round(fromCm(v) * 10) / 10) + '" placeholder="">' +
"<i>" + S.unit + "</i></span></label>";
}).join("") + "</div>") + "</div>";
}).join("");
if (fid) { var f = document.getElementById(fid); if (f) { f.focus(); try { f.setSelectionRange(f.value.length, f.value.length); } catch (e) {} } }
renderStep1Nav();
}
var FIELD_NAME = { chest: "Chest", waist: "Waist", hips: "Hips", inseam: "Inseam", palm: "Palm", "hand length": "Hand length", foot: "Foot length", head: "Head" };
function renderStep1Nav() {
var nx = $("[data-sy-next1]"); if (!nx) return;
var miss = missing();
nx.disabled = !S.sel.length || !!miss.length;
nx.textContent = !S.sel.length ? "Add a measurement to start" : miss.length ? "Add your " + listJoin(miss.map(function (a) { return SHORT[a]; })) : "Show my gear";
$$("[data-tcard]").forEach(function (el) {
var k = el.getAttribute("data-tcard"), on = S.sel.indexOf(k) > -1;
el.classList.toggle("is-on", on);
var b = el.querySelector("[data-tile]"); if (b) b.setAttribute("aria-pressed", String(on));
});
}
function selectCat(k) {
if (!catDef(k) || S.sel.indexOf(k) > -1) return;
S.sel.push(k);
S.sel = CATS.map(function (c) { return c.k; }).filter(function (x) { return S.sel.indexOf(x) > -1; });
saveSel();
}
function renderOwnBits() {
var cats = selCats(), single = cats.length === 1 ? cats[0] : null;
$("[data-sy-ownopen]").setAttribute("aria-expanded", String(S.ownOpen));
$("[data-sy-ownopenlab]").textContent = "No tape measure? Size from " + (single ? OWN_WORD[single.k] : "gear") + " you own";
$("[data-sy-own]").hidden = !S.ownOpen;
$("[data-sy-ref2]").innerHTML = refHtml();
}
var measKey = null;
function figFor(a) { for (var k in FIGURES) if (FIGURES[k].areas.indexOf(a) > -1) return k; return "body"; }
function figHtml(name) {
var fig = FIGURES[name], ax = selAxes();
var bands = Object.keys(fig.bands).map(function (a) {
return fig.bands[a].replace(/^<(\w+)/, '<$1 class="sy-band' + (ax.indexOf(a) >= 0 ? "" : " is-off") + '" data-area="' + a + '"');
}).join("");
return '<div class="sy-mini" style="--w:' + fig.width + 'px" data-fig="' + name + '" aria-hidden="true"><svg viewBox="' + fig.box + '">' + fig.shape + '<g fill="none" stroke-width="3">' + bands + "</g></svg></div>";
}
function usedBy(a) { return selCats().filter(function (c) { return axesFor(c).indexOf(a) > -1; }).map(function (c) { return c.n; }).join(", "); }
function measTable(editable) {
return '<table class="sy-mt"><thead><tr><th scope="col">Measurement</th><th scope="col">' + (editable ? "Yours (" + S.unit + ")" : "Yours") + "</th></tr></thead><tbody>" +
selAxes().map(function (a) {
var v = F.measValue(body()[a]), id = "sy-m-" + a.replace(" ", "-");
var cell;
if (editable) {
var shown = v == null ? "" : Math.round(fromCm(v) * 10) / 10;
cell = '<input class="sy-meas" type="text" inputmode="decimal" autocomplete="off" spellcheck="false" id="' + id + '" data-ax="' + a + '" value="' + shown + '" placeholder="">' +
(S.refFrom[a] ? '<span class="sy-from" data-sy-from="' + a + '">from your ' + esc(S.refFrom[a].t) + "</span>" : "");
} else cell = v == null ? '<span class="sy-need">Needed</span>' : esc(show(v));
return '<tr data-row="' + a + '"' + (v == null ? ' class="is-need"' : "") + '><th scope="row">' + (editable ? '<label for="' + id + '">' + esc(MEAS[a]) + "</label>" : esc(MEAS[a])) +
"<small>" + esc(usedBy(a)) + "</small></th><td>" + cell + "</td></tr>";
}).join("") + "</tbody></table>";
}
function unitSeg() {
return '<div class="sy-seg sy-pillseg is-mini" role="group" aria-label="Units"><button type="button" class="sy-segbtn" data-u="cm" aria-pressed="' + (S.unit === "cm") + '">cm</button>' +
'<button type="button" class="sy-segbtn" data-u="in" aria-pressed="' + (S.unit === "in") + '">in</button></div>';
}
function renderMeasures() {
var host = S.step === 2 ? "step" : S.acc.meas ? "edit" : "none";
var key = host + "|" + S.sel.join(",") + "|" + S.unit + "|" + Object.keys(S.refFrom).sort().map(function (a) { return a + "=" + S.refFrom[a].h; }).join(",");
if (key === measKey) return;
measKey = key;
var s2 = $("[data-sy-meas2]"), s4 = $("[data-sy-det-meas]");
if (host === "step") {
s4.innerHTML = "";
var ax = selAxes();
s2.innerHTML = '<div class="sy-calc"><div data-sy-fig>' + (ax.length ? figHtml(figFor(ax[0])) : "") + "</div><div>" + measTable(true) +
'<p class="sy-tip" data-sy-tip aria-live="polite" hidden></p></div></div>';
} else {
s2.innerHTML = "";
s4.innerHTML = host === "edit" ? '<div class="sy-detunits">' + unitSeg() + '<a class="sy-howto" href="' + esc(GUIDE_URL) + '" target="_blank" rel="noopener">How to measure</a></div>' + measTable(true) +
'<p class="sy-tip" data-sy-tip aria-live="polite" hidden></p>' : "";
}
}
function markArea(area) { $$(".sy-band").forEach(function (b) { b.classList.toggle("is-on", !!area && b.getAttribute("data-area") === area); }); }
function tipBox() { return $('[data-sy-step="' + S.step + '"] [data-sy-tip]') || $("[data-sy-tip]"); }
function showTip(ax) {
var box = tipBox(); if (!box) return;
var tip = TIPS[ax];
box.innerHTML = (tip ? "<strong>How to measure your " + esc(tip[0]) + ":</strong> " + esc(tip[1]) : "") + '<span class="sy-gen">' + esc(TIP_GENERAL) + "</span>";
box.hidden = false;
}
function hideTip() { var box = tipBox(); if (box) box.hidden = true; markArea(null); }
function focusAxis(a) {
var host = $("[data-sy-fig]");
if (host) { var name = figFor(a), cur = host.firstChild; if (!cur || cur.getAttribute("data-fig") !== name) host.innerHTML = figHtml(name); }
showTip(a); markArea(a);
}
function renderStep2() {
var cats = selCats();
$("[data-sy-s2sub]").textContent = "For your " + listJoin(cats.map(function (c) { return c.n.toLowerCase(); })) + ". We size every one of them from these.";
var single = cats.length === 1 ? cats[0] : null;
if (S.sel.indexOf(S.cat) < 0) S.cat = S.sel[0];
$("[data-sy-ownopen]").setAttribute("aria-expanded", String(S.ownOpen));
$("[data-sy-ownopenlab]").textContent = "No tape measure? Size from " + (single ? OWN_WORD[single.k] : "gear") + " you own";
$("[data-sy-own]").hidden = !S.ownOpen;
$("[data-sy-ref2]").innerHTML = refHtml();
var nx = $("[data-sy-next2]"), miss = missing();
nx.disabled = !!miss.length;
nx.textContent = miss.length ? "Add your " + listJoin(miss.map(function (a) { return SHORT[a]; })) : "Next";
}
function renderStep3() {
var keys = attrKeys(selCats());
$$("[data-sy-attr], [data-sy-sub]").forEach(function (g) { g.hidden = !keys[g.getAttribute("data-attr")]; });
renderProt();
}
function placeRide(sel) {
var node = $("[data-sy-ride]"), slot = $(sel);
if (node && slot && node.parentNode !== slot) slot.appendChild(node);
}
function rideText() {
var r = [];
if (S.bikes.length) r.push(bikeNames().join(", "));
if (S.heights.length && S.sel.indexOf("boots") > -1) r.push(S.heights.join(", ") + " boots");
if (S.kitColour) r.push(S.kitColour + " kit");
if (S.budget) r.push("Budget " + money(S.budget * 100));
if (S.wet) r.push("Waterproof");
if (S.tempOn) r.push(degText(S.tlo, S.thi));
var p = protText(); if (p) r.push(p);
return r.join(" · ") || "Any";
}
function prefText() {
var r = [selCats().map(function (c) { return c.n; }).join(", ")];
if (S.gender) r.push(cutName());
var ride = rideText();
if (ride !== "Any") r.push(ride);
return r.join(" · ");
}
function measText() {
var m = selAxes().filter(hasM).map(function (a) { return MEAS[a].replace(" circumference", "").replace(" length", "") + " " + show(body()[a]); });
var miss = missing().length;
return (m.join(" · ") || "None yet") + (miss ? " · " + miss + " to add" : "");
}
function renderDetails() {
["meas", "prefs"].forEach(function (k) {
var b = $('[data-acc-toggle="' + k + '"]');
b.setAttribute("aria-expanded", String(!!S.acc[k]));
b.parentNode.classList.toggle("is-open", !!S.acc[k]);
});
$("[data-sy-meassum]").textContent = measText();
$("[data-sy-prefsum]").textContent = prefText();
var g = $("[data-sy-det-gear]");
if (S.acc.prefs) {
g.innerHTML = '<p class="sy-label">Gear</p><div class="sy-checks">' + CATS.map(function (c) {
return '<button type="button" class="sy-check" data-tile="' + c.k + '" aria-pressed="' + (S.sel.indexOf(c.k) > -1) + '"><span class="sy-tick" aria-hidden="true"></span>' + esc(c.n) + "</button>";
}).join("") + '</div><p class="sy-label sy-gap">Cut</p><div class="sy-seg sy-pillseg" data-sy-gender role="group" aria-label="Cut">' +
[["Women", "Women's"], ["Men", "Men's"], ["", "Any"]].map(function (x) { return '<button type="button" class="sy-segbtn" data-g="' + x[0] + '" aria-pressed="' + (S.gender === x[0]) + '">' + x[1] + "</button>"; }).join("") + "</div>";
renderStep3();
placeRide("[data-sy-ride4]");
$("[data-sy-ride4]").hidden = !hasRide();
} else g.innerHTML = "";
renderMeasures();
}
function renderSideSum() {
$("[data-sy-meassum]").textContent = measText();
$("[data-sy-prefsum]").textContent = prefText();
}
var KIT_KEY = "pmo.sys.kit";
function saveKit() {
try { localStorage.setItem(KIT_KEY, JSON.stringify({ k: S.kit, b: S.budget, c: S.colSel, z: S.sizeSel, t: Date.now() })); } catch (e) {}
}
function loadKit() {
var o = null;
try { o = JSON.parse(localStorage.getItem(KIT_KEY) || "null"); } catch (e) {}
if (!o || !Array.isArray(o.k) || Date.now() - (o.t || 0) > 90 * 864e5) return;
S.kit = o.k.filter(function (h) { return !!findItem(h); });
if (o.b && !S.budget) S.budget = o.b;
if (o.c) S.colSel = o.c;
if (o.z) S.sizeSel = o.z;
if (S.kit.length) { S.prefill = "yes"; S.backSig = S.kit.join(","); }
}
function render() {
if (!ITEMS) return;
PICKS = null; ideaFooter(); if (S.mode) applyMode();
saveKit();
syncControls(); renderSteps(); renderNotice(); if (S.step !== 4) renderKitSum();
if (S.step === 1) { renderTiles(); renderOwn(); renderOwnBits(); return; }
if (S.step === 2) { renderMeasures(); renderOwn(); renderStep2(); return; }
if (S.step === 3) { placeRide("[data-sy-ride3]"); renderStep3(); return; }
renderDetails(); renderResults(); renderSearch();
}
function placeFilters() {
var f = $(".sy-filters"), side = $("[data-sy-side]"), bar = $(".sy-resbar");
if (!f || !side || !bar) return;
var box = side.querySelector("[data-sy-sfilt]");
if (!box) {
box = document.createElement("section"); box.className = "sy-sfilt"; box.setAttribute("data-sy-sfilt", "");
box.innerHTML = '<p class="sy-sfh">Filters</p>';
var ks = side.querySelector("[data-sy-kitsum]"); side.insertBefore(box, ks ? ks.nextSibling : side.firstChild);
}
var allB = f.querySelector('[data-sold="1"]'); if (allB && allB.nextElementSibling) allB.parentNode.appendChild(allB);
if (!f.querySelector("[data-stinfo]")) f.insertAdjacentHTML("beforeend", '<div class="sy-filter"><span class="sy-flab">Stock &amp; dispatch info</span><div class="sy-seg is-small" role="group" aria-label="Stock and dispatch info">' +
'<button type="button" class="sy-segbtn" data-stinfo="1">Show</button><button type="button" class="sy-segbtn" data-stinfo="0">Hide</button></div></div>');
var wide = !window.matchMedia || window.matchMedia("(min-width: 961px)").matches;
var to = wide ? box : bar;
if (f.parentNode !== to) to.appendChild(f);
box.hidden = !wide;
}
window.addEventListener("resize", function () { placeFilters(); });
function renderResults() {
placeFilters();
if (S.sel.indexOf(S.cat) < 0) S.cat = S.sel[0];
var c = catDef(S.cat);
renderTabs(); renderKit(); renderMail(); renderCmpBar(); renderSteps();
var back = S.backSig && S.backSig === S.kit.join(",") && !S.welcome;
if (S.backSig && !back) S.backSig = null;
var boxes = (S.welcome ? '<div class="sy-box sy-ref is-welcome"><div class="sy-reftext"><b>Welcome back.</b> We\'ve filled in your measurements from your email.</div></div>' : "") +
(back ? '<div class="sy-box sy-ref is-welcome"><div class="sy-reftext"><b>Welcome back.</b> Here\'s the kit you were building, sized from the measurements you gave us last time.</div></div>' : "") + refHtml();
var out = $("[data-sy-out]");
$("[data-sy-boxes]").innerHTML = boxes;
if (!haveFor(c)) {
var need = axesFor(c).filter(function (a) { return !hasM(a); }).map(function (a) { return SHORT[a]; });
$("[data-sy-rtitle]").textContent = c.n;
out.innerHTML = '<div class="sy-empty"><b>We need your ' + esc(listJoin(need)) + "</b>Add " + (need.length > 1 ? "them" : "it") + " and we'll size all our " + esc(c.n.toLowerCase()) + " for you." +
'<button type="button" class="sy-btn sy-emptybtn" data-addmeas="' + c.k + '">Add your ' + esc(listJoin(need)) + "</button></div>";
return;
}
var own = rowsFor(c, "own"), cross = rowsFor(c, "cross").filter(function (r) { return r.fit.exact && !r.fit.missing; });
var inStock = function (r) { return r.fit.a; };
if (c.k === "helmets") { own = groupModels(own); cross = groupModels(cross); inStock = function (r) { return (r.group || [r]).some(function (x) { return x.fit.a; }); }; }
var hidden = S.showSold ? [] : own.filter(function (r) { return !inStock(r); }).concat(cross.filter(function (r) { return !inStock(r); }));
var rows = S.showSold ? own : own.filter(inStock);
if (!S.showSold) cross = cross.filter(inStock);
var bbox = "";
if (overBy() > 0 && kitHas(c.k)) {
var same = kitItems().filter(function (x) { return x.cat === c.k; }).reduce(function (t, x) { return Math.max(t, x.p); }, 0);
var allow = same - overBy(), fits = function (r) { return r.it.p <= allow; };
var ok = rows.filter(fits);
rows = ok.length ? ok.concat(rows.filter(function (r) { return !fits(r); })) : rows.slice().sort(function (a, b) { return a.it.p - b.it.p; });
bbox = '<div class="sy-box sy-budgetbox"><b>Your kit is ' + money(overBy()) + " over budget.</b> " +
(ok.length ? ok.length + " of these " + esc(c.n.toLowerCase()) + (ok.length === 1 ? " brings" : " bring") + " it back within budget, so " + (ok.length === 1 ? "it's" : "they're") + " first." :
(lowestAlready(c, kitItems().filter(function (x) { return x.cat === c.k; })) ? "Your " + esc(c.n.toLowerCase()) + " " + (c.k === "gloves" || c.k === "pants" || c.k === "boots" ? "are" : "is") + " already the lowest price in your size, so the savings will need to come from another part of your kit." :
"None of these " + esc(c.n.toLowerCase()) + " bring it back within budget on " + (c.k === "gloves" || c.k === "pants" || c.k === "boots" ? "their" : "its") + " own, so the cheapest are first.")) + "</div>";
}
if (S.pinCat !== c.k) { S.pinCat = c.k; S.pin = S.kit.slice(); }
var pinned = function (r) { return (r.group || [r]).some(function (x) { return S.pin.indexOf(x.it.h) > -1 && S.kit.indexOf(x.it.h) > -1; }); };
if (S.pin.length) rows = rows.filter(pinned).concat(rows.filter(function (r) { return !pinned(r); }));
var ONE = { helmets: "helmet", jackets: "jacket", base: "base layer", pants: "pants", boots: "boot", gloves: "glove", acc: "accessory" };
$("[data-sy-rtitle]").textContent = !rows.length ? (c.k === "extras" ? "Nothing here yet" : "Nothing in your size") :
c.k === "extras" ? rows.length + " " + c.n.toLowerCase() :
S.fitOnly ? rows.length + " " + (c.k === "helmets" ? "helmet models" : c.n.toLowerCase()) + " in your size" :
rows.length + " " + (ONE[c.k] || c.n.toLowerCase()) + " result" + (rows.length === 1 ? "" : "s");
if (bbox) $("[data-sy-boxes]").insertAdjacentHTML("beforeend", bbox);
if (c.acc) $("[data-sy-boxes]").insertAdjacentHTML("beforeend", '<div class="sy-pills sy-accsub" role="group" aria-label="' + esc(c.n) + '">' +
[["", "All"]].concat(SUB_GROUPS[c.k] || []).filter(function (g) { return !g[0] || ITEMS.some(function (it) { return it.cat === c.k && it.ag === g[0]; }); }).map(function (g) {
return '<button type="button" class="sy-pill" data-accsub="' + g[0] + '" aria-pressed="' + ((S.accSub[c.k] || "") === g[0]) + '">' + g[1] + "</button>";
}).join("") + "</div>");
var html = "";
if (!rows.length) {
html = '<div class="sy-empty"><b>Nothing matches</b>' + (hidden.length ? "Everything that fits you is sold out in your size right now. Switch Availability to All to see it." :
S.fitOnly ? "Nothing here publishes a size that fits you. Switch Show to Everything to see the closest." : "Try widening the temperature range, or clearing a filter.") + "</div>";
} else {
html += '<div class="sy-grid">' + rows.map(card).join("") + "</div>";
}
if (cross.length) {
var other = S.gender === "Women" ? "Men's" : "Women's";
html += '<p class="sy-secthead">Also fits your measurements ' + info(other + " cut, which sits differently through the chest and hip") + "</p>" + '<div class="sy-grid">' + cross.map(card).join("") + "</div>";
}
if (hidden.length) html += '<p class="sy-soldnote"><b>' + hidden.length + "</b> more sold out in your size. " + '<button type="button" class="sy-linkbtn" data-showsold>Show them</button></p>';
out.innerHTML = html;
watchCards();
}
function prefsSet() {
return !!(S.budget || S.bikes.length || S.heights.length || S.wet || S.tempOn || S.kitColour || S.gSpots.length ||
Object.keys(S.minProt).some(function (f) { return S.minProt[f]; }));
}
function syncControls() {
placeFilters();
$$("[data-sy-showgear]").forEach(function (b) { b.textContent = prefsSet() ? "Show my gear" : "Show all gear"; });
var press = function (sel, fn) { $$(sel).forEach(function (b) { b.setAttribute("aria-pressed", String(fn(b))); }); };
press("[data-g]", function (b) { return b.getAttribute("data-g") === S.gender; });
press("[data-fit]", function (b) { return (b.getAttribute("data-fit") === "1") === S.fitOnly; });
press("[data-sold]", function (b) { return (b.getAttribute("data-sold") === "1") === S.showSold; });
if (S.stInfo == null) { try { S.stInfo = localStorage.getItem(STINFO_KEY) !== "0"; } catch (x) { S.stInfo = true; } }
rootEl.classList.toggle("no-stinfo", !S.stInfo);
press("[data-stinfo]", function (b) { return (b.getAttribute("data-stinfo") === "1") === S.stInfo; });
press("[data-b]", function (b) { var k = b.getAttribute("data-b"); return k ? S.bikes.indexOf(k) > -1 : !S.bikes.length; });
renderKitColours();
var pb = $('[data-sy-budget="pref"]');
if (pb && document.activeElement !== pb) pb.value = S.budget || "";
var ph = $("[data-sy-bhint]"), bh = budgetHintHtml();
if (ph) { ph.innerHTML = bh.replace(/<p[^>]*>/g, "<span>").replace(/<\/p>/g, "</span>"); ph.classList.toggle("is-low", bh.indexOf("is-low") > -1); }
press("[data-kc]", function (b) { return b.getAttribute("data-kc") === S.kitColour; });
press("[data-bh]", function (b) { var k = b.getAttribute("data-bh"); return k ? S.heights.indexOf(k) > -1 : !S.heights.length; });
press("[data-u]", function (b) { return b.getAttribute("data-u") === S.unit; });
press("[data-tile]", function (b) { return S.sel.indexOf(b.getAttribute("data-tile")) > -1; });
$("[data-sy-wet]").setAttribute("aria-pressed", String(S.wet));
syncTemp();
}
function syncTemp() {
var lo = $("[data-sy-tlo]"), hi = $("[data-sy-thi]");
lo.value = S.tlo; hi.value = S.thi;
$("[data-sy-tread]").textContent = S.tempOn ? degText(S.tlo, S.thi) : "Any temperature";
$("[data-sy-range]").classList.toggle("is-off", !S.tempOn);
$("[data-sy-anytemp]").setAttribute("aria-pressed", String(!S.tempOn));
var f = $("[data-sy-tfill]"); f.style.left = S.tlo / 40 * 100 + "%"; f.style.right = 100 - S.thi / 40 * 100 + "%";
}
function renderTabs() {
var cats = selCats().sort(byKit);
$("[data-sy-tabbar]").hidden = cats.length < 2;
$("[data-sy-tabs]").innerHTML = cats.map(function (c) {
return '<button type="button" class="sy-tab" role="tab" data-cat="' + c.k + '" aria-selected="' + (c.k === S.cat) + '">' + esc(c.n) +
(haveFor(c) ? "" : '<span class="sy-tabneed" title="Needs a measurement"></span>') + "</button>";
}).join("");
}
function liveMeasured() {
if (S.step === 1) renderStep1Nav();
if (S.step === 2) renderStep2();
if (S.step === 4) { renderResults(); renderSideSum(); }
$$("[data-row]").forEach(function (r) { r.classList.toggle("is-need", !hasM(r.getAttribute("data-row"))); });
renderSteps();
}
function openMeasEdit(cat) {
S.acc.meas = true; render();
var c = catDef(cat), a = c ? axesFor(c).filter(function (x) { return !hasM(x); })[0] : null;
var el = a ? $("#sy-m-" + a.replace(" ", "-")) : $(".sy-meas");
if (el) { el.scrollIntoView({ block: "center" }); el.focus(); }
}
function whyNot(it) {
var c = catDef(it.cat);
if (!c) return { text: "We don't size this kind of gear here yet." };
if (ARMOURED_CATS[it.cat] && !hasArmour(it.ip)) return { text: "No armour listed for it, so it isn't in our armoured picks." };
if (S.sel.indexOf(c.k) < 0) return { text: "It's in " + c.n + ", which you haven't picked.", add: c.k };
if (!haveFor(c)) return { text: "Add your " + listJoin(axesFor(c).filter(function (a) { return !hasM(a); }).map(function (a) { return SHORT[a]; })) + " to size it.", meas: c.k };
var out = [];
if (isCross(it)) out.push("It's a " + (S.gender === "Women" ? "men's" : "women's") + " cut, which we only show when it fits you exactly.");
if (!heightOk(it)) out.push("It's " + (it.bh === "Ankle" ? "an " : "a ") + it.bh.toLowerCase() + "-height boot, and you picked " + orJoin(S.heights.map(function (h) { return h.toLowerCase(); })) + ".");
if (!bikeOk(it)) out.push("It's made for " + listJoin(it.rs) + ", and you picked " + orJoin(bikeNames()) + ".");
if (S.wet && it.wp !== true) out.push(it.wp === false ? "It isn't waterproof." : "We haven't recorded whether it's waterproof.");
var pf = PROT_FAMILY[it.cat];
if (protOut(it)) out.push(pf === "gloves" ? "It doesn't have " + listJoin(S.gSpots.filter(function (k) { return gloveSpots(it).indexOf(k) < 0; }).map(function (k) { return k.toLowerCase(); })) + " protection." :
it.noCE ? "It's an Australian brand that isn't CE rated, and you picked " + PROT_OPT[pf][S.minProt[pf]] + "." :
it.prot && PROT_RANK[pf][it.prot] ? "It's rated " + it.prot + ", below the " + PROT_OPT[pf][S.minProt[pf]] + " you picked." : "It has no CE rating listed, and you picked " + PROT_OPT[pf][S.minProt[pf]] + ".");
if (S.tempOn && !overlapsTemp(it)) out.push("It suits " + itemBandText(it).replace(/^[A-Z]/, function (c) { return c.toLowerCase(); }) + ", outside the " + degText(S.tlo, S.thi) + " you ride in.");
var fit = fitItem(it, bodyFor(c));
if (!fit) out.push("It has no size chart we can match your measurements to.");
else {
if (S.fitOnly && (!fit.exact || fit.missing)) out.push("Your measurements fall outside its sizes, and Show is set to Fits me.");
if (!S.showSold && !fit.a) out.push("It's sold out in your size, and Availability is set to My size in stock.");
}
return { text: out.join(" "), fit: fit, ok: !out.length };
}
function renderSearch() {
var box = $("[data-sy-qres]"); if (!box) return;
var q = norm(S.q);
if (q.length < 2) { box.innerHTML = ""; return; }
var words = q.split(/\s+/);
var hits = (ALL || []).filter(function (it) {
var hay = norm(it.v + " " + it.t + " " + it.ty);
return words.every(function (w) { return hay.indexOf(w) > -1; });
}).slice(0, 8);
if (!hits.length) { box.innerHTML = '<div class="sy-qres"><p class="sy-hint">Nothing in the shop matches that. Try the brand or model name.</p></div>'; return; }
box.innerHTML = '<div class="sy-qres"><div class="sy-qhead"><span>' + hits.length + (hits.length === 8 ? "+" : "") + ' found</span><button type="button" class="sy-linkbtn" data-qclear>Clear</button></div><ul>' + hits.map(function (it) {
var w = whyNot(it), fit = w.fit, v = fit && fit.v, inKit = S.kit.indexOf(it.h) > -1;
var status = w.ok ? '<span class="sy-qok">In your results' + (fit ? " · your size " + esc(fit.label) : "") + "</span>" :
'<span class="sy-qwhy"><b>Not in your results.</b> ' + esc(w.text) + "</span>";
var acts = '<a class="sy-outline" href="' + url(it, v) + '">View' + (fit ? " · size " + esc(fit.label) : "") + "</a>" +
(w.add ? '<button type="button" class="sy-outline" data-qadd="' + w.add + '">Add ' + esc(catDef(w.add).n.toLowerCase()) + "</button>" : "") +
(w.meas ? '<button type="button" class="sy-outline" data-addmeas="' + w.meas + '">Add measurement</button>' : "") +
(fit ? '<button type="button" class="sy-outline" data-kit="' + esc(it.h) + '" aria-pressed="' + inKit + '">' + (inKit ? "✓ In your kit" : "Add to kit") + "</button>" : "");
return '<li class="sy-qrow">' + thumb(it) + '<div class="sy-qmain"><span class="sy-vend">' + esc(it.v) + '</span><span class="sy-qname">' + esc(it.t) + "</span>" + status +
'<div class="sy-qacts">' + acts + "</div></div><span class=\"sy-qprice\">" + money(it.p) + "</span></li>";
}).join("") + "</ul></div>";
}
var STINFO_KEY = "pmo.sys.stinfo";
var NAV_ATTRS = ["data-slot", "data-go", "data-cat", "data-sy-kitjump", "data-sy-shown", "data-kc-yes", "data-sy-next1", "data-sy-next2", "data-sy-next3", "data-addmeas"];
function holdPlace(e) {
var t = e.target.closest ? e.target.closest("button") : null;
if (!t || t.closest(".sy-modal") || NAV_ATTRS.some(function (a) { return t.hasAttribute(a); })) return;
var a = [].filter.call(t.attributes, function (x) { return /^data-/.test(x.name); })[0];
if (!a) return;
var sel = "button[" + a.name + '="' + String(a.value).replace(/(["\\])/g, "\\$1") + '"]', y0 = t.getBoundingClientRect().top, sy = window.pageYOffset;
requestAnimationFrame(function () {
if (Math.abs(window.pageYOffset - sy) > 2) return;
var best = null, bd = 1e9;
[].forEach.call(rootEl.querySelectorAll(sel), function (b) { if (b.closest(".sy-modal") || !b.offsetParent) return; var d = Math.abs(b.getBoundingClientRect().top - y0); if (d < bd) { bd = d; best = b; } });
if (!best && t.isConnected) best = t;
if (!best) return;
var dy = best.getBoundingClientRect().top - y0;
if (Math.abs(dy) > 1 && Math.abs(dy) < window.innerHeight) window.scrollBy(0, dy);
});
}
function wire() {
rootEl.addEventListener("click", holdPlace, true);
$("[data-sy-guide]").href = GUIDE_URL;
$("[data-sy-bh]").innerHTML = '<button type="button" class="sy-pill" data-bh="">Any</button>' + HEIGHTS.map(function (h) { return '<button type="button" class="sy-pill" data-bh="' + h + '">' + h + "</button>"; }).join("");
$("[data-sy-bike]").innerHTML = '<button type="button" class="sy-pill" data-b="">Any</button>' + BIKES.map(function (b) { return '<button type="button" class="sy-pill" data-b="' + b[0] + '">' + b[1] + "</button>"; }).join("");
rootEl.addEventListener("click", function (e) {
var t = e.target.closest ? e.target.closest("button, [data-sy-cmpmodal], [data-sy-revmodal], [data-sy-mailmodal], [data-sy-fitmodal]") : null;
if (!t || !rootEl.contains(t)) return;
var d = t.dataset;
if (t.hasAttribute("data-sy-revmodal")) { if (e.target === t) closeReviews(); return; }
if (t.hasAttribute("data-sy-mailmodal")) { if (e.target === t) closeMail(); return; }
if (t.hasAttribute("data-sy-cmpmodal")) { if (e.target === t) closeCmp(); return; }
if (t.hasAttribute("data-sy-fitmodal")) { if (e.target === t) closeFitCheck(); return; }
if (t.classList.contains("sy-mclose")) { if (t.closest("[data-sy-revmodal]")) closeReviews(); else if (t.closest("[data-sy-mailmodal]")) closeMail(); else if (t.closest("[data-sy-fitmodal]")) closeFitCheck(); else closeCmp(); return; }
if (t.hasAttribute("data-sy-fitcheck")) { openFitCheck(); return; }
if (t.hasAttribute("data-sy-kitmin")) { S.kitShut = !S.kitShut; try { localStorage.setItem(KITSHUT_KEY, S.kitShut ? "1" : "0"); } catch (x) {} renderKitSum(); return; }
if (t.hasAttribute("data-sy-stx")) { S.stretchX = true; renderKitSum(); return; }
if (t.hasAttribute("data-sy-stback")) { S.stretchX = false; renderKitSum(); return; }
if (t.hasAttribute("data-sy-stoff")) { try { localStorage.setItem(STRETCH_KEY, "1"); } catch (x) {} S.stretchX = false; renderKitSum(); return; }
if (t.hasAttribute("data-sy-kclear")) { openClearKit(); return; }
if (t.hasAttribute("data-sy-share")) { openShare("card"); return; }
if (t.hasAttribute("data-sy-idea")) { openIdea(); return; }
if (d.mode) { S.mode = d.mode === "advanced" ? "advanced" : "simple"; try { localStorage.setItem(MODE_KEY, S.mode); } catch (x) {} applyMode(); render(); return; }
if (d.preset) { applyPreset(d.preset); return; }
if (t.hasAttribute("data-sy-gift")) { openShare("gift"); return; }
if (t.hasAttribute("data-sy-shadd")) { addSharedToCart(); return; }
if (t.hasAttribute("data-sy-shx")) { S.shared.hidden = true; renderNotice(); return; }
if (t.hasAttribute("data-sy-shown")) { S.shared.hidden = true; renderNotice(); var st = $(".sy-stepper") || $("[data-sy-out]"); if (st) window.scrollTo({ top: Math.max(0, st.getBoundingClientRect().top + window.pageYOffset - 90), behavior: "smooth" }); return; }
if (t.hasAttribute("data-sy-notex")) { S.addNote = null; renderNotice(); return; }
if (d.fitnext) { S.fitIdx[d.fitnext] = (S.fitIdx[d.fitnext] || 0) + 1; openFitCheck(); return; }
if (d.fitprev) { var fl = fitCount(d.fitprev); S.fitIdx[d.fitprev] = ((S.fitIdx[d.fitprev] || 0) - 1 + fl) % fl; openFitCheck(); return; }
if (d.fcnames != null) { S.fcHide = d.fcnames === "0"; openFitCheck(); return; }
if (d.reviews) { openReviews(d.reviews); return; }
if (d.go) { goStep(+d.go); return; }
if (d.tile) {
var i = S.sel.indexOf(d.tile);
if (i > -1) { if (S.step !== 4 || S.sel.length > 1) S.sel.splice(i, 1); }
else { S.sel.push(d.tile); S.sel = CATS.map(function (c) { return c.k; }).filter(function (k) { return S.sel.indexOf(k) > -1; }); if (S.step === 4) S.cat = d.tile; }
saveSel(); render(); return;
}
if (t.hasAttribute("data-sy-selall")) { S.sel = S.sel.length === CATS.length ? [] : CATS.map(function (c) { return c.k; }); saveSel(); render(); return; }
if (t.hasAttribute("data-sy-next1")) { ping("measured"); goStep(4); return; }
if (t.hasAttribute("data-sy-next2")) { goStep(3); return; }
if (t.hasAttribute("data-sy-ownopen")) { S.ownOpen = !S.ownOpen; renderStep2(); return; }
if (d.accToggle) { S.acc[d.accToggle] = !S.acc[d.accToggle]; renderDetails(); return; }
if (t.hasAttribute("data-sy-mailopen")) { openMail(); return; }
if (d.qadd) { if (S.sel.indexOf(d.qadd) < 0) { S.sel.push(d.qadd); S.sel = CATS.map(function (c) { return c.k; }).filter(function (k) { return S.sel.indexOf(k) > -1; }); saveSel(); } S.cat = d.qadd; render(); return; }
if (t.hasAttribute("data-qclear")) { S.q = ""; $("[data-sy-q]").value = ""; renderSearch(); return; }
if (d.addmeas) { openMeasEdit(d.addmeas); return; }
if (d.g != null && t.closest("[data-sy-gender]")) { S.gender = d.g; saveRider(); render(); return; }
if (d.fit) { S.fitOnly = d.fit === "1"; render(); return; }
if (d.sold) { S.showSold = d.sold === "1"; render(); return; }
if (d.stinfo) { S.stInfo = d.stinfo === "1"; try { localStorage.setItem(STINFO_KEY, S.stInfo ? "1" : "0"); } catch (x) {} syncControls(); return; }
if (d.kc != null && t.closest("[data-sy-kc]")) { S.kitColour = d.kc; render(); return; }
if (d.slot) {
S.cat = d.slot; render();
var rb = $(".sy-resbar"); if (rb) rb.scrollIntoView({ behavior: "smooth", block: "start" });
return;
}
if (t.hasAttribute("data-sy-fill")) { fillKit(); render(); return; }
if (t.hasAttribute("data-sy-nofill")) { S.prefill = "no"; renderKit(); return; }
if (d.cwmore) { S.cwOpen[d.cwmore] = 1; renderResults(); return; }
if (d.cw) { var ci = d.cw.lastIndexOf("|"); S.colPick[d.cw.slice(0, ci)] = d.cw.slice(ci + 1); renderResults(); return; }
if (t.hasAttribute("data-sy-kitjump")) { var ks = $("[data-sy-kitsum]"); if (ks) ks.scrollIntoView({ behavior: "smooth", block: "start" }); return; }
if (d.bh != null && t.closest("[data-sy-bh]")) {
if (!d.bh) S.heights = [];
else { var hi2 = S.heights.indexOf(d.bh); if (hi2 > -1) S.heights.splice(hi2, 1); else S.heights.push(d.bh); }
render(); return;
}
if (d.b != null && t.closest("[data-sy-bike]")) {
if (!d.b) S.bikes = [];
else { var bi = S.bikes.indexOf(d.b); if (bi > -1) S.bikes.splice(bi, 1); else S.bikes.push(d.b); }
render(); return;
}
if (t.hasAttribute("data-sy-wet")) { S.wet = !S.wet; render(); return; }
if (d.setbudget) { S.budget = +d.setbudget; S.cartMsg = null; render(); return; }
if (d.gspot != null) {
if (!d.gspot) S.gSpots = []; else { var gi = S.gSpots.indexOf(d.gspot); if (gi > -1) S.gSpots.splice(gi, 1); else S.gSpots.push(d.gspot); }
render(); return;
}
if (d.prot) { var pp = d.prot.split(":"); S.minProt[pp[0]] = +pp[1]; render(); return; }
if (t.hasAttribute("data-sy-anytemp")) { S.tempOn = !S.tempOn; saveRider(); render(); return; }
if (d.u) { S.unit = d.u; measKey = null; render(); return; }
if (d.cat) { S.cat = d.cat; S.ownPick = null; render(); return; }
if (d.gotab) { S.cat = d.gotab; S.ownPick = null; render(); return; }
if (d.own) { S.ownMode = d.own; S.ownPick = null; renderOwn(); if (S.ownMode === "search") $("[data-sy-ownq]").focus(); return; }
if (d.ownpick && d.ownvid) { applyOwned(d.ownpick, d.ownvid); return; }
if (d.ownpick) { S.ownPick = d.ownpick; renderOwnSearch(); renderOwnPick(); return; }
if (d.ownsize && S.ownPick) {
var it = findItem(S.ownPick), v = it && it.vars.filter(function (x) { return String(x.o[it.sizeIdx]) === d.ownsize; })[0];
if (v) applyOwned(it.h, v.id);
return;
}
if (t.hasAttribute("data-clearref")) { clearRef(); return; }
if (d.unref) { dropRef(d.unref); return; }
if (t.hasAttribute("data-showsold")) { S.showSold = true; render(); return; }
if (d.cmp) { var l = cmpList(), j0 = l.indexOf(d.cmp); S.cmpUndo = null; if (j0 > -1) { var rn = findItem(d.cmp); cmpSnap("Removed " + (rn ? rn.t : "it") + "."); l.splice(j0, 1); } else if (l.length < 3) l.push(d.cmp); render(); return; }
if (d.uncmp) { var l2 = cmpList(), j = l2.indexOf(d.uncmp), un = findItem(d.uncmp); cmpSnap("Removed " + (un ? un.t : "it") + "."); if (j > -1) l2.splice(j, 1); render(); if (!$("[data-sy-cmpmodal]").hidden) { if (l2.length < 2) closeCmp(); else openCmp(); } return; }
if (t.hasAttribute("data-cmpclear")) { cmpSnap("Cleared your comparison."); S.cmp[S.cat] = []; render(); return; }
if (t.hasAttribute("data-cmpundo")) { var cu = S.cmpUndo; if (cu) { S.cmp[cu.cat] = cu.list; S.cmpUndo = null; render(); if (cu.open && cu.list.length >= 2) openCmp(); else if (!$("[data-sy-cmpmodal]").hidden) openCmp(); } return; }
if (t.hasAttribute("data-cmpgo")) { openCmp(); return; }
if (d.vpick) {
var vp = d.vpick.split("|"), vk = vp[0] + "|" + vp[1], vc = vp.slice(2).join("|");
var was = (S.vpick || {})[vk] === vc; S.vpick = {}; if (!was) S.vpick[vk] = vc;
refreshCmp(); return;
}
if (d.vadd) {
var va = d.vadd.split("|"), vcol = (S.vpick || {})[d.vadd], vhel = findItem(va[0]);
if (vcol) {
S.colSel[va[1]] = vcol; delete S.sizeSel[va[1]];
if (S.kit.indexOf(va[1]) < 0) { S.kit.push(va[1]); ping("extra"); }
autoVisorSize(va[1], vhel);
S.cartMsg = null; render(); refreshCmp();
}
return;
}
if (d.kit) { var ki = S.kit.indexOf(d.kit); if (ki > -1) S.kit.splice(ki, 1); else { S.kit.push(d.kit); autoVisorSize(d.kit); if (d.kextra) ping("extra"); } S.cartMsg = null; render(); if (t.closest("[data-sy-cmpmodal]")) openCmp(); return; }
if (d.swap) { swapIn(d.swap); render(); if (t.closest("[data-sy-cmpmodal]")) openCmp(); return; }
if (d.accsub != null && t.closest(".sy-accsub")) { S.accSub[S.cat] = d.accsub; renderResults(); return; }
if (d.swc != null && d.col != null) { S.colSel[d.swc] = d.col; S.cartMsg = null; render(); return; }
if (d.swmore) { S.swOpen[d.swmore] = 1; renderResults(); return; }
if (d.cmpboth) { var ca = findItem(d.cmpboth); if (ca) { S.cat = ca.cat; S.cmp[ca.cat] = [d.cmpboth, d.cmpwith]; render(); openCmp(); } return; }
if (d.unkit) { var ku = S.kit.indexOf(d.unkit); if (ku > -1) S.kit.splice(ku, 1); S.cartMsg = null; render(); return; }
if (t.hasAttribute("data-sy-kitcart")) { addKitToCart(); return; }
if (t.hasAttribute("data-sy-opencart")) { openCartDrawer(); return; }
if (t.hasAttribute("data-resend")) { submitFit(S.email, S.who, false); return; }
if (t.hasAttribute("data-changemail")) { S.emailDraft = S.email; S.email = ""; renderMail(); return; }
if (t.hasAttribute("data-sy-reset")) {
profile.meas = {}; S.gender = ""; S.bikes = []; S.heights = []; S.wet = false; S.tempOn = false; S.tlo = 10; S.thi = 28; S.minProt = {}; S.auProt = {}; S.gSpots = []; S.kit = []; S.cartMsg = null; S.cmp = {}; S.kitColour = ""; S.budget = null; S.prefill = ""; S.colPick = {}; S.colSel = {}; S.sizeSel = {};
S.refFrom = {}; S.ref = null; S.refs = []; S.fitOnly = true; S.showSold = false; S.welcome = false; measKey = null;
S.sel = []; S.acc = {}; S.ownOpen = false; S.email = ""; S.q = ""; closeMail();
saveSel(); saveRider(); goStep(1); return;
}
});
rootEl.addEventListener("submit", function (e) {
var f = e.target;
if (f.hasAttribute("data-sy-mailform")) {
e.preventDefault();
var email = f.querySelector("[name=email]").value.trim(); if (!email) return;
var who = { first: String((f.querySelector("[name=first]") || {}).value || "").trim(), last: String((f.querySelector("[name=last]") || {}).value || "").trim() };
S.mkt = !!($("[data-sy-mkt]") || {}).checked;
submitFit(email, who, S.mkt); return;
}
if (f.hasAttribute("data-wait")) {
e.preventDefault();
var vid = f.getAttribute("data-wait"), em = f.querySelector("input").value.trim();
if (!em) return;
fetch("/apps/peakmoto/waitlist", { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json" }, body: JSON.stringify({ variant: vid, email: em }) }).catch(function () {});
S.wait[vid] = em; render();
}
});
rootEl.addEventListener("input", function (e) {
var el = e.target;
if (el.classList.contains("sy-meas")) {
var a = el.getAttribute("data-ax"), n = parseFloat(String(el.value).replace(",", "."));
if (isNaN(n)) delete profile.meas[a]; else profile.meas[a] = Math.round(toCm(n) * 10) / 10;
$$('.sy-meas[data-ax="' + a + '"]').forEach(function (o) { if (o !== el) o.value = el.value; });
if (!isNaN(n) && el.getAttribute("data-tcat")) { selectCat(el.getAttribute("data-tcat")); renderStep1Nav(); }
if (S.refFrom[a]) { delete S.refFrom[a]; var fr = $('[data-sy-from="' + a + '"]'); if (fr) fr.remove(); }
S.welcome = false; saveRider();
clearTimeout(rootEl._t); rootEl._t = setTimeout(liveMeasured, 200);
return;
}
if (el.hasAttribute("data-sy-tlo") || el.hasAttribute("data-sy-thi")) {
var lo = +$("[data-sy-tlo]").value, hi = +$("[data-sy-thi]").value;
if (lo > hi) { if (el.hasAttribute("data-sy-tlo")) hi = lo; else lo = hi; }
S.tempOn = true; S.tlo = lo; S.thi = hi; syncTemp();
clearTimeout(rootEl._tt); rootEl._tt = setTimeout(function () { saveRider(); if (S.step === 4) { renderResults(); } else render(); }, 150);
return;
}
if (el.hasAttribute("data-sy-budget")) {
var bn = parseInt(String(el.value).replace(/[^\d]/g, ""), 10), which = el.getAttribute("data-sy-budget");
S.budget = bn > 0 ? bn : null;
clearTimeout(rootEl._bt); rootEl._bt = setTimeout(function () {
var pos = el.selectionStart; render();
var nb = $('[data-sy-budget="' + which + '"]'); if (nb) { nb.focus(); try { nb.setSelectionRange(pos, pos); } catch (x) {} }
}, 400);
return;
}
if (el.hasAttribute("data-sy-q")) { S.q = el.value; clearTimeout(rootEl._qt); rootEl._qt = setTimeout(renderSearch, 120); return; }
if (el.closest("[data-sy-mailform]")) { if (el.name === "email") S.emailDraft = el.value; if (el.name === "first") S.firstDraft = el.value; if (el.name === "last") S.lastDraft = el.value; }
});
rootEl.addEventListener("change", function (e) {
if (e.target.hasAttribute("data-sizesel")) {
var sh = e.target.getAttribute("data-sizesel"), si = findItem(sh), sf = si && kitFit(si) || null;
if (!e.target.value || (sf && !sf.nofit && e.target.value === sf.sugLabel)) delete S.sizeSel[sh]; else S.sizeSel[sh] = e.target.value;
S.cartMsg = null; render(); return;
}
if (e.target.hasAttribute("data-sy-hidesame")) { S.hideSame = e.target.checked; $(".sy-cmpwrap").classList.toggle("is-hidesame", S.hideSame); }
if (e.target.hasAttribute("data-sy-mkt")) S.mkt = e.target.checked;
if (e.target.hasAttribute("data-sy-auprot")) { S.auProt[e.target.getAttribute("data-sy-auprot")] = e.target.checked; render(); }
});
rootEl.addEventListener("focusin", function (e) { if (e.target.classList.contains("sy-meas")) focusAxis(e.target.getAttribute("data-ax")); });
rootEl.addEventListener("focusout", function (e) { if (e.target.classList.contains("sy-meas")) setTimeout(function () { if (!rootEl.contains(document.activeElement) || !document.activeElement.classList.contains("sy-meas")) hideTip(); }, 0); });
document.addEventListener("keydown", function (e) {
if (e.key !== "Escape") return;
if (!$("[data-sy-revmodal]").hidden) closeReviews(); else if (!$("[data-sy-mailmodal]").hidden) closeMail(); else if ($("[data-sy-fitmodal]") && !$("[data-sy-fitmodal]").hidden) closeFitCheck(); else if (!$("[data-sy-cmpmodal]").hidden) closeCmp();
});
}
function syncLock() {
var open = $$(".sy-modal").some(function (m) { return !m.hidden; });
document.documentElement.classList.toggle("sy-lock", open);
}
function start() {
if ("MutationObserver" in window) $$(".sy-modal").forEach(function (m) { new MutationObserver(syncLock).observe(m, { attributes: true, attributeFilter: ["hidden"] }); });
F = window.PmoFit;
profile = F.loadProfile();
if (profile.gen && profile.gen.length === 1) S.gender = profile.gen[0];
if (profile.temp && profile.temp.on) { S.tempOn = true; S.tlo = profile.temp.lo; S.thi = profile.temp.hi; }
S.sel = loadSel();
readFitLink();
wire();
betaNote();
syncControls();
loadData().then(function () {
var keys = CATS.map(function (c) { return c.k; });
S.sel = S.sel.filter(function (k) { return keys.indexOf(k) > -1; });
if (!S.sel.length && Object.keys(body()).length) S.sel = CATS.filter(function (c) { return !c.acc && haveFor(c); }).map(function (c) { return c.k; });
if (S.sel.length) S.cat = S.sel.filter(function (k) { return haveFor(catDef(k)); })[0] || S.sel[0];
loadKit();
applyLinks();
initMode();
S.step = measured() ? 4 : 1;
if (S.step === 4 && S.kit.length) ping("returned");
$("[data-sy-boot]").hidden = true;
S.acc.meas = !!(window.matchMedia && window.matchMedia("(min-width: 961px)").matches);
ping("start");
render();
resumeAfterPhoto();
}).catch(function () {
$("[data-sy-boot]").innerHTML = '<span class="sy-empty" style="display:block"><b>We couldn\'t load the gear just now.</b>Refresh the page to try again.</span>';
});
}
(function boot(n) {
if (window.PmoFit && window.PmoSizeCalc) start();
else if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(0); }, { once: true });
else if (n < 100) setTimeout(function () { boot(n + 1); }, 50);
})(0);
})();
